<template>
  <div class="quoteReport">
    <div v-if="filterDrawer == true" style="z-index: 2; opacity: 0.8; background: #000; width: 100%; height: 100%; position: absolute; left: 0; top: 42px;"></div>
    <v-navigation-drawer v-model="filterDrawer" right absolute light width="1000" class="rightDrawer">
      <v-container ref="filterReload" v-if="filterNeedsReload == true">
        <v-layout row wrap>
          <v-flex lg12>
            <h2 style="padding-top: 10%;"><center>Loading Filters<br /><span style="font-size: 12px;">Please Wait</span></center></h2>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container ref="filterShow" v-if="filterNeedsReload == false">
        <v-layout row wrap style="overflow: hidden !important;">
          <v-flex lg11>
            <h2>FILTER YOUR REPORT</h2>
          </v-flex>
          <v-flex lg1>
            <a @click.prevent="fncCloseDrawer">Cancel</a>
          </v-flex>
          <v-flex lg12>
            <!--<v-btn class="regenReport" :disabled="regenFalse" @click="fncSearchNewQuotes()">REGENERATE REPORT</v-btn>-->
            <v-btn class="regenReport" @click="fncSearchNewQuotes(false,false,false)">REGENERATE REPORT</v-btn>
            <v-btn class="clearfilters" style="float:left !important;" @click="fncClearFilter()">CLEAR ALL FILTERS</v-btn>
            <v-btn class="clearregen" style="float:left !important;" @click="fncSearchClearNewQuotes()">CLEAR & REGENERATE</v-btn>
            <!--<v-btn @click="fncHideFilter()">CLOSE FILTERS</v-btn>-->
          </v-flex>
          <v-flex lg12>
            <small style="display: block; margin-top: 2px;font-weight: bold;" v-if="search != ''">You currently have search text which could affect your filters.</small>
            <br /><h3 style="margin-bottom: 10px;">DATE</h3>
          </v-flex>
          <v-flex lg12 class="dates">
            <date-picker id="dashDateRep" valueType="format" class="quoteDateRep dashDateRep" v-model="reportDate[0]" placeholder="Start Date" format="YYYY-MM-DD" lang="en"></date-picker>
            <span v-if="quoteReportLoaded == true && quotesLoaded == true" class="toRep">to</span>
            <date-picker id="dashDateRep"  valueType="format" class="quoteDateRep dashDateRep" v-model="reportDate[1]" placeholder="End Date" format="YYYY-MM-DD" lang="en"></date-picker>
            <v-btn @click="fncSetDateEmpty" style="margin-top: 1px;" color="info">GO</v-btn>
          </v-flex>
          <v-flex lg12 class="or">
            <small>OR</small>
          </v-flex>
          <v-flex lg12>
            <v-select v-if="quoteFilter != 99 && quoteFilter > 0" class="dropdown dashDroprep" v-model="quoteFilter" style="width:14%;margin-top: -18px;" :items="dateOptions" @input="fncChangeQuotes('nonchange')" item-value="id" item-text="name" autocomplete solo single-line></v-select>
            <v-select v-else class="dropdown dashDroprep" v-model="quoteFilter" style="width:14%;margin-top: -18px;" :label="fncFilterLabel()" :items="dateOptions" @input="fncChangeQuotes('nonchange')" item-value="id" item-text="name" autocomplete solo single-line></v-select>
          </v-flex>
          <v-flex lg12 class="additional">
            <h3>OTHER</h3><br />
          </v-flex>
          <v-flex lg3 v-if="objAuthorize.manufacturer == '385889803'" style="position:relative">
            <label class="mTop"><b>Vendor</b></label>
            <a class="filterDone" @click="fncReloadFilters()" v-if="fncCheckDone('vendor')">Done</a>
            <v-select ref="vendorSelect" @blur="fncCheckChange('vendor')" class="shortSelect" v-model="objVendor" :items="fncSetFilters('vendor')" item-text="name" item-value="id" autocomplete multiple @input="fncCheckDropdowns('vendor')"></v-select>
          </v-flex>
          <v-flex lg3 v-if="objAuthorize.manufacturer == '385889803'" style="position:relative">
            <label class="mTop"><b>Store</b></label>
            <a class="filterDone" @click="fncReloadFilters()" v-if="fncCheckDone('store')">Done</a>
            <v-select ref="storeSelect" @blur="fncCheckChange('store')" class="shortSelect" v-model="objStore" :items="fncSetFilters('store')" item-text="name" item-value="id" autocomplete multiple @input="fncCheckDropdowns('store')"></v-select>
          </v-flex>
          <v-flex lg3 style="position:relative">
            <label class="mTop"><b>Originator</b></label>
            <a class="filterDone" @click="fncReloadFilters()" v-if="fncCheckDone('originator')">Done</a>
            <v-select ref="originatorSelect" @blur="fncCheckChange('originator')" class="shortSelect" v-model="objOriginator" :items="fncSetFilters('originator')" item-text="name" item-value="id" multiple autocomplete @input="fncCheckDropdowns('originator')"></v-select>
          </v-flex>
          <v-flex lg3 style="position:relative">
            <label class="mTop"><b>Customer</b></label>
            <a class="filterDone" @click="fncReloadFilters()" v-if="fncCheckDone('customer')">Done</a>
            <v-select ref="customerSelect" @blur="fncCheckChange('customer')" class="shortSelect" v-model="objCustomerUser" :items="fncSetFilters('customer')" item-text="name" item-value="id" multiple autocomplete @input="fncCheckDropdowns('customer')"></v-select>
          </v-flex>
          <v-flex lg3 style="position:relative">
            <label class="mTop"><b>Status</b></label>
            <a class="filterDone" @click="fncReloadFilters()" v-if="fncCheckDone('status')">Done</a>
            <v-select ref="statusSelect" @blur="fncCheckChange('status')" class="shortSelect" v-model="objStatus" :items="fncSetFilters('status')" item-text="name" item-value="id" multiple autocomplete @input="fncCheckDropdowns('status')"></v-select>
          </v-flex>
          <v-flex lg3 v-if="objAuthorize.manufacturer == '385889803'" style="position:relative">
            <label class="mTop"><b>Departments</b></label>
            <a class="filterDone" @click="fncReloadFilters()" v-if="fncCheckDone('department')">Done</a>
            <v-select ref="departmentSelect" class="shortSelect" @blur="fncCheckChange('department')" v-model="objDepartment" :items="fncSetFilters('department')" item-text="name" item-value="id" multiple autocomplete @input="fncCheckDropdowns('department')"></v-select>
          </v-flex>
          <v-flex lg3 v-if="objAuthorize.manufacturer == '385889803'" style="position:relative">
            <label class="mTop"><b>KAM Region</b></label>
            <a class="filterDone" @click="fncReloadFilters()" v-if="fncCheckDone('region')">Done</a>
            <v-select ref="regionSelect" class="shortSelect" @blur="fncCheckChange('region')" v-model="objRegion" :items="fncSetFilters('region')" item-text="name" item-value="id" multiple autocomplete @input="fncCheckDropdowns('region')"></v-select>
          </v-flex>
          <v-flex lg3 v-if="objAuthorize.manufacturer == '385889803'" style="position:relative">
            <label class="mTop"><b>Responsible Rep</b></label>
            <a class="filterDone" @click="fncReloadFilters()" v-if="fncCheckDone('rep')">Done</a>
            <v-select ref="repSelect" class="shortSelect" @blur="fncCheckChange('rep')" v-model="objRep" :items="fncSetFilters('rep')" item-text="name" item-value="id" multiple autocomplete @input="fncCheckDropdowns('rep')"></v-select>
          </v-flex>
          <!--<v-flex lg3 v-if="objAuthorize.manufacturer == '385889803'" style="position:relative">
            <label class="mTop"><b>Commercial Kam</b></label>
            <a class="filterDone" @click="fncReloadFilters()" v-if="fncCheckDone('kam')">Done</a>
            <v-select ref="kamSelect" class="shortSelect" @blur="fncCheckChange('kam')" v-model="objKam" :items="fncSetFilters('kam')" item-text="name" item-value="id" multiple autocomplete @input="fncCheckDropdowns('kam')"></v-select>
          </v-flex>
          <v-flex lg3 v-if="objAuthorize.manufacturer == '385889803'" style="position:relative">
            <label class="mTop"><b>Commercial Co-Ordinator</b></label>
            <a class="filterDone" @click="fncReloadFilters()" v-if="fncCheckDone('cOriginator')">Done</a>
            <v-select ref="cOriginatorSelect" class="shortSelect" @blur="fncCheckChange('cOriginator')" v-model="objcOriginator" :items="fncSetFilters('cOriginator')" item-text="name" item-value="id" multiple autocomplete @input="fncCheckDropdowns('cOriginator')"></v-select>
          </v-flex>-->
          <v-flex lg3 v-if="objAuthorize.manufacturer == '385889803'" style="position:relative">
            <label class="mTop"><b>Quote Type</b></label>
            <a class="filterDone" @click="fncReloadFilters()" v-if="fncCheckDone('quote_type')">Done</a>
            <v-select ref="quoteTypeSelect" class="shortSelect" @blur="fncCheckChange('quote_type')" v-model="objQuoteType" :items="fncSetFilters('quote_type')" item-text="name" item-value="id" multiple autocomplete @input="fncCheckDropdowns('quote_type')"></v-select>
          </v-flex>
          <v-flex lg3 v-if="objAuthorize.manufacturer == '385889803'" style="position:relative">
            <label class="mTop"><b>Service Type</b></label>
            <a class="filterDone" @click="fncReloadFilters()" v-if="fncCheckDone('service_type')">Done</a>
            <v-select ref="serviceTypeSelect" class="shortSelect" @blur="fncCheckChange('service_type')" v-model="objServiceType" :items="fncSetFilters('service_type')" item-text="name" item-value="id" multiple autocomplete @input="fncCheckDropdowns('service_type')"></v-select>
          </v-flex>
          <v-flex lg3 v-if="objAuthorize.manufacturer == '385889803'" style="position:relative">
            <label class="mTop"><b>Projects</b></label>
            <a class="filterDone" @click="fncReloadFilters()" v-if="fncCheckDone('projects')">Done</a>
            <v-select ref="projectsSelect" class="shortSelect" @blur="fncCheckChange('projects')" v-model="objProjects" :items="fncSetFilters('projects')" item-text="name" item-value="id" multiple autocomplete @input="fncCheckDropdowns('projects')"></v-select>
          </v-flex>
          <v-flex lg3 v-if="objAuthorize.manufacturer == '385889803'" style="position:relative">
            <label class="mTop"><b>Company</b></label>
            <a class="filterDone" @click="fncReloadFilters()" v-if="fncCheckDone('company')">Done</a>
            <v-select ref="companySelect" class="shortSelect" @blur="fncCheckChange('company')" v-model="objCompany" :items="fncSetFilters('company')" item-text="name" item-value="id" multiple autocomplete @input="fncCheckDropdowns('company')"></v-select>
          </v-flex>
        </v-layout>
      </v-container>
    </v-navigation-drawer>
    <v-content style="padding: 0 !important">
      <v-container fluid>
        <center v-if="quotesLoaded == false || editLoading == true"><img class="imgLoader" src="../../shared/assets/images/3dloader.gif"  /></center>
        <v-layout row wrap daterow v-if="quoteReportLoaded == true && quotesLoaded == true && editLoading == false">
          <v-flex xs3 searchpanel style="position: relative;">
            <!--<v-text-field v-if="quoteReportLoaded == true && quotesLoaded == true && editLoading == false" ref="searchField" @focus="fncClearFilterShadows" @input="fncCustomReportSearch('search')" append-icon="search" :label="fncSearchLabel()" style="display: block; float:left;margin-right:0px;" id="quoteSearch" solo single-line v-model="search"></v-text-field>-->
            <v-text-field v-show="quoteReportLoaded == true && quotesLoaded == true && editLoading == false" ref="searchQuoteField"  append-icon="search" :disabled="EnableSearchQuote " :label="fncQuoteSearchLabel()"  @input="CheckEditable" style="display: block; float:left;margin-right:0px;width: 380px" id="quoteSearch" :value="searchQuoteReport" solo single-line class="quoteNumberSearchPanel"></v-text-field>
            <!--<span v-if="objAuthorize.privileges.indexOf('SEARCH_QUOTE_NO') != -1 && quoteReportLoaded == true && quotesLoaded == true" class="toRep"><strong>OR</strong></span>-->
            <v-text-field v-show="1 == 2 && quoteReportLoaded == true && quotesLoaded == true && editLoading == false" ref="searchField" :disabled="EnableSearch" append-icon="search" :label="fncSearchLabel()" @input="CheckEditableSearch" style="display: block; float:left;margin-right:0px;width: 225px" id="quoteSearch" :value="search" solo single-line class="quoteSearchPanel"></v-text-field>

            <v-btn v-if="nonClickable == true && quoteReportLoaded == true && quotesLoaded == true && editLoading == false" class="dashGenerateRep qtGenerate" @click="fncSearchNewQuotes()" style="background: #333 !important; color: #fff !important;position: absolute;height: 35px; margin-top: 3px; display: block; right: 10px;">SEARCH</v-btn>
            <v-btn v-if="quoteReportLoaded == true && quotesLoaded == true && editLoading == false" class="dashGenerateRep qtGenerate" @click="fncClearSearchTop()" style="background: #333 !important; color: #fff !important;position: absolute; margin-top: 3px; display: block; right: 73px;height: 35px;">CLEAR</v-btn>
            <!--<v-btn v-if="fncCanClear() && nonClickable == true && quoteReportLoaded == true && quotesLoaded == true && editLoading == false" class="dashGenerateRep qtGenerate" @click="fncClearSearchTop()" style="background: #333 !important; color: #fff !important;height: 30px;position: absolute; top: -1px; display: block; right: 72px;">CLEAR</v-btn>-->
          </v-flex>
          <v-flex xs6 filterresetbtns >
            <v-btn v-if="quotesLoaded == true && filterDrawer == true" @click.prevent="fncCloseDrawer" class="elevation-5" style="display: block; float:left; margin-top: 1px; height: 39px; " color="info"><i class="material-icons">filter_alt</i>Hide Filters</v-btn>
            <v-btn v-if="filterNeedsReload == false &&  objAuthorize.type != '6' && quotesLoaded == true && filterDrawer == false" @click.prevent="fncShowFilterSlide()" class="elevation-5" style="display: block; float:left; margin-top: 1px; height: 39px;" color="info"><i class="material-icons">filter_alt</i>Filters</v-btn>
            <v-btn v-if="filterNeedsReload == false &&  quotesLoaded == true && filterDrawer == false" @click.prevent="fncSearchClearNewQuotes()" class="elevation-5" style="display: block; float:left; margin-top: 1px; height: 39px;" color="info"><i class="material-icons">close</i>Clear Filters</v-btn>
            <v-btn v-if="filterNeedsReload == true && objAuthorize.type != '6' && quotesLoaded == true && filterDrawer == false" @click.prevent="fncShowFilterSlide()" class="elevation-5" style="display: block; float:left; margin-top: 1px; height: 39px;" color="info" disabled="true"><i class="material-icons">filter_alt</i>Loading Filters</v-btn>
            <v-btn v-if="quoteReportLoaded == true && quotesLoaded == true && quotesLinked == true" @click.prevent="fncHideLinkedQuotes()" class="elevation-5" style="display: block; float:left;height: 39px;margin-top:1px;" color="info">Hide Linked Quotes</v-btn>
            <v-btn @click.prevent="fncSearchNewQuotes" style="margin-top: 1px; height: 39px;" class="elevation-5" color="info reloadButton"><i class="material-icons">refresh</i></v-btn>
          </v-flex>
          <v-flex xs6 datefilters>
            <!--<span style="font-size:12px; padding-top: 10px; float: left; width: 80px"><strong>Date Range:</strong></span>-->
            <date-picker @mousedown="fncClearFilterShadows" id="dashDateRep" valueType="format" class="quoteDateRep dashDateRep" @change="dateChange" v-model="reportDate[0]" placeholder="Start Date" format="YYYY-MM-DD" lang="en" ></date-picker>
            <span v-if="quoteReportLoaded == true && quotesLoaded == true" class="toRep"><strong>to</strong></span>
            <date-picker @mousedown="fncClearFilterShadows" id="dashDateRep" valueType="format" class="quoteDateRep dashDateRep" @change="dateChange" v-model="reportDate[1]" placeholder="End Date" format="YYYY-MM-DD" lang="en"></date-picker>
            <v-btn color="info" style="display: block; float: left; margin-top: 1px;" :disabled="checGoButton" @click="fncSearchNewQuotes(true)">GO</v-btn>
            <span v-if="quoteReportLoaded == true && quotesLoaded == true" class="toRep"><strong>OR</strong></span>
            <v-select class="dropdown dashDroprep" @change="fncOnrangeChange()" @mousedown="fncClearFilterShadows" v-model="quoteFilter" style="width:145px;" :label="fncFilterLabel()" :items="dateOptions" @input="fncChangeQuotes(false, true)" item-value="id" item-text="name" autocomplete solo single-line></v-select>
          </v-flex>

<!--          <v-flex xs2 class="text-xs-right" >-->
<!--            <v-btn small  @click.prevent="fncSearchNewQuotes" style="margin-top: 1px; height: 39px; font-size: 9px !important;" class="elevation-5" color="info reloadButton"><i class="material-icons">refresh</i></v-btn>-->
<!--            &lt;!&ndash;            <v-btn  style="position: relative;height: 39px;margin-top: 1px !important;font-size: 9px !important;" @click.prevent="fncCreateLead()" class="elevation-5 mt-2" color="info"><i class="material-icons">person_pin</i>CREATE NEW LEAD</v-btn>&ndash;&gt;-->
<!--            &lt;!&ndash;            v-if="quotesLoaded == true && (headers.length > 2 || quoteSearchList.length > 0) && topTab === '0'"&ndash;&gt;-->
<!--            <div class="pl-3 mr-3" style="border-right: 1px solid rgba(0, 0, 0, 0.12) !important; height: 40px !important;display: inline">-->
<!--            </div>-->
<!--            <v-toolbar-side-icon  color="white"  @click.stop="drawer = !drawer"></v-toolbar-side-icon>-->
<!--            <v-navigation-drawer hide-overlay style="padding: 0px !important;right: 10px !important;width: auto !important;height: auto !important;margin-top: 97px !important;" absolute bottom right temporary v-model="drawer" >-->
<!--              <v-list >-->
<!--                <div class="" >-->
<!--                  <v-list-tile  v-if="quotesLoaded == true && (headers.length > 2 || quoteSearchList.length > 0)" >-->
<!--                    <v-list-tile-content>-->
<!--                      <v-list-tile-title  @click.prevent="fncShowColumns" style="cursor: pointer;">Manage Columns</v-list-tile-title>-->
<!--                    </v-list-tile-content>-->
<!--                  </v-list-tile>-->
<!--                  <v-list-tile v-if="quotesLoaded == true && objAuthorize.privileges.indexOf('CAN_SUMMARY_REPORTING') != -1">-->
<!--                    <v-list-tile-content>-->
<!--                      <v-list-tile-title  @click.prevent="fncShowSummaryReporting" style="cursor: pointer;">Summary Reporting</v-list-tile-title>-->
<!--                    </v-list-tile-content>-->
<!--                  </v-list-tile>-->
<!--                  <v-list-tile v-if="quotesLoaded == true && objAuthorize.privileges.indexOf('CAN_SUMMARY_REPORTING') != -1">-->
<!--                    <v-list-tile-content v-if="objAuthorize.privileges.indexOf('CAN_SUMMARY_REPORTING') != -1">-->
<!--                      <v-list-tile-title  @click.prevent="fncGetStatusCount" style="cursor: pointer;">Summary By Status</v-list-tile-title>-->
<!--                    </v-list-tile-content>-->
<!--                  </v-list-tile>-->
<!--                  <v-list-tile v-show="quotesLoaded == true && excelLoading == false">-->
<!--                    <v-list-tile-content>-->
<!--                      <v-list-tile-title @click.prevent="fncExportQuotes"  style="cursor: pointer;">Export to Excel</v-list-tile-title>-->
<!--                    </v-list-tile-content>-->
<!--                  </v-list-tile>-->
<!--                </div>-->
<!--              </v-list>-->
<!--            </v-navigation-drawer>-->
<!--            <v-progress-circular v-show="excelLoading == true" style="display: block; float: left !important;margin-left: 50% !important; margin-top: 12px;" indeterminate :width="3" :size="20" color="grey" class="pt-3 loginLoader"></v-progress-circular>-->
<!--          </v-flex>-->
        </v-layout>
     <!--<v-flex xs12 style="margin-bottom: 20px;">
       <div class="relative">
         <a v-if="search != ''" @click.prevent="fncClearSearch" class="searchTypeClearFull"><i class="material-icons searchTypeClearText">close</i></a>
         <v-text-field v-if="quoteReportLoaded == true && quotesLoaded == true && search != ''" @input="fncCustomReportSearch" label="Search" style="width:10%;display: block; float:left;margin-right:10px;" solo single-line v-model="search"></v-text-field>
         <v-text-field v-if="quoteReportLoaded == true && quotesLoaded == true && search == ''" @input="fncCustomReportSearch" append-icon="search" label="Search" style="width:12%;display: block; float:left;margin-right:10px;" solo single-line v-model="search"></v-text-field><br />-->
            <!--<date-picker v-if="quoteReportLoaded == true && quotesLoaded == true" id="dashDateRep" valueType="format" @change="fncMakeClickable('start')" class="quoteDateRep dashDateRep" style="margin: 0 auto; width: 13% !important; margin-top: -18px !important; display: block !important; margin-left: 1% !important;font-weight: bold !important;font-size:14px !important;" v-model="reportDate[0]" placeholder="Select a date" format="YYYY-MM-DD" lang="en"></date-picker>
            <span v-if="quoteReportLoaded == true && quotesLoaded == true" class="toRep">to</span>
            <date-picker v-if="quoteReportLoaded == true && quotesLoaded == true" id="dashDateRep" valueType="format" @change="fncMakeClickable('end')" class="quoteDateRep dashDateRep" style="margin: 0 auto; width: 13% !important; margin-top: -18px !important; display: block !important; margin-left: -0.8% !important;font-weight: bold !important;font-size:14px !important;" v-model="reportDate[1]" placeholder="Select a date" format="YYYY-MM-DD" lang="en"></date-picker>
            <span v-if="quoteReportLoaded == true && quotesLoaded == true" class="toRepTwo" style="display: block; float:left;padding-left:1%;padding-right:1.4%;padding-top: 0px;font-size:12px;"><strong>OR</strong></span>
            <v-select v-if="quoteReportLoaded == true && quotesLoaded == true" class="dropdown dashDroprep" v-model="quoteFilter" style="width:14%;font-size:12px 1important;margin-top: -18px;" :label="fncFilterLabel()" :items="dateOptions" @input="fncChangeQuotes(false)" item-value="id" item-text="name" autocomplete solo single-line></v-select>-->
            <!--<div style="position: absolute; left: 0%;top: 0%;width:100%;">-->
            <!--<div style="position: absolute; left: 55%;top: 0%;width:100%;">-->
              <!--<v-btn :disabled="nonClickable" v-if="nonClickable == true && quoteReportLoaded == true && quotesLoaded == true" class="dashGenerateRep qtGenerate" @click="fncSearchNewQuotes()" style="opacity: 0.5 !important; width: 10% !important;position: absolute; top: 0px; display: block; float: left;">SEARCH</v-btn>
              <v-btn :disabled="nonClickable" v-if="nonClickable == false && quoteReportLoaded == true && quotesLoaded == true" class="dashGenerateRep qtGenerate" @click="fncSearchNewQuotes()" style="width: 10% !important;position: absolute; top: 0px; display: block; float: left;">SEARCH</v-btn>-->
              <!--<date-picker ref="dateSelect" @input="fncSearchNewQuotes()" range class="quoteDate" v-model="reportDate" placeholder="Date Range" format="YYYY-MM-DD" lang="en"></date-picker>-->
              <!--<v-btn v-if="quoteReportLoaded == true && quotesLoaded == true && hasFilters == false && filterActive == true" @click.prevent="fncToggleFilters" class="elevation-5" style="display: block; float:left;position: absolute; top: 0px; left: 11%;" color="info"><i class="material-icons">filter_list</i>Hide Filters</v-btn>-->
              <!--<v-btn v-if="quoteReportLoaded == true && quotesLoaded == true && hasFilters == false && filterActive == false" @click.prevent="fncToggleFilters" class="elevation-5" style="display: block; float:left;position: absolute; top: 0px; left: 11%;" color="info"><i class="material-icons">filter_list</i>Show Filters</v-btn>-->
              <!--<v-btn v-if="quotesLoaded == true && filterDrawer == true" @click.prevent="filterDrawer = false" class="elevation-5" style="display: block; float:left;position: absolute; top: 0px; left: 11%;" color="info"><i class="material-icons">filter_list</i>Hide Filters</v-btn>
              <v-btn v-if="quotesLoaded == true && filterDrawer == false" @click.prevent="filterDrawer = true" class="elevation-5" style="display: block; float:left;position: absolute; top: 0px; left: 11%;" color="info"><i class="material-icons">filter_list</i>Show Filters</v-btn>-->
              <!--<v-btn v-if="quotesLoaded == true && filterDrawer == true" @click.prevent="filterDrawer = false" class="elevation-5" style="display: block; float:left;position: absolute; top: 0%; margin-top: -26px; left: -3px;" color="info"><i class="material-icons">filter_list</i>Hide Filters</v-btn>
              <v-btn v-if="quotesLoaded == true && filterDrawer == false" @click.prevent="fncShowFilterSlide()" class="elevation-5" style="display: block; float:left;position: absolute; top: 0%; margin-top: -26px; left: -3px;" color="info"><i class="material-icons">filter_list</i>Filters</v-btn>

              <v-btn v-if="quoteReportLoaded == true && quotesLoaded == true && quotesLinked == true" @click.prevent="fncHideLinkedQuotes()" class="elevation-5" style="display: block; float:left;position: absolute; top: 0px; left: 11%;" color="info"><i class="material-icons">filter_list</i>Hide Linked Quotes</v-btn>-->
              <!--<v-btn @click.prevent="fncClearFilters" v-if="quoteReportLoaded == true && quotesLoaded == true && hasFilters == true" class="elevation-5 whiteText" style="display: block; float:left;position: absolute; top: 0px; left: 11%;" color="red"><i class="material-icons">filter_list</i>Clear Filters</v-btn>-->
            <!--</div>
          </div>
        </v-flex>-->
        <div v-if="objAuthorize.privileges.indexOf('VIEW_OLD_QUOTE_REPORT') != -1" style="height: 80px !important;"></div>
        <v-tabs  class="pt-4 mt-5"  v-model="topTab" slider-color="grey" v-if="objAuthorize.privileges.indexOf('VIEW_OLD_QUOTE_REPORT') == -1 && quotesLoaded == true && editLoading == false">
<!--          <v-tab class="tab"  @click="getTabs('is_new_lead')" :key="1" ripple>NEW LEADS-->
<!--            <span v-show="!totalPending" class="tabs_totals">Value: <strong v-html="fncDisplayTopTabValue('is_new_lead')"></strong> Count: <strong v-html="fncDisplayTopTabCount('is_new_lead')"></strong></span>-->
<!--          </v-tab>-->
          <v-tab class="tab"  @click="getTabs('is_initial_engagement_quote')" :key="1" ripple :disabled="tabIsDisabled('is_initial_engagement_quote')">INITIAL ENGAGEMENT & QUOTING</v-tab>
          <v-tab class="tab"  @click="getTabs('is_negotiating_customer_approval')" :key="2" ripple :disabled="tabIsDisabled('is_negotiating_customer_approval')">NEGOTIATING CUSTOMER APPROVAL
<!--            <span v-show="!totalPending" class="tabs_totals">Value: <strong v-html="fncDisplayTopTabValue('is_negotiating_customer_approval')"></strong> Count: <strong v-html="fncDisplayTopTabCount('is_negotiating_customer_approval')"></strong></span>-->
<!--            <img v-show="totalPending"  class="tabs_totals" src="../../shared/assets/images/total-loader.gif" style="width: 250px;"  />-->
          </v-tab>
          <v-tab class="tab"  @click="getTabs('is_manufacturer_fulfilment')" :key="3" ripple :disabled="tabIsDisabled('is_manufacturer_fulfilment')">MANUFACTURER & FULFILMENT</v-tab>
          <v-tab class="tab"  @click="getTabs('is_cancelled_expired_rejected')" :key="4" ripple :disabled="tabIsDisabled('is_cancelled_expired_rejected')">CANCELLED, REJECTED OR EXPIRED</v-tab>
<!--    New lead-->
<!--            <v-tab-item :key="1" style="background-color: white;width: 95% !important;">-->
<!--              <v-tabs  v-model="secondTab" class="pt-2 " id="subTab" style="background-color: white !important;" slider-color="grey" v-if="quotesLoaded == true">-->
<!--                <v-tab class="pa-0 ma-0" style="min-width:0px; display: none" />-->
<!--                <v-tab @click="getTab(tab.description)" v-for="(tab, index) in tabs.is_new_lead" class="tab"-->
<!--                       :class="[ (secondTab === 'null' && fncCanApplyLeftBorder('is_new_lead',tab.description)) ? 'tabs_borders tabs_left_border' : '',-->
<!--                       secondTab === 'null' ? 'tabs_borders' : '',-->
<!--                       (fncCanApplyRightBorder('is_new_lead', tab.description) && secondTab === 'null' ) ? 'tabs_right_border' : '']"-->
<!--                       id="tab1"  :key="tab.id"  :value="tab.id" ripple>-->
<!--                  <span  style="overflow: hidden;text-overflow: ellipsis;-webkit-line-clamp: 2;-webkit-box-orient: vertical;display: -webkit-box;"> {{tab.description}}</span>-->
<!--                  <span v-show="!totalPending" style="margin-top: 30px !important;display: block;" class="tabs_totals">Value: <strong v-html="fncDisplayBottomTabValue('is_new_lead',tab.description)" ></strong> Count: <strong v-html="fncDisplayBottomTabCount('is_new_lead',tab.description)"></strong> </span>-->
<!--                </v-tab>-->
<!--              </v-tabs>-->
<!--            </v-tab-item>-->
            <v-tab-item :key="1" style="background-color: white; width: 98%" >
              <v-tabs  next-icon="next-quote-status" show-arrows
                       prev-icon="prev-quote-status" row :value="secondTab" @input="onTabSelected" class="pt-2 " id="subTab" style="background-color: white !important;" slider-color="grey" v-if="quotesLoaded == true">
                <v-tabs-slider ></v-tabs-slider>
                <v-tab @click="getTab(tab.description)" v-for="tab in tabs.is_initial_engagement_quote" class="tab" id="tab1"  :key="tab.id"  :value="tab.id" ripple
                       :class="[ (secondTab === 'null' && fncCanApplyLeftBorder('is_initial_engagement_quote',tab.description)) ? 'tabs_left_border' : '',
                       secondTab === 'null' ? 'tabs_borders' : '',
                       (fncCanApplyRightBorder('is_initial_engagement_quote', tab.description) && secondTab === 'null' ) ? 'tabs_right_border' : '']">
                  <span style="overflow: hidden;text-overflow: ellipsis;-webkit-line-clamp: 2;-webkit-box-orient: vertical;display: -webkit-box;"> {{tab.description}}</span>
<!--                  <span :class="tab.description.length > 34 ? 'ninePixel' : 'fivePixel'" style="overflow: hidden;text-overflow: ellipsis;-webkit-line-clamp: 2;-webkit-box-orient: vertical;display: -webkit-box;"> {{tab.description}}</span>-->
<!--                  <span v-show="!totalPending" style="margin-top: 30px !important;display: block !important;white-space: nowrap;" class="tabs_totals">Value: <strong  v-html="fncDisplayBottomTabValue('is_initial_engagement_quote',tab.description)" ></strong> Count: <strong v-html="fncDisplayBottomTabCount('is_initial_engagement_quote',tab.description)"></strong> </span>-->
<!--                  <img v-show="totalPending" class="tabs_totals second_tabs" src="../../shared/assets/images/total-loader.gif" style="width: 250px;"  />-->
                </v-tab>
              </v-tabs>
            </v-tab-item>

            <v-tab-item :key="2" style="background-color: white;width: 98%">
              <v-tabs  next-icon="next-quote-status"
                       prev-icon="prev-quote-status"   v-model="secondTab" class="pt-2 "  id="subTab" style="background-color: white !important;" slider-color="grey" v-if="quotesLoaded == true">
                <v-tab @click="getTab(tab.description)" v-for="tab in tabs.is_negotiating_customer_approval" class="tab" id="tab1"  :key="tab.id"  :value="tab.id" ripple
                       :class="[ (secondTab === 'null' && fncCanApplyLeftBorder('is_negotiating_customer_approval',tab.description)) ? 'tabs_borders tabs_left_border' : '',
                       secondTab === 'null' ? 'tabs_borders' : '',
                       (fncCanApplyRightBorder('is_negotiating_customer_approval', tab.description) && secondTab === 'null' ) ? 'tabs_right_border' : ''] ">
                  <span style="overflow: hidden;text-overflow: ellipsis;-webkit-line-clamp: 2;-webkit-box-orient: vertical;display: -webkit-box;"> {{tab.description}}</span>
                </v-tab>
              </v-tabs>
            </v-tab-item>

            <v-tab-item :key="3" style="background-color: white;width: 98%">
              <v-tabs next-icon="next-quote-status"
                      prev-icon="prev-quote-status" v-model="secondTab" class="pt-2 " id="subTab" style="background-color: white !important;" slider-color="grey" v-if="quotesLoaded == true">
                <v-tab @click="getTab(tab.description)" v-for="tab in tabs.is_manufacturer_fulfilment" class="tab" id="tab1"  :key="tab.id"  :value="tab.id" ripple
                       :class="[ (secondTab === 'null' && fncCanApplyLeftBorder('is_manufacturer_fulfilment',tab.description)) ? 'tabs_borders tabs_left_border' : '',
                       secondTab === 'null' ? 'tabs_borders' : '',
                       (fncCanApplyRightBorder('is_manufacturer_fulfilment', tab.description) && secondTab === 'null' ) ? 'tabs_right_border' : ''] ">
                  <span style="overflow: hidden;text-overflow: ellipsis;-webkit-line-clamp: 2;-webkit-box-orient: vertical;display: -webkit-box;"> {{tab.description}}</span>
                </v-tab>
              </v-tabs>
            </v-tab-item>

            <v-tab-item  :key="4" style="background-color: white;width: 98%">
              <v-tabs next-icon="next-quote-status" prev-icon="prev-quote-status" v-model="secondTab" class="pt-2 " id="subTab" style="background-color: white !important;" slider-color="grey" v-if="quotesLoaded == true">
                <v-tab @click="getTab(tab.description)" v-for="tab in tabs.is_cancelled_expired_rejected" class="tab" id="tab1"  :key="tab.id"  :value="tab.id" ripple
                       :class="[ (secondTab === 'null' && fncCanApplyLeftBorder('is_cancelled_expired_rejected',tab.description)) ? 'tabs_borders tabs_left_border' : '',
                       secondTab === 'null' ? 'tabs_borders' : '',
                       (fncCanApplyRightBorder('is_cancelled_expired_rejected', tab.description) && secondTab === 'null' ) ? 'tabs_right_border' : ''] ">
                  <span style="overflow: hidden;text-overflow: ellipsis;-webkit-line-clamp: 2;-webkit-box-orient: vertical;display: -webkit-box;"> {{tab.description}}</span>
                </v-tab>
              </v-tabs>
            </v-tab-item>

        </v-tabs>
        <p class="pt-5" style="text-align: center" v-if="quotesLoaded == true && ( headers.length <= 2 || quoteSearchList.length == 0)"><br /><strong>&nbsp;No matching records found.</strong></p>

<!--        <div style="float: right" class="pr-3">-->
<!--          <v-btn small @click.prevent="fncShowColumns" v-if="quotesLoaded == true && (headers.length > 2 || quoteSearchList.length > 0)" class="elevation-5 mt-2"  color="info"><i class="material-icons">view_column</i>MANAGE COLUMNS</v-btn>-->
<!--        </div>-->
        <div v-if="quotesLoaded == true && editLoading == false && headers.length > 2 && quoteSearchList.length > 0" class="paginationRecords pt-3 pl-3" v-html="fncShowPaginationRecords()">
        </div>
        <v-pagination
          v-model="page"
          :length= this.totalPages
          :page= this.getPage
          :total-visible="7"
          v-if="totalPages > 1 && quotesLoaded == true && editLoading == false && headers.length > 2 && quoteSearchList.length > 0"
        ></v-pagination>
<!--        <div v-if="quotesLoaded == true && editLoading == false && headers.length > 2 && quoteSearchList.length > 0" class="paginationRecords" v-html="fncShowPaginationRecords()"></div>-->
        <div id="quoteReportTable" v-if="quotesLoaded == true && editLoading == false && headers.length > 2 && quoteSearchList.length > 0" :class="fncHasFilters()" style="width:100%; overflow: auto; ">
          <!--<v-data-table v-if="( quotesLoaded == true && quoteReportLoaded == true ) || search != ''" ref="sortableTable" :headers="headers" :items="quoteSearchList" class="elevation-1" disable-initial-sort :style="{ 'width': tableWidth+'px'}" :total-items="fncGetRecordCount()" @click:pagination="updatePagination" :pagination.sync="pagination" :rows-per-page-items="[50]">-->
          <v-data-table v-if="( quotesLoaded == true && quoteReportLoaded == true ) || search != ''" ref="sortableTable" :headers="headers" :items="quoteSearchList" class="elevation-1" disable-initial-sort :style="{ 'width': tableWidth+'px'}" :total-items="fncGetRecordCount()" :rows-per-page-items="[50]">
            <template slot="headers" slot-scope="row">
              <tr>
                <th @click="fncShowFilterPop(header.text)" class="reportFilters" valign="top" :width="header.width" v-for="header in headers" :data-ref="header.value">
                      <span style="pointer-events: none;" class="headerTitle">
                        <div v-if="header.text == 'Discount Value' || header.text == 'Pre-Discount Total' || header.text == 'Sub-Total' || header.text == 'VAT'  || header.text == 'Total'" style="float: right">{{ fncUpper(header.text) }}</div>
                        <div v-if="header.text == 'Responsible Rep' || header.text == 'Users Linked to Quote'">Users Linked to Quote</div>
                        <div v-if="header.text == 'User Type' || header.text == 'Customer User Type'">Customer User Type</div>
                        <div v-if="header.text != 'User Type' && header.text != 'Customer User Type' && header.text != 'Responsible Rep' && header.text != 'Users Linked to Quote' && header.text != 'Discount Value' && header.text != 'Pre-Discount Total' && header.text != 'Sub-Total' && header.text != 'VAT' && header.text != 'Total'" v-html="fncCheckHeaderFilter(header.text)"></div>
                        <div v-if="dateFilterShow == true && header.text == 'Quote Date'"  class="reportFilterPop"   v-html="fncShowDateFilters()"></div>
                        <div v-if="vendorFilterShow == true && header.text == 'Vendor'"  class="reportFilterPop" v-html="fncShowVendorFilters()">
                        </div>
                        <div v-if="departmentFilterShow == true && header.text == 'Department'" class="reportFilterPop" v-html="fncShowDepartmentFilters()"></div>
                        <div v-if="storeFilterShow == true && header.text == 'Store'" class="reportFilterPop" v-html="fncShowStoreFilters()"></div>
                        <div v-if="originatorFilterShow == true && header.text == 'Originator Name'" class="reportFilterPop" v-html="fncShowOriginatorFilters()"></div>
                        <div v-if="customerFilterShow == true && header.text == 'Customer Name'" class="reportFilterPop" v-html="fncShowCustomerUserFilters()"></div>
                        <div v-if="statusFilterShow == true && header.text == 'Status'" class="reportFilterPop"  ></div>
                        <div v-if="regionFilterShow == true && header.text == 'Kam Region'" class="reportFilterPop" v-html="fncShowRegionFilters()"></div>
                        <div v-if="repFilterShow == true && ( header.text == 'Responsible Rep' || header.text == 'Users Linked to Quote')" class="reportFilterPop" v-html="fncShowRepFilters()"></div>
                      </span>
                </th>
              </tr>
            </template>
            <template slot="items" v-if="fncCanDisplay( props.item )" slot-scope="props" class="test" :style="{ background: props.item.backgroundColour }">
              <!--<td width="100px" :style="{ background: props.item.backgroundColour }" class="text-xs-right">-->
              <!--<td width="100px" :style="{ border: props.item.backgroundColour }" class="text-xs-right">-->
              <td class="menu-field" :style="{ 'border-left': '6px solid ' + props.item.backgroundColour + ' !important' }">
                <v-menu offset-y>
                  <i style="color: #00a99d;" class="material-icons menuIcon" slot="activator">menu</i>
                  <v-list>
                    <v-list-tile v-if="fncCheckTalisman(props.item.departmentId)" @click.prevent="fncViewQuote(props.item)">
                      <v-list-tile-title>
                        <a>View Quote Details</a>
                      </v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile @click.prevent="fncDownloadQuotePdf(props.item)">
                      <v-list-tile-title>
                        <a>Download Quote PDF</a>
                      </v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile v-if="fncCheckSurveyDocument(props.item)" @click.prevent="fncEditSurveyDoc(props.item.id)">
                      <v-list-tile-title>
                        <a>Edit Service Form Document</a>
                      </v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile v-if="fncCheckSurveyDocument(props.item)" @click.prevent="fncCloneQuote(props.item.id,props.item.departmentId)">
                      <v-list-tile-title>
                        <a>Clone Quote</a>
                      </v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile v-if="fncCheckSurveyDocument(props.item)" @click.prevent="fncDownloadSurveyDoc(props.item.id, props.item.quote_no, 'full')">
                      <v-list-tile-title>
                        <a>Download Service Form Document - Full</a>
                      </v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile v-if="fncCheckSurveyDocument(props.item)" @click.prevent="fncDownloadSurveyDoc(props.item.id, props.item.quote_no, 'client')">
                      <v-list-tile-title>
                        <a>Download Service Form Document - Client</a>
                      </v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile v-if="fncCheckSalesOrder(props.item)" @click.prevent="fncDownloadPdf(props.item)">
                      <v-list-tile-title>
                        <a>Download Sales Order</a>
                      </v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile @click.prevent="fncLinkedQuotes(props.item)">
                      <v-list-tile-title>
                        <a>View Linked Quotes</a>
                      </v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile @click.prevent="fncNotificationHistory(props.item.id)">
                      <v-list-tile-title>
                        <a>Notification History</a>
                      </v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile v-if='objAuthorize.privileges.indexOf("CAN_ARCHIVE") != -1' @click.prevent="fncArchiveQuote(props.item)">
                      <v-list-tile-title>
                        <a>Archive Quote</a>
                      </v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile @click.prevent="fncRefreshQuoteNo(props.item)" v-if="( objAuthorize.email == 'superuser@ndtec.co.za' || objAuthorize.email == 'bwsuperuser@ndtec.co.za' ) && objAuthorize.manufacturer == '385889803'">
                      <v-list-tile-title>
                        <a>Refresh Quote Number</a>
                      </v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile @click.prevent="fncStoreAudits(props.item)" v-if="objAuthorize.manufacturer == '385889803'">
                      <v-list-tile-title>
                        <a>View Store Change Audits</a>
                      </v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile @click.prevent="fncUpdateStore(props.item)" v-if="objAuthorize.privileges.indexOf('CAN_UPDATE_STORE') != -1 && objAuthorize.manufacturer == '385889803'">
                      <v-list-tile-title>
                        <a>Update Store</a>
                      </v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile @click.prevent="fncViewApis(props.item)" v-if="objAuthorize.privileges.indexOf('CAN_VIEW_API_AUDITS') != -1 && objAuthorize.manufacturer == '385889803'">
                      <v-list-tile-title>
                        <a>View API Audits</a>
                      </v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile @click.prevent="fncViewDeliveryNote(props.item)" v-if="objAuthorize.manufacturer == '385889803'">
                      <v-list-tile-title>
                        <a>Download Delivery Note</a>
                      </v-list-tile-title>
                    </v-list-tile>
                  </v-list>
                </v-menu>
                <a class="menu editQuoteIcon" title="Edit Quote" v-if="objAuthorize.manufacturer == '385889803' && fncDepartmentCanEdit(props.item)" @click="fncEditQuote(props.item)"><i style="color: #00a99d;" class="material-icons menuIcon">edit</i></a>
                <a class="menu openCalcIcon" title="Open Calculators" v-if="objAuthorize.manufacturer == '385889803' && fncCheckSurveyDocument(props.item) && fncCheckCalcItems(props.item)" @click.prevent="fncOpenCalc(props.item)"><i style="color: #00a99d;" class="material-icons menuIcon">calculate</i></a>
                <!--<a class="menu openCalcIcon" title="Open Calculators" v-if="objAuthorize.manufacturer == '385889803' && fncCheckSurveyDocument(props.item)" @click.prevent="fncOpenCalc(props.item)"><i style="color: #00a99d;" class="material-icons menuIcon">calculate</i></a>-->
              </td>
              <!-- :style="{ background: props.item.backgroundColour }" -->
              <td width="350px" v-if="objAuthorize.vendorActive == 1 && objAuthorize.type != '6'" class="nowrap vendorName">
                <span v-if="props.item.vendorName != 'None'">{{ props.item.vendorName }}</span>
                <span v-else>{{ props.item.vendorName }}</span>
                  <!--<v-btn v-if="props.item.vendorName != 'None'" class="elevation-5" color="info" @click="fncShowVendorUsers( props.item.vendorName, props.item )">View Users</v-btn>-->
              </td>
              <td v-for="item in objQuoteSettings" :width="fncGetWidth(item.id)" v-if="fncCheckSubDisplay(item)">

                <span v-if="item.id == 'linkedQuotes'" class="pencil nowrap" @click="fncRunQuoteSearch" v-html="fncFormatColumn(props.item,item.id)"></span>
                <span v-if="item.id != 'linkedQuotes' && item.id != 'quote_no' && item.id != 'status' && item.id != 'orig_name'" @click.prevent="fncEditStatus(props.item,item.id)" class="pencil nowrap" v-html="fncFormatColumn(props.item,item.id)"></span>
                <span v-if="item.id != 'linkedQuotes' && item.id != 'quote_no' && item.id == 'orig_name' && canEditOriginator == false" @click.prevent="fncEditStatus(props.item,item.id)" class="pencil nowrap" v-html="fncFormatColumn(props.item,item.id)"></span>

                <!--<span style="display: block; padding-top: 5px;padding-bottom: 5px;" v-if="item.id == 'responsible_representative' && objAuthorize.manufacturer == '385889803'">{{ props.item.responsible_representative }}</span>-->
                <div class="nowrap status-container">
                <span class="status-text" v-if="item.id == 'status'"><strong :id="fncSetId(props.item.id)">{{ props.item.status }}</strong></span>
                <span @click="fncEditStatusPopup(props.item, props.item.id)" v-if="filterNeedsReload == false && objAuthorize.privileges.indexOf('CANNOT_UPDATE_STATUS') == -1 && !fncCheckStatusStatus(props.item) && item.id == 'status'"><v-btn class="elevation-5" color="info">UPDATE STATUS</v-btn></span>
                <a v-if="filterNeedsReload == false && item.id == 'status'" href="#" @click.prevent="fncEditStatus(props.item,'status')"><i class="material-icons">history</i></a>
                </div>

                <v-select :label="props.item.orig_name" v-if="item.id == 'orig_name' && canEditOriginator == true" style="width:87%;display:block;float:left;margin-top: 0px !important;" @input="fncEditOriginator(props.item)" v-model="props.item.originator" item-value="id" :items="repUsers" item-text="label" solo outline autocomplete class="statusList originatorDropdown"></v-select>
                <!--<v-select :label="props.item.status" :disabled="fncCheckStatusStatus(props.item)" v-if="item.id == 'status'" style="width:87%;display:block;float:left;margin-top: 0px !important;" @input="fncEditStatusPopup(props.item, props.item.id, props.item.status)" v-model="props.item.status" item-value="description" :items="fncGetStatusDropdown(props.item)" item-text="description" solo outline class="headerSelect statusList"></v-select>

                <v-select :ref="fncGenerateRef(props.index)" :label="fncSetRepLabel(props.item.new_responsible_reps_ids_obj)" v-if="item.id == 'responsible_representative' && objAuthorize.manufacturer == '385889803'" style="width:87%;display:block;float:left;" @blur="fncReloadRepUsers(repUsers, props.item.new_responsible_reps_ids_obj, props.index)" @keyup="fncGetSearchedQuoteReps( props.index, repUsers )" @input="fncEditQuoteReps(props.item)" v-model="props.item.new_responsible_reps_ids_obj" item-value="id" :items="fncGetRepUsers(props.item, repUsers, props.item.new_responsible_reps_ids_obj)" item-text="fullname" autocomplete multiple class="repSelect"></v-select>-->

                <!--<span v-if="item.id == 'process_order' && !fncCheckOrderButton(props.item.status)">N/A</span>-->
                <!--<v-btn v-if="item.id == 'responsible_representative' && objAuthorize.manufacturer == '385889803'" class="elevation-5" color="info" @click="fncSetResponsibleReps()">VIEW AND SET</v-btn>-->

                <div class="nowrap responsibleRep">
                <span v-if="item.id == 'responsible_representative' && objAuthorize.manufacturer != '1845509583'">{{ fncShowReps(props.item.responsible_representative, []) }}</span>
                <v-btn v-if="item.id == 'responsible_representative' && objAuthorize.manufacturer == '385889803' && objAuthorize.privileges.indexOf('CAN_SET_RESPONSIBLE_REP') != -1" @click="fncSetResponsibleReps( props.item, 0 )" slot="activator" class="elevation-5" color="info">UPDATE</v-btn>
                </div>

                <span v-if=" item.id == 'customerRecipient'" class="nowrap customerRecipient">
                  <!--<v-text-field style="margin-top: 6px; float: left !important;width:60%;" solo single-line v-model="props.item.customer_recipient"></v-text-field>-->
                  <span v-if="props.item.customer_recipient != ''" v-html="fncDotDotDot(props.item.customer_recipient)"></span>
                  <span v-else>Not Set</span>
                  <v-btn class="elevation-5" @click="fncEditCustomerRecipient(props.item)" color="info">UPDATE</v-btn>
                </span>

                <span style="margin-top: 2px;display: block; padding-top: 0px;padding-right:4px;padding-bottom: 0px;" v-if=" item.id == 'vendorRecipient'" class="nowrap vendorRecipient">
                  <!--<v-text-field style="margin-top: 6px; float: left !important;width:60%;" solo single-line v-model="props.item.customer_recipient"></v-text-field>-->
                  <span v-if="props.item.vendor_recipient != ''" v-html="fncDotDotDot(props.item.vendor_recipient)"></span>
                  <span v-else>Not Set</span>
                  <v-btn class="elevation-5" @click="fncEditVendorRecipient(props.item)" color="info">UPDATE</v-btn>
                </span>

                <!--<v-tooltip v-if="item.id == 'responsible_representative' && objAuthorize.manufacturer == '385889803'" right style="top: 0px !important;">
                  <v-btn v-if="objAuthorize.privileges.indexOf('CAN_SET_RESPONSIBLE_REP') != -1" @click="fncSetResponsibleReps( props.item, 0 )" style="margin-top: 3px;margin-left:-12px !important;" slot="activator" class="elevation-5" color="info">SET</v-btn>
                  <v-btn v-if="objAuthorize.privileges.indexOf('CAN_SET_RESPONSIBLE_REP') == -1"  style="margin-top: 3px;margin-left:-12px !important;" slot="activator" class="elevation-5" color="info">VIEW</v-btn>
                  <span v-html="fncShowReps(props.item.responsible_representative, [])"></span>
                </v-tooltip>-->


                <div class="responsibleRep nowrap">
                <span v-if="item.id == 'commercialKam' && objAuthorize.manufacturer == '385889803'"><br />{{ props.item.responsible_kam_name }}</span>
                <v-btn v-if="item.id == 'commercialKam' && objAuthorize.manufacturer == '385889803' && objAuthorize.privileges.indexOf('CAN_SET_RESPONSIBLE_REP') != -1" @click="fncSetResponsibleKams( props.item )" slot="activator" class="elevation-5" color="info">SET</v-btn>
                <span v-if="item.id == 'commercialOriginator' && objAuthorize.manufacturer == '385889803'">{{ props.item.responsible_originator_name }}</span>
                <v-btn v-if="item.id == 'commercialOriginator' && objAuthorize.manufacturer == '385889803' && objAuthorize.privileges.indexOf('CAN_SET_RESPONSIBLE_REP') != -1" @click="fncSetResponsibleOriginator( props.item )"  slot="activator" class="elevation-5" color="info">SET</v-btn>
                </div>
                <!--<v-tooltip v-if="!isNaN(item.id) && objAuthorize.manufacturer == '385889803'" right style="top: 0px !important;">-->
                <div class="responsibleRep nowrap">
                  <span v-if="!isNaN(item.id)">{{ fncShowRepsSub(props.item.responsible_representative, item) }}</span>
                  <v-btn v-if="!isNaN(item.id) && objAuthorize.manufacturer == '385889803' && objAuthorize.privileges.indexOf('CAN_SET_RESPONSIBLE_REP') != -1" @click="fncSetResponsibleReps( props.item, item.id )" slot="activator" class="elevation-5" color="info">UPDATE</v-btn>
                </div>
                  <!--<v-btn v-if="!isNaN(item.id) && objAuthorize.manufacturer == '385889803' && objAuthorize.privileges.indexOf('CAN_SET_RESPONSIBLE_REP') != -1" @click="fncSetResponsibleReps( props.item, item.id )" style="margin-top: 3px;margin-left:-12px !important;" slot="activator" class="elevation-5" color="info">{{ fncShowRepsSub(props.item.responsible_representative, item) }}</v-btn>-->
                <!--<v-btn v-if="!isNaN(item.id) && objAuthorize.manufacturer == '385889803' && objAuthorize.privileges.indexOf('CAN_SET_RESPONSIBLE_REP') == -1"  style="margin-top: 3px;margin-left:-12px !important;" disabled="true" slot="activator" class="elevation-5" color="info">{{ fncShowRepsSub(props.item.responsible_representative, item) }}</v-btn>-->
                  <!--<span v-html="fncShowReps(props.item.responsible_representative, item)"></span>-->
                <!--</v-tooltip>-->

                <!--<v-tooltip v-if="item.id == 'commercialKam' && objAuthorize.manufacturer == '385889803'" right style="top: 0px !important;">
                  <v-btn v-if="objAuthorize.privileges.indexOf('CAN_SET_RESPONSIBLE_REP') != -1" @click="fncSetResponsibleKams( props.item )" style="margin-top: 3px;margin-left:-12px !important;" slot="activator" class="elevation-5" color="info">VIEW AND SET</v-btn>
                  <v-btn v-if="objAuthorize.privileges.indexOf('CAN_SET_RESPONSIBLE_REP') == -1"  style="margin-top: 3px;margin-left:-12px !important;" slot="activator" class="elevation-5" color="info">VIEW</v-btn>
                  <span v-html="fncShowReps(props.item.responsible_representative)"></span>
                </v-tooltip>
                <v-tooltip v-if="item.id == 'commercialOriginator' && objAuthorize.manufacturer == '385889803'" right style="top: 0px !important;">
                  <v-btn v-if="objAuthorize.privileges.indexOf('CAN_SET_RESPONSIBLE_REP') != -1" @click="fncSetResponsibleOriginator( props.item )" style="margin-top: 3px;margin-left:-12px !important;" slot="activator" class="elevation-5" color="info">VIEW AND SET</v-btn>
                  <v-btn v-if="objAuthorize.privileges.indexOf('CAN_SET_RESPONSIBLE_REP') == -1"  style="margin-top: 3px;margin-left:-12px !important;" slot="activator" class="elevation-5" color="info">VIEW</v-btn>
                  <span v-html="fncShowReps(props.item.responsible_representative)"></span>
                </v-tooltip>-->
                <div class="nowrap reportAttachmentContainer">
                  <a v-if="item.id == 'quote_no' && props.item.hasAttachments != '0'" @click.prevent="fncQuoteSettings(props.item.id, props.item.quote_no, props.item)" class="reportAttachment"><i class="material-icons attachmentTick" style="font-size:6px !important; top: -18px; left: -5px !important;">done</i><i style="position: relative;left:-16px;" class="material-icons">attach_file</i></a>
                  <a v-if="item.id == 'quote_no' && props.item.hasAttachments == '0'" @click.prevent="fncQuoteSettings(props.item.id, props.item.quote_no, props.item)" class="reportAttachment"><i style="opacity: 1" class="material-icons">attach_file</i></a>
                  <span v-if="item.id == 'quote_no' && props.item.hasAttachments != '0'" ><strong>{{ props.item.quote_no }}</strong></span>
                  <span v-if="item.id == 'quote_no' && props.item.hasAttachments == '0'" ><strong>{{ props.item.quote_no }}</strong></span>
                </div>
                <!--<v-btn v-if="fncCheckOrderButton(props.item.status) && item.id == 'process_order'" @click.prevent="fncGoSaleOrder(props.item)" class="elevation-5" color="info">Process Order</v-btn>-->

                <div class="nowrap processOrder">
                <v-btn v-if="fncCheckProcessButton(props.item) && item.id == 'process_order'" @click.prevent="fncGoSaleOrder(props.item)" class="elevation-5" color="info">Process Order</v-btn>
                <!--<v-btn v-if="fncCheckSalesOrder(props.item) && fncCheckOrderButton(props.item.status) && item.id == 'process_order'" @click.prevent="fncGoSaleOrder(props.item)" class="elevation-5" color="info">Process Order</v-btn>-->
                <span v-html="fncCheckProcessButtonText(props.item)" v-if="!fncCheckProcessButton(props.item) && item.id == 'process_order'"></span>
                </div>
                <!--<span v-if="!fncCheckSalesOrder(props.item) && item.id == 'process_order'">Order not paid</span>-->
                <!--<a class="floatLeft" v-if="item.id == 'status'" style="margin-top:9px;margin-left: 5px;" href="#" @click.prevent="fncEditStatus(props.item,'status')"><i class="material-icons">history</i></a>-->
                <div v-if="item.id == 'installationDate'" class="nowrap dateInstallation">

                  <span v-if="fncGetInstallationDate(props.item) === 'N/A' " :id="'installation_date_'+props.item.id"  v-html="fncGetInstallationDate(props.item)"></span>

                  <date-picker style="min-width: 155px !important;" confirm  v-if="fncGetInstallationDate(props.item) !== 'N/A'" type="datetime" @change="handleChange($event, props.item, 'installation')"
                               :value="dates[props.item.id]" @dateSelect="handleDateSelect"  class="quoteDateRep dashDateRep" format="YYYY-MM-DD HH:mm" :minute-step="30" placeholder="Installation Date"  lang="en" >
                  </date-picker>

                  <span style="padding-left: 6px;padding-right: 140px;">
                  <a v-if="fncGetInstallationDate(props.item) !== 'N/A'" href="#" @click.prevent="fncShowDateHistory(props.item,'installation_date_change')"><i class="material-icons">history</i></a>
                </span>
                </div>
                <div v-if=" item.id == 'manufacturer_date_api'" class="nowrap dateInstallation">

                  <date-picker style="min-width: 120px !important;"   @change="handleChange($event, props.item, 'manufacturer')"  valueType="format"
                               v-model="props.item.manufacturer_date_api"   class="quoteDateRep dashDateRep" format="YYYY-MM-DD"  :minute-step="01" placeholder="Manufacturer Date"  lang="en" >
                  </date-picker>

                  <span style="padding-left: 6px;padding-right: 92px;width: 140px">
                  <a  href="#" @click.prevent="fncShowDateHistory(props.item,'manufacturer_date_change')"><i class="material-icons">history</i></a>
                </span>
                </div>
                <div v-if=" item.id === 'delivery_date_api'" class="nowrap dateInstallation">
                  <date-picker style="min-width: 120px !important;"
                               :value="convertedItems[props.item.id]" valueType="format" class="quoteDateRep dashDateRep" @change="handleChange($event, props.item, 'delivery_date_api')"
                               format="YYYY-MM-DD"  placeholder="Delivery Date"  lang="en" >
                  </date-picker>

                  <span style="padding-left: 6px;padding-right: 140px;">
                <a  href="#" @click.prevent="fncShowDateHistory(props.item,'delivaery_date_change')"><i class="material-icons">history</i></a>
              </span>
                </div>
              </td>

            </template>
          </v-data-table>
        </div>
      </v-container>
    </v-content>
  </div>
</template>

<script>

  import { mapGetters } from 'vuex';
  import tableDragger from 'table-dragger';
  import Modal from '@/components/shared/modal';
  import DatePicker from 'vue2-datepicker'
  import router from '@/router';
  import {setObjAuthorize} from "../../../store/mutations";
  import {commercialKams} from "../../../store/modules/processes/getters";

  export default {
    name: 'QuoteList',
    data () {
      return {
        sortedQuotes: [],
        sortKey: 'quote_date',
        stKey: 'status',
        sortOrders: {
          'quote_date': 1, // 1 for ascending, -1 for descending
          'status': 1,
        },
        isStatusSortOn: false,
        isDateSortOn: false,
        sortStatus: 1,
        dateChanged: false,
        hasScroll: true,
        drawer: false,
        InputValueSearch: null,
        EnableSearch: false,
        InputValueSearchQuote: null,
        EnableSearchQuote:  window.localStorage.reportSearch !== undefined && window.localStorage.reportSearch !== '' ? true: false ,
        shortcuts: [
          {
            text: 'Today',
            onClick: () => {
              //this.time3 = [ new Date(), new Date() ]
              alert('test');
            }
          }
        ],
        tabs_to_display: [],
        more:[],
        chageTopreviousTab: false,
        previousTab: '',
        topTab:'',
        secondTab: window.localStorage.secondTab !== undefined && window.localStorage.secondTab != null ?  window.localStorage.secondTab  : null,
        filterStatusSet: [],
        quoteFilter: '',
        filterDrawer: false,
        headerLoaded: false,
        //search: window.localStorage.reportSearch == null || window.localStorage.reportSearch == 'undefined' ? '' : window.localStorage.reportSearch,
        search: '',
        searchQuoteReport: window.localStorage.reportSearchQuote == null || window.localStorage.reportSearchQuote == 'undefined' ? '' : JSON.parse(window.localStorage.reportSearchQuote),
        newSearch: '',
        headers: [],
        columnLengths: [],
        objCustomerRegion: window.localStorage.qRegion != undefined && window.localStorage.qRegion[0] != null ? window.localStorage.qRegion.split(',') : '',
        objOriginator: window.localStorage.reportOriginators != undefined && window.localStorage.reportOriginators != null ? JSON.parse(window.localStorage.reportOriginators) : ['all'],
        objKam: window.localStorage.reportKams != undefined && window.localStorage.reportKams != null ? JSON.parse(window.localStorage.reportKams) : ['all'],
        objcOriginator: window.localStorage.reportcOriginator != undefined && window.localStorage.reportcOriginator != null ? JSON.parse(window.localStorage.reportcOriginator) : ['all'],
        objQuoteType: window.localStorage.reportQuoteType != undefined && window.localStorage.reportQuoteType != null ? JSON.parse(window.localStorage.reportQuoteType) : ['all'],
        objServiceType: window.localStorage.reportServiceType != undefined && window.localStorage.reportServiceType != null ? JSON.parse(window.localStorage.reportServiceType) : ['all'],
        objProjects: window.localStorage.reportProjects != undefined && window.localStorage.reportProjects != null ? JSON.parse(window.localStorage.reportProjects) : ['all'],
        objCompany: window.localStorage.reportCompany != undefined && window.localStorage.reportCompany != null ? JSON.parse(window.localStorage.reportCompany) : ['all'],
        objStatus: window.localStorage.reportStatus != undefined && window.localStorage.reportStatus != null ? JSON.parse(window.localStorage.reportStatus) : ['all'],
        objCustomerCompany: window.localStorage.reportCompanies != undefined && window.localStorage.reportCompanies != null ? JSON.parse(window.localStorage.reportCompanies) : ['all'],
        objCustomerUser: window.localStorage.reportUsers != undefined && window.localStorage.reportUsers != null ? JSON.parse(window.localStorage.reportUsers) : ['all'],
        objProject: window.localStorage.reportProject != undefined && window.localStorage.reportProject != null ? JSON.parse(window.localStorage.reportProject) : ['all'],
        objSpecifier: window.localStorage.reportSpecifiers != undefined && window.localStorage.reportSpecifiers != null ? JSON.parse(window.localStorage.reportSpecifiers) : ['all'],
        objVendor: window.localStorage.reportVendors != undefined && window.localStorage.reportVendors != null ? JSON.parse(window.localStorage.reportVendors) : ['all'],
        objDepartment: window.localStorage.reportDepartments != undefined && window.localStorage.reportDepartments != null ? JSON.parse(window.localStorage.reportDepartments) : ['all'],
        objStore: window.localStorage.reportStores != undefined && window.localStorage.reportStores != null ? JSON.parse(window.localStorage.reportStores) : ['all'],
        startDate: window.localStorage.qStartDate,
        endDate: window.localStorage.qEndDate,
        tableWidth: 300,
        reportDate: window.localStorage.reportDates != undefined && window.localStorage.reportDates != null ? this.setDates() : '',
        lang: {
          placeholder: {
            date: 'Select Date',
            dateRange: 'Select Date'
          }
        },
        filterActive: this.$route.query.filter != null ? true : false,
        originatorBlur: false,
        companyBlur: false,
        customerBlur: false,
        statusBlur: false,
        specifierBlur: false,
        projectBlur: false,
        vendorBlur: false,
        departmentBlur: false,
        storeBlur: false,
        hasFilters: false,
        hasFiltersDateOnly: false,
        storeMapping: [],
        dateOptions: [
          { id: 1, name: 'View All Quotes' },
          { id: 2, name: 'View Last 6 Months' },
          { id: 3, name: 'View Last 90 Days' },
          { id: 4, name: 'View Last 60 Days' },
          { id: 5, name: 'View Last 30 Days' },
          { id: 6, name: 'View Last Week' }
        ],
        nonClickable: true,
        storeMapping: [],
        filterStatus: [],
        quotesLinked: false,
        pagination: {},
        page: 1,
        regenFalse: true,
        dateFilterShow: false,
        vendorFilterShow: false,
        departmentFilterShow: false,
        storeFilterShow: false,
        originatorFilterShow: false,
        customerFilterShow: false,
        statusFilterShow: false,
        repFilterShow: false,
        regionFilterShow: false,
        showVendorClose: false,
        getPage: 1,
        totalPages: 1,
        hideOriginatorLabels: false,
        filteredRepsDropdown: [],
        canEditOriginator: false,
        quotesStatuses: [],
        vendorUserList: [],
        objRegion: window.localStorage.reportRegions != undefined && window.localStorage.reportRegions != null ? JSON.parse(window.localStorage.reportRegions) : ['all'],
        objRep: window.localStorage.reportReps != undefined && window.localStorage.reportReps != null ? JSON.parse(window.localStorage.reportReps) : ['all'],
        selectedStatus: null,
        checkoutStatus: 0
      }
    },
    methods: {
      fncViewDeliveryNote( quote ) {
        this.$store.dispatch('fncGenerateDeliveryNote', quote);
      },
      handleChange(event, objItem, type)
      {

        let dateObj = event
        let se = null

        const year = dateObj.getFullYear();
        const month = String(dateObj.getMonth() + 1).padStart(2, '0');
        const day = String(dateObj.getDate()).padStart(2, '0');
        const hours = String(dateObj.getHours()).padStart(2, '0');
        const minutes = String(dateObj.getMinutes()).padStart(2, '0');
        const seconds = String(dateObj.getSeconds()).padStart(2, '0');

        if (type === 'manufacturer'){
          se = `${year}-${month}-${day}`;
        }
        else if(type === 'delivery_date_api'){
          se = `${year}-${month}-${day}`;
          this.convertedItems[objItem.id] = se
        }
        else{
          se = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
          this.dates[objItem.id] = se
        }

// Set the time components to 0 to represent only the date quoteList




        this.$store.dispatch({
          type: 'fncUpdateDate',
          date: se,
          quote_no: objItem.id,
          type_action: type
        })
        this.$forceUpdate();

      },
      handleDateSelect(selectedDate) {
        // This method will be called when a date is selected in the date picker.
        // You can access the selected date as the 'selectedDate' parameter.
        console.log('Selected Date:', selectedDate);
      },
      fncShowDateHistory(objItem, type)
      {
        this.$store.dispatch({
          type: 'fncGetDateHistory',
          id: objItem.id,
          history_type: type
        });

        let modalDetails = { title: 'Installation Date History (' + objItem.quote_no + ')', component: 'modal-date-history', mstate: true, params: {id:objItem.id, history_type: type } };
        this.$store.commit({
          type: 'setModal',
          details: modalDetails
        });
      },
      fncGetInstallationDate(objItem) {
        var lineData = objItem.product_codes;
        var installationDate = 'N/A';
        if( objItem.product_codes && lineData.indexOf('installation_appointment_date_start') != -1 ) {
          var timeSplit = lineData.split('installation_appointment_date_start');
          var newSplit = timeSplit[1].replace(/"/g, "");
          newSplit = newSplit.replace(/'/g, "");
          // newSplit = newSplit.replace(/:/g, "");
          newSplit = newSplit.replace(/\//g,'')
          newSplit = newSplit.split('\\');
          installationDate = newSplit[2];
          var onjInstallDate = installationDate.split(',');
          installationDate = onjInstallDate[ onjInstallDate.length - 1 ];

          const isValid = this.isValidDate(installationDate);
          if (isValid){
            const dateObj = new Date(installationDate);

            const year = dateObj.getUTCFullYear();
            const month = String(dateObj.getUTCMonth() + 1).padStart(2, '0');
            const day = String(dateObj.getUTCDate()).padStart(2, '0');
            const hours = String(dateObj.getUTCHours()).padStart(2, '0');
            const minutes = String(dateObj.getUTCMinutes()).padStart(2, '0');
            const seconds = String(dateObj.getUTCSeconds()).padStart(2, '0');

            // installationDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
            objItem.installationDate = `${year}-${month}-${day} ${hours}:${minutes}`;
          }
        }
        return installationDate;
      },
      fncViewApis( quote ) {

        var modalDetails = { title: 'API History (' + quote.quote_no + ')', component: 'modal-api-history', mstate: true, params: { quote: quote } };
        this.$store.commit({
          type: 'setModal',
          details: modalDetails
        });

      },
      fncCheckTalisman(departmentId) {

        for( var d in this.departmentList ) {
          if( this.departmentList[d].id == departmentId ) {

            var fields = JSON.parse( this.departmentList[d].edit_form_fields );

            if( fields['hireDate'] == 'true' ) {
              return false;
            } else {
              return true;
            }

          }
        }

        return true;

      },
      fncDownloadQuotePdf( quote ) {
        this.$store.dispatch('fncGeneratePdf', quote.id )
      },
      isValidDateFormat(dateString) {
        const pattern = /^\d{2}\/\d{2}\/\d{4}$/;
        return pattern.test(dateString);
      },
      handleDateSelect(selectedDate) {
        // This method will be called when a date is selected in the date picker.
        // You can access the selected date as the 'selectedDate' parameter.
        console.log('Selected Date:', selectedDate);
      },
      handleChange(event, objItem, type)
      {

        let dateObj = event
        let se = null

        const year = dateObj.getFullYear();
        const month = String(dateObj.getMonth() + 1).padStart(2, '0');
        const day = String(dateObj.getDate()).padStart(2, '0');
        const hours = String(dateObj.getHours()).padStart(2, '0');
        const minutes = String(dateObj.getMinutes()).padStart(2, '0');
        const seconds = String(dateObj.getSeconds()).padStart(2, '0');

        if (type === 'manufacturer'){
          se = `${year}-${month}-${day}`;
        }
        else if(type === 'delivery_date_api'){
          se = `${year}-${month}-${day}`;
          this.convertedItems[objItem.id] = se
        }
        else{
          se = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
          this.dates[objItem.id] = se
        }

        // Set the time components to 0 to represent only the date quoteList
        this.$store.dispatch({
          type: 'fncUpdateDate',
          date: se,
          quote_no: objItem.id,
          type_action: type
        })
        this.$forceUpdate();

      },
      fncGetInstallationDate(objItem) {
        var lineData = objItem.product_codes;
        var installationDate = 'N/A';
        if( objItem.product_codes && lineData.indexOf('installation_appointment_date_start') != -1 ) {
          var timeSplit = lineData.split('installation_appointment_date_start');
          var newSplit = timeSplit[1].replace(/"/g, "");
          newSplit = newSplit.replace(/'/g, "");
          // newSplit = newSplit.replace(/:/g, "");
          newSplit = newSplit.replace(/\//g,'')
          newSplit = newSplit.split('\\');
          installationDate = newSplit[2];
          var onjInstallDate = installationDate.split(',');
          installationDate = onjInstallDate[ onjInstallDate.length - 1 ];

          const isValid = this.isValidDate(installationDate);
          if (isValid){
            const dateObj = new Date(installationDate);

            const year = dateObj.getUTCFullYear();
            const month = String(dateObj.getUTCMonth() + 1).padStart(2, '0');
            const day = String(dateObj.getUTCDate()).padStart(2, '0');
            const hours = String(dateObj.getUTCHours()).padStart(2, '0');
            const minutes = String(dateObj.getUTCMinutes()).padStart(2, '0');
            const seconds = String(dateObj.getUTCSeconds()).padStart(2, '0');

            // installationDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
            objItem.installationDate = `${year}-${month}-${day} ${hours}:${minutes}`;
          }
        }
        return installationDate;
      },
      fncUpdateStore( item ) {

        var modalDetails = { title: 'Update Store (' + item.quote_no + ')', component: 'modal-update-store', mstate: true, params: { quote: item } };
        this.$store.commit({
          type: 'setModal',
          details: modalDetails
        });

      },
      toggleSign(number) {
        if (number >= 0) {
          return -number;
        } else {
          return Math.abs(number);
        }
      },
      sortBy(type){
        if (this.sortOrders.quote_date ==  1){
          this.sortOrders.quote_date = -1
        }
        else
          this.sortOrders.quote_date = 1

        // sortedQuotes() {
        const order = this.sortOrders[this.sortKey] || 1;
        const quotes = this.quoteSearchList.slice();
        quotes.sort((a, b) => {
          const aVal = new Date(a[this.sortKey]).getTime();
          const bVal = new Date(b[this.sortKey]).getTime();
          return (aVal - bVal) * order;
        });

        this.isDateSortOn = true
        this.isStatusSortOn = false

        this.$store.commit('fncSortedQuotes', quotes);

      },
      sortByStatus() {
        const quot = this.quoteSearchList.map(obj => obj.id);
        this.sortStatus = this.toggleSign(this.sortStatus)
        const order = this.sortStatus
        this.isStatusSortOn = true
        this.isDateSortOn = false

        this.$store.dispatch({
          type: 'fncGetStatusOrder',
          quotes: quot,
          order: order
        });
      },
      fncStoreAudits( quote ) {
        var modalDetails = { title: 'Store Code Audits (' + quote.quote_no + ')', component: 'modal-store-audit', mstate: true, params: { quote: quote } };
        this.$store.commit({
          type: 'setModal',
          details: modalDetails
        });
      },
      fncRunQuoteSearch() {
        setTimeout(function(){
          window.location.reload();
        }, 250)
      },
      fncRefreshQuoteNo( item ) {

        this.$store.dispatch('fncUpdateQuoteNumber', item.id);

      },
      fncCheckCalcItems( item ) {

        /*console.log( item );

        var canDepartmentEdit = this.fncDepartmentCanEdit(item);

        if( canDepartmentEdit == false ) {

          if( item.pricing_total == '0' || item.pricing_total == '0.00' ) {
            return true;
          } else {
            return false;
          }

        } else {
          return true;
        }*/

        if( item.pricing_total == '0' || item.pricing_total == '0.00' ) {
          if( this.surveyList[item.id] != 'undefined' && this.surveyList[item.id] != undefined && this.surveyCalculators[this.surveyListProcess[item.id]] != undefined ) {
            return true;

          }
        }

        return false;

      },
      fncDepartmentCanEdit( item ) {

        for( var d in this.departmentList ) {
          if( this.departmentList[d].id == item.departmentId ) {

            if( this.departmentList[d].hide_quote_edit == '1' || this.departmentList[d].hide_quote_edit == 1 ) {
              for( var s in this.statusList ) {
                if( this.statusList[s].description == item.status ) {
                  if( this.statusList[s].order < this.checkoutStatus ){
                    return true;
                  }
                }
              }
            }
          }
        }

        return false;
      },
      dateChange(){
        this.dateChanged = true
      },
      onTabSelected(index) {
        this.secondTab = index
        localStorage.setItem('secondTab', index);
      },
      tabIsDisabled(key){
        let index
        switch (key) {
          case 'is_initial_engagement_quote' :
            index = '0'
            break
          case 'is_negotiating_customer_approval' :
            index = '1'
            break
          case 'is_manufacturer_fulfilment' :
            index = '2'
            break
          case 'is_cancelled_expired_rejected' :
            index = '3'
            break
        }

        if (index === this.topTab){
          return false
        }
        else{
          if (this.tabs.length !==  0){
            return Object.keys(this.tabs[key]).length === 0
          }
          else
            return true
        }

      },
      onResize(key){
        const temp = this.tabs[key].slice()
        this.tabs_to_display = temp.splice(0, (window.innerWidth/100)-1)
        this.more = temp.splice(0)
        console.log('more', this.more)
      },
      fncCanApplyLeftBorder(key, description){ // is first
        if (Array.isArray(this.tabs[key]) && this.tabs[key].length > 1){
          let firstElement = this.tabs[key][0].description
          if (description === firstElement)
            return true
          else
            return  false
        }
        else{
          let firstKey = Object.keys(this.tabs[key])[0]
          if (firstKey)
            return (this.tabs[key][firstKey].description === description) ? true: false
        }

      },
      fncCanApplyRightBorder(key, description){
        if (Array.isArray(this.tabs[key]) && this.tabs[key].length > 1){
          let last = this.tabs[key].length
          let lastElement = this.tabs[key][last-1].description
          return (description === lastElement) ? true : false
        }else
        {
          //object
          let lastItem = Object.values(this.tabs[key]).pop();
          if (lastItem )
            return (description === lastItem.description) ? true : false
        }

      },
      fncShowSummaryReporting() {
        var modalDetails = { title: 'Summary Reporting', component: 'modal-summary-reporting', mstate: true, params: {} };
        this.$store.commit({
          type: 'setModal',
          details: modalDetails
        });
      },
      fncExportQuotes() {
        this.$store.commit('fncExcelLoading', true);
        this.$store.dispatch({
          type: 'fncDoQuoteReportExcel',
          status: this.objStatus == '' || this.objStatus[0] == 'null' ? 'null' || this.objStatus[0] == 'null' : this.objStatus,
          originator: this.objOriginator == '' || this.objOriginator[0] == 'null' || this.objOriginator[0] == 'null' ? 'null' : this.objOriginator,
          department: this.objDepartment[0] == 'all' || this.objDepartment == '' || this.objDepartment[0] == 'null' || this.objDepartment[0] == 'null' ? 'null' : this.objDepartment,
          customer: this.objCustomerUser == '' || this.objCustomerUser[0] == 'null' || this.objCustomerUser[0] == 'null' ? 'null' : this.objCustomerUser,
          company: this.objCustomerCompany == '' || this.objCustomerCompany[0] == 'null' || this.objCustomerCompany[0] == 'null' ? 'null' : this.objCustomerCompany,
          specifier: this.objSpecifier == '' || this.objSpecifier[0] == 'null' || this.objSpecifier[0] == 'null' ? 'null' : this.objSpecifier,
          vendor: this.objVendor == '' || this.objVendor[0] == 'null' || this.objVendor[0] == 'null' ? 'null' : this.objVendor,
          store: this.objStore[0] == 'all' ||this.objStore == '' || this.objStore[0] == 'null' || this.objStore[0] == 'null' ? 'null' : this.objStore,
          quoteRegion: this.objRegion[0] == 'all' ||this.objRegion == '' || this.objRegion[0] == 'null' || this.objRegion[0] == 'null' ? 'null' : this.objRegion,
          quoteRep: this.objRep[0] == 'all' ||this.objRep == '' || this.objRep[0] == 'null' || this.objRep[0] == 'null' ? 'null' : this.objRep,
          commercial_kam: this.objKam[0] == 'all' ||this.objKam == '' || this.objKam[0] == 'null' || this.objKam[0] == 'null' ? 'null' : this.objKam,
          commercial_originator: this.objcOriginator[0] == 'all' ||this.objcOriginator == '' || this.objcOriginator[0] == 'null' || this.objcOriginator[0] == 'null' ? 'null' : this.objcOriginator,
          quote_type: this.objQuoteType[0] == 'all' ||this.objQuoteType == '' || this.objQuoteType[0] == 'null' || this.objQuoteType[0] == 'null' ? 'null' : this.objQuoteType,
          service_type: this.objServiceType[0] == 'all' ||this.objServiceType == '' || this.objServiceType[0] == 'null' || this.objServiceType[0] == 'null' ? 'null' : this.objQuoteType,
          start_date: localStorage.getItem("quote_start_date"),
          end_date: localStorage.getItem("quote_end_date")
          // selectedTab: this.selectedTab
        })

        /*var reportData = [];
          reportData.push(['QUOTE DATE', 'QUOTE NO.', 'ORIGINATOR TYPE', 'ORIGINATOR', 'CUSTOMER TYPE', 'CUSTOMER', 'CUSTOMER MANAGER', 'DISCOUNT (R/c)', 'SUB TOTAL', 'TAX VALUE', 'GRAND TOTAL', 'STATUS', 'ROJECT REGION', 'ORIGINATOR REGION', 'PROJECT', 'SPECIFIER', 'RESPONSIBLE REP', 'FOLLOW UP']);

        for (var q in this.quoteList) {
          var toPush = [];
          var projectRegion = '-';
          if (this.quoteList[q].project_region != null) {
            projectRegion = this.quoteList[q].project_region.replace(/,/g, ' | ')
          }

          toPush.push(this.quoteList[q].quote_date);
          toPush.push(this.quoteList[q].quote_no);
          toPush.push(this.quoteList[q].orig_type);
          toPush.push(this.quoteList[q].orig_name);
          toPush.push(this.quoteList[q].customer_type);
          toPush.push(this.quoteList[q].customer_name);
          toPush.push(this.quoteList[q].customer_manager);
          toPush.push('R' + this.quoteList[q].discount_val);
          toPush.push('R' + this.quoteList[q].pricing_subtotal);
          toPush.push('R' + this.quoteList[q].pricing_vat);
          toPush.push('R' + this.quoteList[q].pricing_total);
          toPush.push(this.quoteList[q].status);
          toPush.push(projectRegion);
          toPush.push(this.quoteList[q].originator_region);
          toPush.push(this.quoteList[q].project.replace(/,/g, ' | '));
          toPush.push(this.quoteList[q].specifier);
          toPush.push(this.quoteList[q].responsible_representative.replace(/,/g, ' | '));
          toPush.push(this.quoteList[q].pmoc);

          reportData.push( toPush );

        }

        this.$store.dispatch('fncReturnExcel', reportData);*/

      },
      CheckEditableSearch(event){ console.log('CheckEditableSearch '+ event)
        if(event != null && event !== '' ){
            this.EnableSearchQuote = true
          }
        else if ( window.localStorage.reportSearch != null && window.localStorage.reportSearch !== undefined && window.localStorage.reportSearch !== '')
        {
          this.EnableSearchQuote = true
        }
        else
          this.EnableSearchQuote = false
      },
      CheckEditable(event){
          const myObject = JSON.parse(localStorage.getItem('reportSearchQuote'));

          if(event != null && event !== '' ){
            this.EnableSearch = true
          }
          else if( myObject )
            this.EnableSearch = true
          else
            this.EnableSearch = false
      },
      fncSetId( id ) {
        return id;
      },
      fncDotDotDot( str ) {
        if( str.length > 30 ) {
          return str.substr(0,30) + ' ...';
        }
        return str;
      },
      fncEditVendorRecipient( quote ) {

        var modalDetails = { title: 'Update Vendor Recipient (' + quote.quote_no + ')', component: 'modal-set-emails', mstate: true, params: { type: 'vendor', quote: quote } };
        this.$store.commit({
          type: 'setModal',
          details: modalDetails
        });
        // this.$store.dispatch('fncSetCustomerRecipient', quote);
      },
      fncEditCustomerRecipient( quote ) {

        var modalDetails = { title: 'Update Customer Recipient (' + quote.quote_no + ')', component: 'modal-set-emails', mstate: true, params: { type: 'customer', quote: quote } };
        this.$store.commit({
          type: 'setModal',
          details: modalDetails
        });
        // this.$store.dispatch('fncSetCustomerRecipient', quote);
      },
      fncShowVendorUsers( vendorName, quote ) {

          var vendorUsers = [];
          if( this.vendorUserList[vendorName] != null ) {
            vendorUsers = this.vendorUserList[vendorName];
          }

          var modalDetails = { title: 'Quote Vendor Users (' + quote.quote_no + ')', component: 'modal-vendor-users', mstate: true, params: { vendorUsers: vendorUsers } };
          this.$store.commit({
            type: 'setModal',
            details: modalDetails
          });

      },
      fncOpenCalc( quote ) {

        this.$store.dispatch('fncGetCalculators', quote);

        //window.open('https://builders.ndtecappsstaging.co.za/base/www/index.html?rangeredirect=true&id=2600468779&quoteId=' + quote.id, '_blank').focus();
      },
      fncCanClear() {
        if( this.$refs.searchField && this.$refs.searchField.lazyValue != '' ) {
          return true;
        }
        return false;
      },
      fncShowReps(repList, roleObj) {

        if( roleObj.label && roleObj.label != null ) {

          var roleLabel = roleObj.label;
          var subRoles = []

          var repSplit = repList.split( ',');

          for( var r in repSplit ) {
            if( repSplit[r].includes(roleLabel) == true ) {
              subRoles.push( repSplit[r] );
            }
          }

          if( subRoles.length == 0 ) {
            subRoles = ['N/A'];
          }

          subRoles = subRoles.join(',');

          return subRoles.replace(/,/g, "<br />");

        } else {

          //subRoles = subRoles.join(', ');

          if( repList.length > 70 ) {
            return repList.substr(0,70) + '...';
          } else {
            return repList;
          }

          //return repList.replace(/,/g, "<br />");
        }

      },
      fncShowRepsSub(repList, roleObj) {

        if( roleObj.label && roleObj.label != null ) {

          var roleLabel = roleObj.label;
          var subRoles = []

          var repSplit = repList.split( ',');

          for( var r in repSplit ) {

            var subSplit = repSplit[r].split('( ');

            if( subSplit.length > 1 ) {
              var subsubSplit = subSplit[1].split(' )');

              if( subsubSplit[0] == roleLabel ) {
                // if( repSplit[r].includes(roleLabel) == true ) {
                var subRep = repSplit[r].split('(');
                subRoles.push( subRep[0] );
                // subRoles.push( repSplit[r] );
              }
            }
          }

          if( subRoles.length == 0 ) {
            subRoles = ['N/A'];
          }

          subRoles = subRoles.join(', ');

          if( subRoles.length > 70 ) {
            return subRoles.substr(0,70) + '...';
          } else {
            return subRoles;
          }
          //return subRoles.replace(/,/g, "<br />");

        } else {
          if( repList.replace.length > 25 ) {
            return repList.replace.substr(0,25) + '...';
          } else {
            return repList.replace;
          }
          // return repList.replace(/,/g, "<br />");
        }

      },
      fncCheckProcessButton( payload ) {
        for( var s in this.statusList ) {
          if( this.statusList[s].is_checked == 'Yes' && this.statusList[s].description == payload.status ) {
            return true;
          }
        }
        return false;
      },
      fncCheckProcessButtonText( payload ) {
        var hasText = false;
        for( var s in this.statusList ) {
          if( this.statusList[s].is_process_order == 'Yes' && this.statusList[s].description == payload.status ) {
            hasText = true;
            return '&nbsp;Order Processed';
          }
        }
        if( hasText == false ) {
          return '&nbsp;'+payload.status;
        }
      },
      fncSetResponsibleReps( setReps, roleId ) {
        var modalDetails = { title: 'Quote Responsible Reps (' + setReps.quote_no + ')', component: 'modal-set-reps', mstate: true, params: { object: setReps, roleId: roleId } };
        this.$store.commit({
          type: 'setModal',
          details: modalDetails
        });
      },
      fncSetResponsibleKams( setReps ) {
        var modalDetails = { title: 'Quote Commercial KAM (' + setReps.quote_no + ')', component: 'modal-set-kams', mstate: true, params: { quote: setReps, kams: this.commercialKams } };
        this.$store.commit({
          type: 'setModal',
          details: modalDetails
        });
      },
      fncSetResponsibleOriginator( setReps ) {
        var modalDetails = { title: 'Quote Commercial Co-Ordinator (' + setReps.quote_no + ')', component: 'modal-set-originators', mstate: true, params: { quote: setReps, originators: this.commercialOriginators } };
        this.$store.commit({
          type: 'setModal',
          details: modalDetails
        });
      },
      fncCanDisplay( item ) {
        if( this.surveyListQuotes[item.id] == 3 && this.objAuthorize.type == 6 ) {
          return false;
        }
        return true;
      },
      fncNotificationHistory( quoteId ) {

        this.$store.commit('setNotificationHistoryLoaded', false);

        var modalDetails = { title: 'Notification History', component: 'modal-notification-history', mstate: true, params: { quote: quoteId } };
        this.$store.commit({
          type: 'setModal',
          details: modalDetails
        });

        /*this.$store.dispatch({
          type: 'fncNotificationHistory',
          quoteId: quoteId
        });*/
      },
      fncCheckSalesOrder( quote ) {
        if( this.objAuthorize.manufacturer == '385889803' ) {
          return false
        }
        else if( quote.sales_order_number && quote.sales_order_number != '' && quote.sales_order_number != '0' && quote.sales_order_number != 'N/A' ) {
          return true;
        }
        return false;
      },
      fncDownloadPdf(data) {
        for( var v in this.vendorList ) {
          if( this.vendorList[v].id == data.vendorId ) {
            data.vendorDetails = this.vendorList[v]
          }
        }
        this.$store.dispatch('fncDownloadReportSoPdfNew', data);
      },
      fncEditOriginator( quote ) {
        this.$store.dispatch({
          type: 'fncUpdateQuoteOriginator',
          quoteId: quote.id,
          originator: quote.originator
        });
      },
      fncReloadRepUsers( repUsers, selected, index ) {
        /*var repReturn = [];
        for( var r in repUsers ) {
          if( selected.indexOf( repUsers[r].id ) != -1 ) {
            repReturn.push( repUsers[r] );
          }
        }
        this.$refs['respReps'+index][0].items = repReturn;*/
      },
      fncGenerateRef( index ) {
        return 'respReps' + index;
      },
      fncGetRepUsers( quote, repUsers, selected ){

        /*console.log('Quote');
        console.log(quote.responsible_user_list);
        console.log(repUsers);*/

        var repReturn = [];
        // if( selected != undefined && selected != null ) {
          for( var r in quote.responsible_user_list ) {
            // if( selected.indexOf( repUsers[r].id ) != -1 ) {
            repReturn.push( { id: r, fullname: quote.responsible_user_list[r] } );
            // }
          }
        // }
        return repReturn;
      },
      fncGetSearchedQuoteReps( index, repUsers ) {
        this.$refs['respReps'+index][0].items = repUsers;
      },
      fncArchiveQuote( quote ) {
        this.$store.dispatch('fncArchiveQuote', quote.id)
      },
      fncEditSurveyDoc( quoteId ) {
        this.$store.dispatch('fncGetSurveyDocEdits', quoteId)
      },
      fncCloneQuote( quoteId, departmentId ) {
        // this.$store.dispatch('fncGeQuoteDetails', quoteId)
        this.$store.dispatch({
          type: 'fncGeQuoteDetails',
          quoteId: quoteId,
          departmentId: departmentId
        });
      },
      fncDownloadSurveyDoc( quoteId, quoteNo, formType ) {
        // this.$store.dispatch('fncGetSurveyDocDownload', quoteId)
        this.$store.dispatch({
          type: 'fncGetSurveyDocDownload',
          quoteId: quoteId,
          quoteNo: quoteNo,
          users: this.repUsers,
          branches: this.branchList,
          formType: formType
        })
      },
      fncCanEdit( quote ) {
        var canEdit = false;
        for( var s in this.statusList  ) {
          if( this.statusList[s].description == quote.status ) {
            if( s == 0 ) {
              canEdit = true;
            }
          }
        }
        return canEdit;
      },
      fncCheckSurveyDocument( quote ) {
        /*if( this.surveyList[quote.id] != undefined ) {
          return true;
        }
        return false;*/
        return true;
      },
      fncSetRepLabel( objReps ) {
        if( objReps == undefined ) {
          return 'Select Reps';
        }
      },
      fncEditQuoteReps( item ) {
        this.$store.dispatch('fncUpdateQuoteReps', item)
      },
      fncCheckDone( type ) {
        if( type == 'vendor' ) {
          if( this.$refs.vendorSelect !=  undefined && this.$refs.vendorSelect.isActive == true ) {
            return true;
          } else {
            return false;
          }
        } else if( type == 'status' ) {
          if( this.$refs.statusSelect !=  undefined && this.$refs.statusSelect.isActive == true ) {
            return true;
          } else {
            return false;
          }
        } else if( type == 'customer' ) {
          if( this.$refs.customerSelect !=  undefined && this.$refs.customerSelect.isActive == true ) {
            return true;
          } else {
            return false;
          }
        } else if( type == 'originator' ) {
          if( this.$refs.originatorSelect !=  undefined && this.$refs.originatorSelect.isActive == true ) {
            return true;
          } else {
            return false;
          }
        } else if( type == 'store' ) {
          if( this.$refs.storeSelect !=  undefined && this.$refs.storeSelect.isActive == true ) {
            return true;
          } else {
            return false;
          }
        } else if( type == 'department' ) {
          if( this.$refs.departmentSelect !=  undefined && this.$refs.departmentSelect.isActive == true ) {
            return true;
          } else {
            return false;
          }
        } else if( type == 'region' ) {
          if( this.$refs.regionSelect !=  undefined && this.$refs.regionSelect.isActive == true ) {
            return true;
          } else {
            return false;
          }
        } else if( type == 'rep' ) {
          if( this.$refs.repSelect !=  undefined && this.$refs.repSelect.isActive == true ) {
            return true;
          } else {
            return false;
          }
        } else if( type == 'kam' ) {
          if( this.$refs.kamSelect !=  undefined && this.$refs.kamSelect.isActive == true ) {
            return true;
          } else {
            return false;
          }
        } else if( type == 'cOriginator' ) {
          if( this.$refs.cOriginatorSelect !=  undefined && this.$refs.cOriginatorSelect.isActive == true ) {
            return true;
          } else {
            return false;
          }
        } else if( type == 'quote_type' ) {
          if( this.$refs.quoteTypeSelect !=  undefined && this.$refs.quoteTypeSelect.isActive == true ) {
            return true;
          } else {
            return false;
          }
        } else if( type == 'service_type' ) {
          if( this.$refs.serviceTypeSelect !=  undefined && this.$refs.serviceTypeSelect.isActive == true ) {
            return true;
          } else {
            return false;
          }
        } else if( type == 'projects' ) {
          if( this.$refs.projectsSelect !=  undefined && this.$refs.projectsSelect.isActive == true ) {
            return true;
          } else {
            return false;
          }
        } else if( type == 'company' ) {
          if( this.$refs.companySelect !=  undefined && this.$refs.companySelect.isActive == true ) {
            return true;
          } else {
            return false;
          }
        }
      },
      fncCheckChange( checkType ) {
        if( checkType == 'status' ) {
          if( this.$refs.statusSelect.isActive == false ) {
            if( JSON.stringify( this.objStatus ) != localStorage.getItem('cancelStatus') ) {
              if( this.objStatus[0] == 'all' ) {
                if( localStorage.getItem('cancelStatus') == null != undefined && localStorage.getItem('cancelStatus') == null ) {
                  // do nothing
                  this.fncReloadFilters();
                } else {
                  this.fncReloadFilters();
                }
              } else {
                this.fncReloadFilters();
              }
            }
          }
        } else if( checkType == 'customer' ) {
          if( this.$refs.customerSelect.isActive == false ) {
            if( JSON.stringify( this.objCustomerUser ) != localStorage.getItem('cancelCustomer') ) {
              if( this.objCustomerUser[0] == 'all' ) {
                if( localStorage.getItem('cancelCustomer') == null != undefined && localStorage.getItem('cancelCustomer') == null ) {
                  // do nothing
                  this.fncReloadFilters();
                } else {
                  this.fncReloadFilters();
                }
              } else {
                this.fncReloadFilters();
              }
            }
          }
        } else if( checkType == 'originator' ) {
          if( this.$refs.originatorSelect.isActive == false ) {
            if( JSON.stringify( this.objOriginator ) != localStorage.getItem('cancelOriginator') ) {
              if( this.objOriginator[0] == 'all' ) {
                if( localStorage.getItem('cancelOriginator') == null != undefined && localStorage.getItem('cancelOriginator') == null ) {
                  // do nothing
                  this.fncReloadFilters();
                } else {
                  this.fncReloadFilters();
                }
              } else {
                this.fncReloadFilters();
              }
            }
          }
        } else if( checkType == 'store' ) {
          if( this.$refs.storeSelect.isActive == false ) {
            if( JSON.stringify( this.objStore ) != localStorage.getItem('cancelStore') ) {
              if( this.objStore[0] == 'all' ) {
                if( localStorage.getItem('cancelStore') == null != undefined && localStorage.getItem('cancelStore') == null ) {
                  // do nothing
                  this.fncReloadFilters();
                } else {
                  this.fncReloadFilters();
                }
              } else {
                this.fncReloadFilters();
              }
            }
          }
        } else if( checkType == 'vendor' ) {
          if( this.$refs.vendorSelect.isActive == false ) {
            if( JSON.stringify( this.objVendor ) != localStorage.getItem('cancelVendor') ) {
              if( this.objVendor[0] == 'all' ) {
                if( localStorage.getItem('cancelVendor') == null != undefined && localStorage.getItem('cancelVendor') == null ) {
                  // do nothing
                  this.fncReloadFilters();
                } else {
                  this.fncReloadFilters();
                }
              } else {
                this.fncReloadFilters();
              }
            }
          }
        } else if( checkType == 'department' ) {
          if( this.$refs.departmentSelect.isActive == false ) {
            if( JSON.stringify( this.objDepartment ) != localStorage.getItem('cancelDepartment') ) {
              if( this.objDepartment[0] == 'all' ) {
                /*if( localStorage.getItem('cancelDepartment') == null != undefined && localStorage.getItem('cancelDepartment') == null ) {
                  // do nothing
                  this.fncReloadFilters();
                } else {
                  this.fncReloadFilters();
                }*/
                this.fncReloadFilters();
              } else {
                this.fncReloadFilters();
              }
            }
          }
        } else if( checkType == 'region' ) {
          if( this.$refs.regionSelect.isActive == false ) {
            if( JSON.stringify( this.objRegion ) != localStorage.getItem('cancelRegion') ) {
              if( this.objRegion[0] == 'all' ) {
                this.fncReloadFilters();
              } else {
                this.fncReloadFilters();
              }
            }
          }
        } else if( checkType == 'rep' ) {
          if( this.$refs.repSelect.isActive == false ) {
            if( JSON.stringify( this.objRep ) != localStorage.getItem('cancelRep') ) {
              if( this.objRep[0] == 'all' ) {
                this.fncReloadFilters();
              } else {
                this.fncReloadFilters();
              }
            }
          }
        } else if( checkType == 'kam' ) {
          if( this.$refs.kamSelect.isActive == false ) {
            if( JSON.stringify( this.objKam ) != localStorage.getItem('cancelKam') ) {
              if( this.objKam[0] == 'all' ) {
                this.fncReloadFilters();
              } else {
                this.fncReloadFilters();
              }
            }
          }
        } else if( checkType == 'cOriginator' ) {
          if( this.$refs.cOriginatorSelect.isActive == false ) {
            if( JSON.stringify( this.objcOriginator ) != localStorage.getItem('cancelcOriginator') ) {
              if( this.objcOriginator[0] == 'all' ) {
                this.fncReloadFilters();
              } else {
                this.fncReloadFilters();
              }
            }
          }
        } else if( checkType == 'quote_type' ) {
          if( this.$refs.quoteTypeSelect.isActive == false ) {
            if( JSON.stringify( this.objQuoteType ) != localStorage.getItem('cancelQuoteType') ) {
              if( this.objQuoteType[0] == 'all' ) {
                this.fncReloadFilters();
              } else {
                this.fncReloadFilters();
              }
            }
          }
        } else if( checkType == 'service_type' ) {
          if( this.$refs.serviceTypeSelect.isActive == false ) {
            if( JSON.stringify( this.objServiceType ) != localStorage.getItem('cancelServiceType') ) {
              if( this.objServiceType[0] == 'all' ) {
                this.fncReloadFilters();
              } else {
                this.fncReloadFilters();
              }
            }
          }
        } else if( checkType == 'projects' ) {
          if( this.$refs.projectsSelect.isActive == false ) {
            if( JSON.stringify( this.objProjects ) != localStorage.getItem('cancelProjects') ) {
              if( this.objProjects[0] == 'all' ) {
                this.fncReloadFilters();
              } else {
                this.fncReloadFilters();
              }
            }
          }
        } else if( checkType == 'company' ) {
          if( this.$refs.companySelect.isActive == false ) {
            if( JSON.stringify( this.objCompany ) != localStorage.getItem('cancelCompany') ) {
              if( this.objCompanies[0] == 'all' ) {
                this.fncReloadFilters();
              } else {
                this.fncReloadFilters();
              }
            }
          }
        }
      },
      fncClearLabels( type ) {
        if( type == 'originator' ) {
          this.hideOriginatorLabels = true;
        }
      },
      fncShowLabels( type ) {
        if( type == 'originator' ) {
          this.hideOriginatorLabels = false;
        }
      },
      fncShowPaginationRecords() {

        var startPage = ( this.page * 10 ) - 9;
        var endPage = ( this.page * 10 );

        if( endPage > this.totalQuoteRecords ) {
          endPage = this.totalQuoteRecords;
        }

        return '<p>Viewing '+startPage+' - '+endPage+' of ' + this.totalQuoteRecords + ' records</p>';
      },
      fncClearFilterShadows() {
        this.dateFilterShow = false;
        this.vendorFilterShow = false;
        this.departmentFilterShow = false;
        this.storeFilterShow = false;
        this.originatorFilterShow = false;
        this.customerFilterShow = false;
        this.statusFilterShow = false;
        this.regionFilterShow = false;
        this.repFilterShow = false;
        this.showVendorClose = false;
      },
		fncCloseDrawer() {
			// this.filterDrawer = false;

      if( window.localStorage.cancelVendor != undefined && window.localStorage.cancelVendor != null ) {
        localStorage.setItem('reportVendors', localStorage.getItem('cancelVendor'));
      }

      if( window.localStorage.cancelStore != undefined && window.localStorage.cancelStore != null ) {
        localStorage.setItem('reportStores', localStorage.getItem('cancelStore'));
      }

      if( window.localStorage.cancelDepartment != undefined && window.localStorage.cancelDepartment != null ) {
        localStorage.setItem('reportDepartments', localStorage.getItem('cancelDepartment'));
      }

      if( window.localStorage.cancelOriginator != undefined && window.localStorage.cancelOriginator != null ) {
        localStorage.setItem('reportOriginators', localStorage.getItem('cancelOriginator'));
      }

      if( window.localStorage.cancelCustomer != undefined && window.localStorage.cancelCustomer != null ) {
        localStorage.setItem('cancelCustomer', localStorage.getItem('cancelCustomer'));
      }

      if( window.localStorage.cancelStatus != undefined && window.localStorage.cancelStatus != null ) {
        localStorage.setItem('reportStatus', localStorage.getItem('cancelStatus'));
      }

      if( window.localStorage.cancelKam != undefined && window.localStorage.cancelKam != null ) {
        localStorage.setItem('reportKams', localStorage.getItem('cancelKam'));
      }

      if( window.localStorage.cancelcOriginator != undefined && window.localStorage.cancelcOriginator != null ) {
        localStorage.setItem('reportcOriginator', localStorage.getItem('cancelcOriginator'));
      }

      if( window.localStorage.cancelQuoteType != undefined && window.localStorage.cancelQuoteType != null ) {
        localStorage.setItem('reportQuoteType', localStorage.getItem('cancelQuoteType'));
      }

      if( window.localStorage.cancelServiceType != undefined && window.localStorage.cancelServiceType != null ) {
        localStorage.setItem('reportServiceType', localStorage.getItem('cancelServiceType'));
      }

      if( window.localStorage.cancelReportDate != undefined && window.localStorage.cancelReportDate != null ) {
        var newReportDate = localStorage.getItem('cancelReportDate').split(',');
        if( newReportDate[0] == '1900-01-01' ) {
          newReportDate[0] = '';
        }
        localStorage.setItem('reportDates', newReportDate.toString());
        //localStorage.setItem('reportDates', localStorage.getItem('cancelReportDate'));
        this.reportDate = newReportDate;
        localStorage.setItem('quote_start_date', newReportDate[0].toString());
        localStorage.setItem('quote_end_date', newReportDate[1].toString());

        //this.reportDate = localStorage.getItem('cancelReportDate');
      }

      if( window.localStorage.cancelQuoteSetDays != undefined && window.localStorage.cancelQuoteSetDays != null ) {
        localStorage.setItem('quoteSetDays', localStorage.getItem('cancelQuoteSetDays'));
      }

      this.filterDrawer = false;
      localStorage.removeItem('secondTab')
      console.log('filterDrawer')
      this.secondTab = null
      // do a reload
      /*setTimeout(function() {
        // location.reload();
        this.filterDrawer = false;
      }, 500)*/


		},
      fncHideAllPops() {
        this.dateFilterShow = false;
        this.vendorFilterShow = false;
        this.departmentFilterShow = false;
        this.storeFilterShow = false;
        this.originatorFilterShow = false;
        this.customerFilterShow = false;
        this.statusFilterShow = false;
        this.regionFilterShow = false;
        this.repFilterShow = false;
        this.showVendorClose = false;
      },
      fncDisplayBottomTabValue(topKey,bottomKey)
      {
        for (const [key, value] of Object.entries(this.topTabsCount)) {
          for (const [secondKey, data] of Object.entries(this.topTabsCount[key])) {
            if (data.hasOwnProperty(0)) {
                for (const [thirdKey, tab] of Object.entries(data[0])) {
                  if (data[0][thirdKey].hasOwnProperty(bottomKey)) {
                    return 'R'+ data[0][thirdKey][bottomKey].total
                  }
                }
            }

          }
        }
      },
      fncDisplayBottomTabCount(topKey,bottomKey)
      {
        for (const [key, value] of Object.entries(this.topTabsCount)) {
          for (const [secondKey, data] of Object.entries(this.topTabsCount[key])) {
            if (data.hasOwnProperty(0)) {
              for (const [thirdKey, tab] of Object.entries(data[0])) {
                if (data[0][thirdKey].hasOwnProperty(bottomKey)) {
                  return data[0][thirdKey][bottomKey].total_count
                }
              }
            }

          }
        }
      },
      fncDisplayTopTabValue(topKey)
      {
        if (this.topTabsCount !== undefined && Object.keys(this.topTabsCount).length !== 0){
          for (const [key, value] of Object.entries(this.topTabsCount)) {
            for (const [secondKey, data] of Object.entries(this.topTabsCount[key])) {
              if (secondKey === topKey){
                if (this.topTabsCount[key][secondKey].total === 0)
                  return  'R0.0'
                else{

                  return 'R'+ this.topTabsCount[key][secondKey].total
                }
              }
            }
          }
      }
        return  'R0.0'
      },
      fncDisplayTopTabCount(topKey)
      {
        for (const [key, value] of Object.entries(this.topTabsCount)) {
          for (const [secondKey, data] of Object.entries(this.topTabsCount[key])) {
            if (secondKey === topKey){
              return this.topTabsCount[key][secondKey].total_count
            }
          }
        }
        return 0
      },
      fncShowFilterPop(headerText) {
        if( headerText == 'Quote Date' ) {
          this.dateFilterShow = false;
        }
        if( headerText == 'Vendor' ) {
          if( this.objVendor.length > 0 && this.objVendor[0] != 'all' ) {
            this.vendorFilterShow = this.vendorFilterShow == false ? true : false;
          } else {
            this.vendorFilterShow = false;
          }
        }
        if( headerText == 'Department' ) {
          if( this.objDepartment.length > 0 && this.objDepartment[0] != 'all' ) {
            this.departmentFilterShow = this.departmentFilterShow == false ? true : false;
          } else {
            this.departmentFilterShow = false;
          }
        }
        if( headerText == 'Store' ) {
          if( this.objStore.length > 0 && this.objStore[0] != 'all' ) {
            this.storeFilterShow = this.storeFilterShow == false ? true : false;
          } else {
            this.storeFilterShow = false;
          }
        }
        if( headerText == 'Originator Name' ) {
          if( this.objOriginator.length > 0 && this.objOriginator[0] != 'all' ) {
            this.originatorFilterShow = this.originatorFilterShow == false ? true : false;
          } else {
            this.originatorFilterShow = false;
          }
        }
        if( headerText == 'Customer Name' ) {
          if( this.objCustomerUser.length > 0 && this.objCustomerUser[0] != 'all' ) {
            this.customerFilterShow = this.customerFilterShow == false ? true : false;
          } else {
            this.customerFilterShow = false;
          }
        }
        if( headerText == 'Status' ) {
          this.statusFilterShow = false;
          // if( this.objStatus.length > 0 && this.objStatus[0] != 'all' ) {
          //   this.statusFilterShow = this.statusFilterShow == false ? true : false;
          // } else {
          //   this.statusFilterShow = false;
          // }
        }
        if( headerText == 'Region' ) {
          if( this.objRegion.length > 0 && this.objRegion[0] != 'all' ) {
            this.regionFilterShow = this.regionFilterShow == false ? true : false;
          } else {
            this.regionFilterShow = false;
          }
        }
        if( headerText == 'Responsible Rep' ) {
          if( this.objRep.length > 0 && this.objRep[0] != 'all' ) {
            this.repFilterShow = this.repFilterShow == false ? true : false;
          } else {
            this.repFilterShow = false;
          }
        }

      },
      fncSetDateEmpty() {
        localStorage.setItem('quoteSetDays', '');
        this.fncReloadFilters();
        /*this.regenFalse = false;
        this.$store.commit('fncFilterNeedsReload', true);
        this.$store.dispatch({
          type: 'fncPopulateDashboard',
          date_from: 'null',
          date_to: 'null',
          region: 'null',
          status: this.objStatus,
          originator: this.objOriginator,
          customer: this.objCustomerUser,
          store: this.objStore,
          vendor: this.objVendor,
          project: 'null',
          company: 'null',
          specifier: 'null',
          refresh: true,
          start_date: this.reportDate[0],
          end_date: this.reportDate[1],
          ignoreFilters: true,
          filter_only: true,
          search: this.search
        })*/
      },
      fncSearchLabel() {
        if(
          ( ( this.objVendor.length > 0 && this.objVendor[0] != 'all' ) ||
            ( this.objStore.length > 0 && this.objStore[0] != 'all' ) ||
            ( this.objDepartment.length > 0 && this.objDepartment[0] != 'all' ) ||
            ( this.objOriginator.length > 0 && this.objOriginator[0] != 'all' ) ||
            ( this.objCustomerUser.length > 0 && this.objCustomerUser[0] != 'all' ) ||
            ( this.objStatus.length > 0 && this.objStatus[0] != 'all' ) ) ||
            ( this.reportDate[0] != '' ) ||
            ( this.reportDate[1] != '' )
        ) {
          return 'Search Current Filtered Quotes';
        } else {
          return 'Search All Quotes';
        }

      },
      fncQuoteSearchLabel() {
        return 'Quote Number';
      },
      fncCheckHeaderFilter( headerText ) {
        if( headerText == 'Quote Date' ) {
          if( this.reportDate != '' && ( this.reportDate[0] != '' || this.reportDate[1] != '' ) ) {
            return '<span class="rowHasFilter">'+headerText.toUpperCase()+'<i style="font-size: 16px !important; padding-left: 6px;position: relative; top: 3px;" class="material-icons">filter_alt</i></span>';
          } else {
            return '<span>'+headerText+'</span>';
          }
        } else if( headerText == 'Vendor' ) {
          if( this.objVendor.length > 0 && this.objVendor[0] != 'all' ) {
            return '<span class="rowHasFilter">'+headerText.toUpperCase()+'<i style="font-size: 16px !important; padding-left: 6px;position: relative; top: 3px;" class="material-icons">filter_alt</i></span>';
          } else {
            return '<span>'+headerText+'</span>';
          }
        } else if( headerText == 'Store' ) {
          if( this.objStore.length > 0 && this.objStore[0] != 'all' ) {
            return '<span class="rowHasFilter">'+headerText.toUpperCase()+'<i style="font-size: 16px !important; padding-left: 6px;position: relative; top: 3px;" class="material-icons">filter_alt</i></span>';
          } else {
            return '<span>'+headerText+'</span>';
          }
        } else if( headerText == 'Originator Name' ) {
          if( this.objOriginator.length > 0 && this.objOriginator[0] != 'all' ) {
            return '<span class="rowHasFilter">'+headerText.toUpperCase()+'<i style="font-size: 16px !important; padding-left: 6px;position: relative; top: 3px;" class="material-icons">filter_alt</i></span>';
          } else {
            return '<span>'+headerText+'</span>';
          }
        } else if( headerText == 'Customer Name' ) {
          if( this.objCustomerUser.length > 0 && this.objCustomerUser[0] != 'all' ) {
            return '<span class="rowHasFilter">'+headerText.toUpperCase()+'<i style="font-size: 16px !important; padding-left: 6px;position: relative; top: 3px;" class="material-icons">filter_alt</i></span>';
          } else {
            return '<span>'+headerText+'</span>';
          }
        } else if( headerText == 'Status' ) {
          if( this.objStatus.length > 0 && this.objStatus[0] != 'all' ) {
            return '<span class="rowHasFilter">'+headerText.toUpperCase()+'<i style="font-size: 16px !important; padding-left: 6px;position: relative; top: 3px;" class="material-icons">filter_alt</i></span>';
          } else {
            return '<span>'+headerText+'</span>';
          }
        } else if( headerText == 'Responsible Rep' ) {
          if( this.objRep.length > 0 && this.objRep[0] != 'all' ) {
            return '<span class="rowHasFilter">'+headerText.toUpperCase()+'<i style="font-size: 16px !important; padding-left: 6px;position: relative; top: 3px;" class="material-icons">filter_alt</i></span>';
          } else {
            return '<span>'+headerText+'</span>';
          }
        } else if( headerText == 'Kam Region' ) {
          if (this.objRegion.length > 0 && this.objRegion[0] != 'all') {
            return '<span class="rowHasFilter">' + headerText.toUpperCase() + '<i style="font-size: 16px !important; padding-left: 6px;position: relative; top: 3px;" class="material-icons">filter_alt</i></span>';
          } else {
            return '<span>' + headerText + '</span>';
          }
        } else if( headerText == 'Department' ) {
            if( this.objDepartment.length > 0 && this.objDepartment[0] != 'all' ) {
              return '<span class="rowHasFilter">'+headerText.toUpperCase()+'<i style="font-size: 16px !important; padding-left: 6px;position: relative; top: 3px;" class="material-icons">filter_alt</i></span>';
            } else {
              return '<span>'+headerText+'</span>';
            }
          } else {
          return headerText;
        }
      },
      fncShowColumns() {
        var modalDetails = { title: 'Filter Columns', component: 'modal-filter-columns', mstate: true, params: {} };
        this.$store.commit({
          type: 'setModal',
          details: modalDetails
        });
      },
      fncCreateLead(){
        this.$store.commit('fncSetUserLoading', true);
        this.$store.dispatch('fncPopulateUserRegions');
        this.$store.dispatch('fncPopulateUserVendors');
        this.$store.dispatch('fncSetupUserCreate', 'user');
        this.$store.dispatch({
          type: 'fncGeLeadDetails'
        });
      },
      getTab(description) {
        this.selectedStatus = description
        //this.fncGenerateReportSelectedTab(description)
        this.fncCheckDropdowns('status');
        this.fncSearchNewQuotes(false,true);
      },

      getTabs(key){
        this.secondTab = null
        localStorage.removeItem("secondTab")
        this.selectedStatus = null
       // //
        if ( localStorage.getItem('reportStatus') !== null){
       //    this.objStatus = []
       //    let arr = []
       //    this.chageTopreviousTab = false
       //
       //    for (let i = 0; i < this.tabs[key].length; i++) {
       //      arr.push(this.tabs[key][i]['description'])
       //    }
          this.objStatus = JSON.parse(localStorage.getItem('reportStatus'));

          this.fncCheckDropdowns('status');
          this.fncSearchNewQuotes(false,true);
       }
        else {
          this.objStatus =['all']
          this.fncCheckDropdowns('status');
          this.fncSearchNewQuotes(false,true);
          //this.fncReloadQuotes()
        }


      },
      fncReloadQuotes() {
        this.$store.commit('fncEmptyQuoteList');
        this.$store.commit('fncSetQuoteReportLoaded', false);
        this.$store.dispatch({
          type: 'fncPopulateQuoteList',
          date_from: this.startDate == '' || this.startDate == undefined ? 'null' : this.startDate,
          date_to: this.endDate == '' || this.endDate == undefined ? 'null' : this.endDate,
          region: this.objCustomerRegion == '' || this.objCustomerRegion[0] == 'null' ? 'null' : this.objCustomerRegion,
          status: this.objStatus == '' || this.objStatus[0] == 'null' ? 'null' || this.objStatus[0] == 'null' : this.objStatus,
          originator: this.objOriginator == '' || this.objOriginator[0] == 'null' || this.objOriginator[0] == 'null' ? 'null' : this.objOriginator,
          customer: this.objCustomerUser == '' || this.objCustomerUser[0] == 'null' || this.objCustomerUser[0] == 'null' ? 'null' : this.objCustomerUser,
          project: this.objProject == '' || this.objProject[0] == 'null' || this.objProject[0] == 'null' ? 'null' : this.objProject,
          projects: this.objProjects == '' || this.objProjects[0] == 'null' || this.objProjects[0] == 'null' ? 'null' : this.objProjects,
          company: this.objCompany == '' || this.objCompany[0] == 'null' || this.objCompany[0] == 'null' ? 'null' : this.objCompany,
          //company: this.objCustomerCompany == '' || this.objCustomerCompany[0] == 'null' || this.objCustomerCompany[0] == 'null' ? 'null' : this.objCustomerCompany,
          specifier: this.objSpecifier == '' || this.objSpecifier[0] == 'null' || this.objSpecifier[0] == 'null' ? 'null' : this.objSpecifier,
          reload: true,
          start_date: localStorage.getItem("quote_start_date"),
          end_date: localStorage.getItem("quote_end_date")
        })
      },
      fncCheckDropdowns(type) {
        this.regenFalse = false;
        var newFilter = [];
        var isAll = false;
        var addedObj = false;
        if( type == 'department' ) {
          for( var v in this.objDepartment ) {
            if( this.objDepartment[v] == 'all' ) {
              isAll = true;
            }
          }
          var lastClicked = this.objDepartment[this.objDepartment.length -1];
          if( isAll == true && this.objDepartment.length == 1 ) {
            newFilter.push('all');
            addedObj = true;
          } else if( lastClicked == 'all' ) {
            newFilter.push('all');
            addedObj = true;
          } else {
            for( var v in this.objDepartment ) {
              if (this.objDepartment[v] != 'all') {
                newFilter.push(this.objDepartment[v]);
                addedObj = true;
              }
            }
          }
          if( addedObj == false ) {
            newFilter.push('all');
          }
          this.objDepartment = newFilter;
        } else if( type == 'vendor' ) {
          for( var v in this.objVendor ) {
            if( this.objVendor[v] == 'all' ) {
              isAll = true;
            }
          }
          var lastClicked = this.objVendor[this.objVendor.length -1];
          if( isAll == true && this.objVendor.length == 1 ) {
            newFilter.push('all');
            addedObj = true;
          } else if( lastClicked == 'all' ) {
            newFilter.push('all');
            addedObj = true;
          } else {
            for( var v in this.objVendor ) {
              if (this.objVendor[v] != 'all') {
                newFilter.push(this.objVendor[v]);
                addedObj = true;
              }
            }
          }
          if( addedObj == false ) {
            newFilter.push('all');
          }
          this.objVendor = newFilter;
        } else if( type == 'store' ) {
          for( var s in this.objStore ) {
            if( this.objStore[s] == 'all' ) {
              isAll = true;
            }
          }
          var lastClicked = this.objStore[this.objStore.length -1];
          if( isAll == true && this.objStore.length == 1 ) {
            newFilter.push('all');
            addedObj = true;
          } else if( lastClicked == 'all' ) {
            newFilter.push('all');
            addedObj = true;
          } else {
            for( var s in this.objStore ) {
              if (this.objStore[s] != 'all') {
                newFilter.push(this.objStore[s]);
                addedObj = true;
              }
            }
          }
          if( addedObj == false ) {
            newFilter.push('all');
          }
          this.objStore = newFilter;
        } else if( type == 'originator' ) {

          this.hideOriginatorLabels = true;

          for( var o in this.objOriginator ) {
            if( this.objOriginator[o] == 'all' ) {
              isAll = true;
            }
          }
          var lastClicked = this.objOriginator[this.objOriginator.length -1];
          if( isAll == true && this.objOriginator.length == 1 ) {
            newFilter.push('all');
            addedObj = true;
          } else if( lastClicked == 'all' ) {
            newFilter.push('all');
            addedObj = true;
          } else {
            for( var o in this.objOriginator ) {
              if (this.objOriginator[o] != 'all') {
                newFilter.push(this.objOriginator[o]);
                addedObj = true;
              }
            }
          }
          if( addedObj == false ) {
            newFilter.push('all');
          }
          this.objOriginator = newFilter;
        } else if( type == 'customer' ) {
          for( var c in this.objCustomerUser ) {
            if( this.objCustomerUser[c] == 'all' ) {
              isAll = true;
            }
          }
          var lastClicked = this.objCustomerUser[this.objCustomerUser.length -1];
          if( isAll == true && this.objCustomerUser.length == 1 ) {
            newFilter.push('all');
            addedObj = true;
          } else if( lastClicked == 'all' ) {
            newFilter.push('all');
            addedObj = true;
          } else {
            for( var c in this.objCustomerUser ) {
              if (this.objCustomerUser[c] != 'all') {
                newFilter.push(this.objCustomerUser[c]);
                addedObj = true;
              }
            }
          }
          if( addedObj == false ) {
            newFilter.push('all');
          }
          this.objCustomerUser = newFilter;
        } else if( type == 'status' ) {
          for( var s in this.objStatus ) {
            if( this.objStatus[s] == 'all' ) {
              isAll = true;
            }
          }
          var lastClicked = this.objStatus[this.objStatus.length -1];
          if( isAll == true && this.objStatus.length == 1 ) {
            newFilter.push('all');
            addedObj = true;
          } else if( lastClicked == 'all' ) {
            newFilter.push('all');
            addedObj = true;
          } else {
            for( var s in this.objStatus ) {
              if (this.objStatus[s] != 'all') {
                newFilter.push(this.objStatus[s]);
                addedObj = true;
              }
            }
          }
          if( addedObj == false ) {
            newFilter.push('all');
          }
          this.objStatus = newFilter;
        } else if( type == 'region' ) {
          for( var s in this.objRegion ) {
            if( this.objRegion[s] == 'all' ) {
              isAll = true;
            }
          }
          var lastClicked = this.objRegion[this.objRegion.length -1];
          if( isAll == true && this.objRegion.length == 1 ) {
            newFilter.push('all');
            addedObj = true;
          } else if( lastClicked == 'all' ) {
            newFilter.push('all');
            addedObj = true;
          } else {
            for( var s in this.objRegion ) {
              if (this.objRegion[s] != 'all') {
                newFilter.push(this.objRegion[s]);
                addedObj = true;
              }
            }
          }
          if( addedObj == false ) {
            newFilter.push('all');
          }
          this.objRegion = newFilter;
        } else if( type == 'rep' ) {
          for( var s in this.objRep ) {
            if( this.objRep[s] == 'all' ) {
              isAll = true;
            }
          }
          var lastClicked = this.objRep[this.objRep.length -1];
          if( isAll == true && this.objRep.length == 1 ) {
            newFilter.push('all');
            addedObj = true;
          } else if( lastClicked == 'all' ) {
            newFilter.push('all');
            addedObj = true;
          } else {
            for( var s in this.objRep ) {
              if (this.objRep[s] != 'all') {
                newFilter.push(this.objRep[s]);
                addedObj = true;
              }
            }
          }
          if( addedObj == false ) {
            newFilter.push('all');
          }
          this.objRep = newFilter;
        } else if( type == 'kam' ) {
          for( var c in this.objKam ) {
            if( this.objKam[c] == 'all' ) {
              isAll = true;
            }
          }
          var lastClicked = this.objKam[this.objKam.length -1];
          if( isAll == true && this.objKam.length == 1 ) {
            newFilter.push('all');
            addedObj = true;
          } else if( lastClicked == 'all' ) {
            newFilter.push('all');
            addedObj = true;
          } else {
            for( var c in this.objKam ) {
              if (this.objKam[c] != 'all') {
                newFilter.push(this.objKam[c]);
                addedObj = true;
              }
            }
          }
          if( addedObj == false ) {
            newFilter.push('all');
          }
          this.objKam = newFilter;
        } else if( type == 'cOriginator' ) {
          for( var c in this.objcOriginator ) {
            if( this.objcOriginator[c] == 'all' ) {
              isAll = true;
            }
          }
          var lastClicked = this.objcOriginator[this.objcOriginator.length -1];
          if( isAll == true && this.objcOriginator.length == 1 ) {
            newFilter.push('all');
            addedObj = true;
          } else if( lastClicked == 'all' ) {
            newFilter.push('all');
            addedObj = true;
          } else {
            for( var c in this.objcOriginator ) {
              if (this.objcOriginator[c] != 'all') {
                newFilter.push(this.objcOriginator[c]);
                addedObj = true;
              }
            }
          }
          if( addedObj == false ) {
            newFilter.push('all');
          }
          this.objcOriginator = newFilter;
        } else if( type == 'quote_type' ) {
          for( var c in this.objQuoteType ) {
            if( this.objQuoteType[c] == 'all' ) {
              isAll = true;
            }
          }
          var lastClicked = this.objQuoteType[this.objQuoteType.length -1];
          if( isAll == true && this.objQuoteType.length == 1 ) {
            newFilter.push('all');
            addedObj = true;
          } else if( lastClicked == 'all' ) {
            newFilter.push('all');
            addedObj = true;
          } else {
            for( var c in this.objQuoteType ) {
              if (this.objQuoteType[c] != 'all') {
                newFilter.push(this.objQuoteType[c]);
                addedObj = true;
              }
            }
          }
          if( addedObj == false ) {
            newFilter.push('all');
          }
          this.objQuoteType = newFilter;
        } else if( type == 'service_type' ) {
          for( var c in this.objServiceType ) {
            if( this.objServiceType[c] == 'all' ) {
              isAll = true;
            }
          }
          var lastClicked = this.objServiceType[this.objServiceType.length -1];
          if( isAll == true && this.objServiceType.length == 1 ) {
            newFilter.push('all');
            addedObj = true;
          } else if( lastClicked == 'all' ) {
            newFilter.push('all');
            addedObj = true;
          } else {
            for( var c in this.objServiceType ) {
              if (this.objServiceType[c] != 'all') {
                newFilter.push(this.objServiceType[c]);
                addedObj = true;
              }
            }
          }
          if( addedObj == false ) {
            newFilter.push('all');
          }
          this.objServiceType = newFilter;
        } else if( type == 'projects' ) {
          for( var c in this.objProjects ) {
            if( this.objProjects[c] == 'all' ) {
              isAll = true;
            }
          }
          var lastClicked = this.objProjects[this.objProjects.length -1];
          if( isAll == true && this.objProjects.length == 1 ) {
            newFilter.push('all');
            addedObj = true;
          } else if( lastClicked == 'all' ) {
            newFilter.push('all');
            addedObj = true;
          } else {
            for( var c in this.objProjects ) {
              if (this.objProjects[c] != 'all') {
                newFilter.push(this.objProjects[c]);
                addedObj = true;
              }
            }
          }
          if( addedObj == false ) {
            newFilter.push('all');
          }
          this.objProjects = newFilter;
        } else if( type == 'company' ) {
          for( var c in this.objCompany ) {
            if( this.objCompany[c] == 'all' ) {
              isAll = true;
            }
          }
          var lastClicked = this.objCompany[this.objCompany.length -1];
          if( isAll == true && this.objCompany.length == 1 ) {
            newFilter.push('all');
            addedObj = true;
          } else if( lastClicked == 'all' ) {
            newFilter.push('all');
            addedObj = true;
          } else {
            for( var c in this.objCompany ) {
              if (this.objCompany[c] != 'all') {
                newFilter.push(this.objCompany[c]);
                addedObj = true;
              }
            }
          }
          if( addedObj == false ) {
            newFilter.push('all');
          }
          this.objCompany = newFilter;
        }
        // this.fncReloadFilters();
      },
      fncReloadFilters() {
        this.$store.commit('fncFilterNeedsReload', true);
        this.fncShowFilterSlideSub();
      },
      fncShowFilterSlide( slideOut = true ) {

        if( this.filterNeedsReload == true ) {

        // what we need to do here is to duplicate the current local storages and make sure that we can revert when cancelled
        var cancelVendor = ['all'];
        if (window.localStorage.reportVendors != undefined && window.localStorage.reportVendors != null) {
          cancelVendor = window.localStorage.reportVendors;
          localStorage.setItem('cancelVendor', cancelVendor);
        } else {
          localStorage.removeItem('cancelVendor');
        }

        var cancelStore = ['all'];
        if (window.localStorage.reportStores != undefined && window.localStorage.reportStores != null) {
          cancelStore = window.localStorage.reportStores;
          localStorage.setItem('cancelStore', cancelStore);
        } else {
          localStorage.removeItem('cancelStore');
        }

        var cancelDepartment = ['all'];
        if (window.localStorage.reportDepartments != undefined && window.localStorage.reportDepartments != null) {
          cancelDepartment = window.localStorage.reportDepartments;
          localStorage.setItem('cancelDepartment', cancelDepartment);
        } else {
          localStorage.removeItem('cancelDepartment');
        }

        var cancelOriginator = ['all'];
        if (window.localStorage.reportOriginators != undefined && window.localStorage.reportOriginators != null) {
          cancelOriginator = window.localStorage.reportOriginators;
          localStorage.setItem('cancelOriginator', cancelOriginator);
        } else {
          localStorage.removeItem('cancelOriginator');
        }

        var cancelCustomer = ['all'];
        if (window.localStorage.reportUsers != undefined && window.localStorage.reportUsers != null) {
          cancelCustomer = window.localStorage.reportUsers;
          localStorage.setItem('cancelCustomer', cancelCustomer);
        } else {
          localStorage.removeItem('cancelCustomer');
        }

        var cancelStatus = ['all'];
        if (window.localStorage.reportStatus != undefined && window.localStorage.reportStatus != null) {
          cancelStatus = window.localStorage.reportStatus;
          localStorage.setItem('cancelStatus', cancelStatus);
        } else {
          localStorage.removeItem('cancelStatus');
        }

        var cancelKam = ['all'];
        if (window.localStorage.reportKams != undefined && window.localStorage.reportKams != null) {
          cancelKam = window.localStorage.cancelKam;
          localStorage.setItem('cancelKam', cancelKam);
        } else {
          localStorage.removeItem('cancelKam');
        }

        var cancelQuoteType = ['all'];
        if (window.localStorage.reportQuoteType != undefined && window.localStorage.reportQuoteType != null) {
          cancelQuoteType = window.localStorage.cancelQuoteType;
          localStorage.setItem('cancelQuoteType', cancelQuoteType);
        } else {
          localStorage.removeItem('cancelQuoteType');
        }

        var cancelServiceType = ['all'];
        if (window.localStorage.reportServiceType != undefined && window.localStorage.reportServiceType != null) {
          cancelServiceType = window.localStorage.cancelServiceType;
          localStorage.setItem('cancelServiceType', cancelServiceType);
        } else {
          localStorage.removeItem('cancelServiceType');
        }

        var cancelProjects = ['all'];
        if (window.localStorage.reportProjects != undefined && window.localStorage.reportProjects != null) {
          cancelProjects = window.localStorage.cancelProjects;
          localStorage.setItem('cancelProjects', cancelProjects);
        } else {
          localStorage.removeItem('cancelProjects');
        }

        var cancelCompany = ['all'];
        if (window.localStorage.reportCompany != undefined && window.localStorage.reportCompany != null) {
          cancelCompany = window.localStorage.cancelCompany;
          localStorage.setItem('cancelCompany', cancelCompany);
        } else {
          localStorage.removeItem('cancelCompany');
        }

        var cancelcOriginator = ['all'];
        if (window.localStorage.reportcOriginator != undefined && window.localStorage.reportcOriginator != null) {
          cancelcOriginator = window.localStorage.cancelKam;
          localStorage.setItem('cancelcOriginator', cancelcOriginator);
        } else {
          localStorage.removeItem('cancelcOriginator');
        }

        var cancelReportDate = [];
        if (window.localStorage.reportDates != undefined && window.localStorage.reportDates != null) {
          cancelReportDate = window.localStorage.reportDates;
          localStorage.setItem('cancelReportDate', cancelReportDate);
        } else {
          localStorage.removeItem('cancelReportDate');
        }

        var cancelQuoteSetDays = 0;
        if (window.localStorage.quoteSetDays != undefined && window.localStorage.quoteSetDays != null) {
          cancelQuoteSetDays = window.localStorage.quoteSetDays;
          localStorage.setItem('cancelQuoteSetDays', cancelQuoteSetDays);
        } else {
          // localStorage.setItem('cancelQuoteSetDays', cancelQuoteSetDays);
          localStorage.removeItem('cancelQuoteSetDays');
        }

        var cancelRegions = ['all'];
        if (window.localStorage.reportRegions != undefined && window.localStorage.reportRegions != null) {
          cancelRegions = window.localStorage.reportRegions;
          localStorage.setItem('cancelRegions', cancelRegions);
        } else {
          localStorage.removeItem('cancelRegions');
        }

        var cancelReps = ['all'];
        if (window.localStorage.reportReps != undefined && window.localStorage.reportReps != null) {
          cancelReps = window.localStorage.reportReps;
          localStorage.setItem('cancelReps', cancelReps);
        } else {
          localStorage.removeItem('cancelReps');
        }

        this.regenFalse = true;

        localStorage.removeItem('reportSearch');
        this.search = ''
        this.dateFilterShow = false;
        this.vendorFilterShow = false;
        this.departmentFilterShow = false;
        this.storeFilterShow = false;
        this.originatorFilterShow = false;
        this.customerFilterShow = false;
        this.statusFilterShow = false;
        this.regionFilterShow = false;
        this.repFilterShow = false;
        this.showVendorClose = false;

        if (slideOut == true) {
          this.filterDrawer = true;
        }

        // this.$store.commit('fncFilterNeedsReload', true);

        // if (this.filterNeedsReload == true) {

          this.$store.dispatch({
            type: 'fncRetrieveFilters',
            date_from: 'null',
            date_to: 'null',
            region: 'null',
            status: this.objStatus,
            originator: this.objOriginator,
            department: this.objDepartment,
            customer: this.objCustomerUser,
            store: this.objStore,
            commercial_kam: this.objKam,
            commercial_originator: this.objcOriginator,
            quote_type: this.objQuoteType,
            service_type: this.objServiceType,
            projects: this.objProjects,
            vendor: this.objVendor,
            project: 'null',
            company: this.objCompany,
            specifier: 'null',
            refresh: true,
            start_date: this.reportDate[0],
            end_date: this.reportDate[1],
            ignoreFilters: true,
            filter_only: true,
            //search: this.search,
            search: '',
            quoteRegion: this.objRegion,
            quoteRep: this.objRep,
            pricelist: false,
            slideout: this.slideOut
          })
        // }
      } else {
          this.filterDrawer = true;
        }

      },
      fncGetStatusCount(){
        var modalDetails = { title: 'SUMMARY BY STATUS', component: 'modal-quote-totals', mstate: true, params: {} };
        this.$store.commit({
          type: 'setModal',
          details: modalDetails
        });

        this.regenFalse = true;

        this.dateFilterShow = false;
        this.vendorFilterShow = false;
        this.departmentFilterShow = false;
        this.storeFilterShow = false;
        this.originatorFilterShow = false;
        this.customerFilterShow = false;
        this.statusFilterShow = false;
        this.regionFilterShow = false;
        this.repFilterShow = false;
        this.showVendorClose = false;

        //this.filterDrawer = true;
        //this.$store.commit( 'fncFilterNeedsReload', true );

        if( this.filterNeedsReload == true ) {

          this.$store.dispatch({
            type: 'fncPopulateDashboard',
            date_from: 'null',
            date_to: 'null',
            region: 'null',
            status: this.objStatus,
            originator: this.objOriginator,
            customer: this.objCustomerUser,
            store: this.objStore,
            commercial_kam: this.objKam,
            commercial_originator: this.objcOriginator,
            quote_type: this.objQuoteType,
            service_type: this.objServiceType,
            projects: this.objProjects,
            vendor: this.objVendor,
            project: 'null',
            company: 'null',
            specifier: 'null',
            refresh: true,
            start_date: this.reportDate[0],
            end_date: this.reportDate[1],
            ignoreFilters: true,
            filter_only: true,
            search: this.search,
            quoteRegion: this.objRegion,
            quoteRep: this.objRep,
            tabs: this.tabs,
            department: this.objDepartment
          })
        }
      },
      fncShowFilterSlideSub() {

        this.regenFalse = true;

        this.dateFilterShow = false;
        this.vendorFilterShow = false;
        this.departmentFilterShow = false;
        this.storeFilterShow = false;
        this.originatorFilterShow = false;
        this.customerFilterShow = false;
        this.statusFilterShow = false;
        this.regionFilterShow = false;
        this.repFilterShow = false;
        this.showVendorClose = false;

        this.filterDrawer = true;
        this.$store.commit( 'fncFilterNeedsReload', true );

        if( this.filterNeedsReload == true ) {

          this.$store.dispatch({
            type: 'fncRetrieveFilters',
            date_from: 'null',
            date_to: 'null',
            region: 'null',
            status: this.objStatus,
            originator: this.objOriginator,
            department: this.objDepartment,
            customer: this.objCustomerUser,
            store: this.objStore,
            vendor: this.objVendor,
            project: 'null',
            company: this.objCompany,
            specifier: 'null',
            refresh: true,
            start_date: this.reportDate[0],
            end_date: this.reportDate[1],
            /*start_date: '1900-01-01',
            end_date: '2020-06-06',*/
            ignoreFilters: true,
            filter_only: true,
            //search: this.search,
            search: '',
            quoteRegion: this.objRegion,
            quoteRep: this.objRep,
            commercial_kam: this.objKam,
            commercial_originator: this.objcOriginator,
            quote_type: this.objQuoteType,
            service_type: this.objServiceType,
            projects: this.objProjects,
          })
        }
      },
      fncSearchClearNewQuotes() {

        /*localStorage.removeItem('quote_start_date');
        localStorage.removeItem('quote_end_date');
        localStorage.removeItem('reportDates');
        localStorage.removeItem('quoteSetDays');*/

        localStorage.removeItem('cancelVendor');
        localStorage.removeItem('cancelStore');
        localStorage.removeItem('cancelDepartment');
        localStorage.removeItem('cancelOriginator');
        localStorage.removeItem('cancelCustomer');
        localStorage.removeItem('cancelRegion');
        localStorage.removeItem('cancelRep');
        localStorage.removeItem('cancelKam');
        localStorage.removeItem('cancelcOriginator');
        localStorage.removeItem('cancelReportDate');
        localStorage.removeItem('cancelQuoteSetDays');
        localStorage.removeItem('cancelProjects');
        localStorage.removeItem('cancelStatus');

        this.regenFalse = false;
        /*this.reportDate[0] = '';
        var dToday = new Date();
        var quote_age_end = dToday.toISOString().split('T')[0];
        this.reportDate[1] = quote_age_end;*/
        this.quoteFilter = '';
        this.search = '';
        this.objVendor = ['all'];
        this.objDepartment = ['all'];
        this.objStore = ['all'];
        this.objOriginator = ['all'];
        this.objCustomerUser = ['all'];
        this.objStatus = ['all'];

        localStorage.removeItem('secondTab')
        console.log('reportStatus')
        localStorage.removeItem('topTab')
        //localStorage.setItem('topTab', '0')
        localStorage.removeItem('reportStatus');
        this.objRegion = ['all'];
        this.objRep = ['all'];
        this.objKam = ['all'];
        this.objQuoteType = ['all'];
        this.objServiceType = ['all'];
        this.objcOriginator = ['all'];
        this.objProjects = ['all'];
        this.objCompany = ['all'];
        localStorage.removeItem('secondTab')

        this.secondTab = null
        this.selectedStatus = null

		    this.fncSearchNewQuotes(false,true);

      },
      fncClearFilter() {

        /*localStorage.removeItem('quote_start_date');
        localStorage.removeItem('quote_end_date');*/
        // localStorage.removeItem('reportDates');
        localStorage.removeItem('quoteSetDays');

        this.regenFalse = false;
        /*this.reportDate[0] = '';
        this.reportDate[1] = '';*/
        this.quoteFilter = '';
        this.search = '';
        this.objVendor = ['all'];
        this.objDepartment = ['all'];
        this.objStore = ['all'];
        this.objOriginator = ['all'];
        this.objCustomerUser = ['all'];
        this.objStatus = ['all'];
        this.objRegion = ['all'];
        this.objRep = ['all'];
        this.objKam = ['all'];
        this.objQuoteType = ['all'];
        this.objServiceType = ['all'];
        this.objcOriginator = ['all'];
        this.objProjects = ['all'];
        this.objCompany = ['all'];

        this.fncReloadFilters();
      },
      fncHideFilter() {
        this.filterDrawer = false;
      },
      fncSetFilters( type ) {

        var toReturn = [{ id: 'all', name: 'All' }];
        var filters = this.newReportFilters;

        if( type == 'vendor' ) {
          var isSelected = [];
          var isNotSelected = [];
          for( var v in filters.vendor ) {
            if( this.objVendor.indexOf(String(v)) != -1 ) {
              isSelected.push({id: v, name: filters.vendor[v]})
            }
          }
          isSelected.sort((a, b) => a.name.localeCompare(b.name));
          for( var v in filters.vendor ) {
            if( this.objVendor.indexOf(String(v)) == -1 ) {
              isNotSelected.push({id: v, name: filters.vendor[v]})
            }
          }
          isNotSelected.sort((a, b) => a.name.localeCompare(b.name));
          toReturn = toReturn.concat(isSelected);
          toReturn = toReturn.concat(isNotSelected);
        } else if( type == 'store' ) {
          var isSelected = [];
          var isNotSelected = [];
          for( var s in filters.store ) {
            if( this.objStore.indexOf(String(s)) != -1 ) {
              isSelected.push({id: s, name: filters.store[s]});
            }
          }
          isSelected.sort((a, b) => a.name.localeCompare(b.name));
          for( var s in filters.store ) {
            if( this.objStore.indexOf(String(s)) == -1 ) {
              isNotSelected.push({id: s, name: filters.store[s]});
            }
          }
          isNotSelected.sort((a, b) => a.name.localeCompare(b.name));
          toReturn = toReturn.concat(isSelected);
          toReturn = toReturn.concat(isNotSelected);
        } else if( type == 'status' ) {

          /* if( this.departmentList.length > 0 ) {

            var simpleDepartmentList = [];
            for( var d in this.departmentList ) {
              simpleDepartmentList[this.departmentList[d].id] = this.departmentList[d].name;
            }

            var depStatuses = [];
            //depStatuses[0] = 'No Department Assigned';
            for( var s in this.statusList ) {
              for( var fs in filters.status ) {
                if( this.statusList[s].description == fs  ) {
                  if( depStatuses[this.statusList[s].department] == null ) {
                    depStatuses[this.statusList[s].department] = [];
                  }
                  depStatuses[this.statusList[s].department].push( this.statusList[s] );
                }
              }
            }

            var isSelected = [];

            for( var ds in depStatuses ) {
              if( ds == 0 ) {
                isSelected.push({header: 'No Department Assigned'});
              } else {
                isSelected.push({header: simpleDepartmentList[ds]});
              }
              for( var dss in depStatuses[ds] ) {
                isSelected.push({id: depStatuses[ds][dss].description, name: depStatuses[ds][dss].description});
              }
            }

            toReturn = toReturn.concat(isSelected);

          } else { */
            var isSelected = [];
            var isNotSelected = [];
            for( var s in filters.status ) {
              if( this.objStatus.indexOf(String(s)) != -1 ) {
                isSelected.push({id: s, name: s});
              }
            }
            isSelected.sort((a, b) => a.name.localeCompare(b.name));
            for( var s in filters.status ) {
              if( this.objStatus.indexOf(String(s)) == -1 ) {
                isNotSelected.push({id: s, name: s});
              }
            }
            isNotSelected.sort((a, b) => a.name.localeCompare(b.name));
            toReturn = toReturn.concat(isSelected);
            toReturn = toReturn.concat(isNotSelected);
          // }
        } else if( type == 'originator' ) {
          var isSelected = [];
          var isNotSelected = [];
          for( var o in filters.originator ) {
            if( this.objOriginator.indexOf(String(o)) != -1 ) {
              isSelected.push({id: o, name: filters.originator[o]});
            }
          }
          isSelected.sort((a, b) => a.name.localeCompare(b.name));
          for( var o in filters.originator ) {
            if( this.objOriginator.indexOf(String(o)) == -1 ) {
              isNotSelected.push({id: o, name: filters.originator[o]});
            }
          }
          isNotSelected.sort((a, b) => a.name.localeCompare(b.name));
          toReturn = toReturn.concat(isSelected);
          toReturn = toReturn.concat(isNotSelected);
        } else if( type == 'customer' ) {
          var isSelected = [];
          var isNotSelected = [];
          for( var c in filters.customer ) {
            if( this.objCustomerUser.indexOf(String(c)) != -1 ) {
              isSelected.push({id: c, name: filters.customer[c]});
            }
          }
          isSelected.sort((a, b) => a.name.localeCompare(b.name));
          for( var c in filters.customer ) {
            if( this.objCustomerUser.indexOf(String(c)) == -1 ) {
              isNotSelected.push({id: c, name: filters.customer[c]});
            }
          }
          isNotSelected.sort((a, b) => a.name.localeCompare(b.name));
          toReturn = toReturn.concat(isSelected);
          toReturn = toReturn.concat(isNotSelected);
        } else if( type == 'department' ) {
          var isSelected = [];
          var isNotSelected = [];
          for( var d in filters.department ) {
            if( this.objDepartment.indexOf(String(d)) != -1 ) {
              isSelected.push({ id: d, name: filters.department[d] });
            }
          }
          isSelected.sort((a, b) => a.name.localeCompare(b.name));
          for( var d in filters.department ) {
            if( this.objDepartment.indexOf(String(d)) == -1 ) {
              isNotSelected.push({ id: d, name: filters.department[d] });
            }
          }
          // isNotSelected.sort((a, b) => a.name.localeCompare(b.name));
          isNotSelected.sort((a, b) => {
            if (a.name && b.name) {
              return a.name.localeCompare(b.name);
            } else if (!a.name && b.name) {
              return -1; // Move null values to the end of the sorted array
            } else if (a.name && !b.name) {
              return 1; // Move null values to the end of the sorted array
            } else {
              return 0; // Both names are null, no need to sort
            }
          });
          toReturn = toReturn.concat(isSelected);
          toReturn = toReturn.concat(isNotSelected);
        } else if( type == 'region' ) {
          var isSelected = [];
          var isNotSelected = [];
          for( var d in filters.regions ) {
            if( this.objRegion.indexOf(String(d)) != -1 ) {
              isSelected.push({ id: filters.regions[d], name: filters.regions[d] });
            }
          }
          isSelected.sort((a, b) => a.name.localeCompare(b.name));
          for( var d in filters.regions ) {
            if( this.objRegion.indexOf(String(d)) == -1 ) {
              isNotSelected.push({ id: filters.regions[d], name: filters.regions[d] });
            }
          }
          isNotSelected.sort((a, b) => a.name.localeCompare(b.name));
          toReturn = toReturn.concat(isSelected);
          toReturn = toReturn.concat(isNotSelected);
        } else if( type == 'rep' ) {
          var isSelected = [];
          var isNotSelected = [];
          for (var d in filters.reps) {
            if (this.objRep.indexOf(String(d)) != -1) {
              isSelected.push({id: d, name: filters.reps[d]});
            }
          }
          isSelected.sort((a, b) => a.name.localeCompare(b.name));
          for (var d in filters.reps) {
            if (this.objRep.indexOf(String(d)) == -1) {
              isNotSelected.push({id: d, name: filters.reps[d]});
            }
          }
          isNotSelected.sort((a, b) => a.name.localeCompare(b.name));
          toReturn = toReturn.concat(isSelected);
          toReturn = toReturn.concat(isNotSelected);
        } else if( type == 'kam' ) {
            var isSelected = [];
            var isNotSelected = [];
            for( var o in filters.commercial_kam ) {
              if( this.objKam.indexOf(String(o)) != -1 ) {
                isSelected.push({id: o, name: filters.commercial_kam[o]});
              }
            }
            isSelected.sort((a, b) => a.name.localeCompare(b.name));
            for( var o in filters.commercial_kam ) {
              if( this.objKam.indexOf(String(o)) == -1 ) {
                isNotSelected.push({id: o, name: filters.commercial_kam[o]});
              }
            }
            isNotSelected.sort((a, b) => a.name.localeCompare(b.name));
            toReturn = toReturn.concat(isSelected);
            toReturn = toReturn.concat(isNotSelected);
        } else if( type == 'cOriginator' ) {
          var isSelected = [];
          var isNotSelected = [];
          for( var o in filters.commercial_originator ) {
            if( this.objcOriginator.indexOf(String(o)) != -1 ) {
              isSelected.push({id: o, name: filters.commercial_originator[o]});
            }
          }
          isSelected.sort((a, b) => a.name.localeCompare(b.name));
          for( var o in filters.commercial_originator ) {
            if( this.objcOriginator.indexOf(String(o)) == -1 ) {
              isNotSelected.push({id: o, name: filters.commercial_originator[o]});
            }
          }
          isNotSelected.sort((a, b) => a.name.localeCompare(b.name));
          toReturn = toReturn.concat(isSelected);
          toReturn = toReturn.concat(isNotSelected);
        } else if( type == 'quote_type' ) {
          var isSelected = [];
          var isNotSelected = [];
          for( var o in filters.quote_type ) {
            if( this.objQuoteType.indexOf(String(o)) != -1 ) {
              isSelected.push({id: o, name: filters.quote_type[o]});
            }
          }
          isSelected.sort((a, b) => a.name.localeCompare(b.name));
          for( var o in filters.quote_type ) {
            if( this.objQuoteType.indexOf(String(o)) == -1 ) {
              isNotSelected.push({id: o, name: filters.quote_type[o]});
            }
          }
          isNotSelected.sort((a, b) => a.name.localeCompare(b.name));
          toReturn = toReturn.concat(isSelected);
          toReturn = toReturn.concat(isNotSelected);
        } else if( type == 'service_type' ) {
          var isSelected = [];
          var isNotSelected = [];
          for( var o in filters.service_type ) {
            if( this.objServiceType.indexOf(String(o)) != -1 ) {
              isSelected.push({id: o, name: filters.service_type[o]});
            }
          }
          isSelected.sort((a, b) => a.name.localeCompare(b.name));
          for( var o in filters.service_type ) {
            if( this.objServiceType.indexOf(String(o)) == -1 ) {
              isNotSelected.push({id: o, name: filters.service_type[o]});
            }
          }
          isNotSelected.sort((a, b) => a.name.localeCompare(b.name));
          toReturn = toReturn.concat(isSelected);
          toReturn = toReturn.concat(isNotSelected);
        } else if( type == 'projects' ) {
          var isSelected = [];
          var isNotSelected = [];
          for( var o in filters.projects ) {
            if( this.objProjects.indexOf(String(o)) != -1 ) {
              isSelected.push({id: o, name: filters.projects[o]});
            }
          }
          isSelected.sort((a, b) => a.name.localeCompare(b.name));
          for( var o in filters.projects ) {
            if( this.objProjects.indexOf(String(o)) == -1 ) {
              isNotSelected.push({id: o, name: filters.projects[o]});
            }
          }
          isNotSelected.sort((a, b) => a.name.localeCompare(b.name));
          toReturn = toReturn.concat(isSelected);
          toReturn = toReturn.concat(isNotSelected);
        } else if( type == 'company' ) {
          var isSelected = [];
          var isNotSelected = [];
          for( var o in filters.companies ) {
            if( this.objCompany.indexOf(String(o)) != -1 ) {
              isSelected.push({id: o, name: filters.companies[o]});
            }
          }
          isSelected.sort((a, b) => a.name.localeCompare(b.name));
          for( var o in filters.companies ) {
            if( this.objCompany.indexOf(String(o)) == -1 ) {
              isNotSelected.push({id: o, name: filters.companies[o]});
            }
          }
          isNotSelected.sort((a, b) => a.name.localeCompare(b.name));
          toReturn = toReturn.concat(isSelected);
          toReturn = toReturn.concat(isNotSelected);
        }

        return toReturn;

      },
      fncGetRecordCount() {
        /*if( this.quoteSearchList == undefined || this.quoteSearchList == null ) {
          return 0;
        } else if( this.quoteSearchList.length > 0 ) {
          return this.quoteSearchList[0].total_records;
        } else {
          return 0;
        }*/

        return this.totalQuoteRecords;
      },
      fncHideLinkedQuotes() {
        this.quotesLinked = false;
        this.$store.commit( 'fncSetQuoteListOutright', this.quoteSearchListSet );
      },
      fncGetStatusDropdown( objItem, quoteId) {

        var currentStatus = objItem.status;
        var currentStatusOrder = -1;

        if( this.objAuthorize.department_active == 0 || this.objAuthorize.department_status_share == 1 ) {
          // return status as per normal
          var canBack = false;
          var canForward = false;
          var isChecked = false;

          var newFilterStatus = [];
          for( var f in this.filterStatusSet ) {
            this.filterStatusSet[f].disabled = false;
            newFilterStatus.push( this.filterStatusSet[f] );
          }

          for( var f in newFilterStatus ) {
            if( newFilterStatus[f].description == currentStatus ) {
              currentStatusOrder = f;
            }
            if( newFilterStatus[f].can_back_after_payment == 'Yes' ) {
              canBack = f;
            }
            if( newFilterStatus[f].is_checked == 'Yes' ) {
              isChecked = f;
            }
            if( newFilterStatus[f].can_forward_before_payment == 'Yes' ) {
              canForward = f;
            }
          }

          var finalS = [];

          if( this.objAuthorize.privileges.indexOf('STATUS_CAN_GO_BACK_AFTER_CHECKOUT') == -1 && this.objAuthorize.privileges.indexOf('STATUS_CAN_GO_FORWARD_BEFORE_CHECKOUT') == -1 ) {
            for (var f in newFilterStatus) {
              if( parseInt(currentStatusOrder) < parseInt(isChecked) && parseInt(f) < parseInt(isChecked) ) {
                finalS.push( { id: newFilterStatus[f].id, description: newFilterStatus[f].description, disabled: false } );
              } else if( parseInt(currentStatusOrder) >= parseInt(isChecked) && parseInt(f) >= parseInt(isChecked) ) {
                finalS.push( { id: newFilterStatus[f].id, description: newFilterStatus[f].description, disabled: false } );
              } else {
                finalS.push( { id: newFilterStatus[f].id, description: newFilterStatus[f].description, disabled: true } );
              }
            }
            //return finalS;
          } else if( this.objAuthorize.privileges.indexOf('STATUS_CAN_GO_BACK_AFTER_CHECKOUT') != -1 && this.objAuthorize.privileges.indexOf('STATUS_CAN_GO_FORWARD_BEFORE_CHECKOUT') != -1 ) {
            finalS = newFilterStatus;
            //return newFilterStatus;
          } else if( canBack != false || canForward != false ) {
            if( canBack != false && this.objAuthorize.privileges.indexOf('STATUS_CAN_GO_BACK_AFTER_CHECKOUT') == -1 /*&& currentStatusOrder > isChecked*/ ) {
              for (var f in newFilterStatus) {
                if ( parseInt(f) < parseInt(canBack) && parseInt(currentStatusOrder) >= parseInt(isChecked) ) {
                  finalS.push( { id: newFilterStatus[f].id, description: newFilterStatus[f].description, disabled: true } );
                } else if ( parseInt(f) < parseInt(isChecked) && parseInt(currentStatusOrder) <= parseInt(isChecked)) {
                  finalS.push( { id: newFilterStatus[f].id, description: newFilterStatus[f].description, disabled: false } );
                } else if ( parseInt(currentStatusOrder) >= parseInt(isChecked) ) {
                  finalS.push( { id: newFilterStatus[f].id, description: newFilterStatus[f].description, disabled: false } );
                } else if( this.objAuthorize.privileges.indexOf('STATUS_CAN_GO_FORWARD_BEFORE_CHECKOUT') != -1 && parseInt(currentStatusOrder) <= parseInt(isChecked)  ) {
                  finalS.push( { id: newFilterStatus[f].id, description: newFilterStatus[f].description, disabled: false } );
                } else {
                  finalS.push( { id: newFilterStatus[f].id, description: newFilterStatus[f].description, disabled: true } );
                }
              }
            }
            if( canForward != false && this.objAuthorize.privileges.indexOf('STATUS_CAN_GO_FORWARD_BEFORE_CHECKOUT') == -1 ) {
              for( var f in newFilterStatus ) {
                if( parseInt(f) >= parseInt(canForward) && parseInt(currentStatusOrder) <= parseInt(isChecked) ) {
                  finalS.push( { id: newFilterStatus[f].id, description: newFilterStatus[f].description, disabled: true } );
                } else {
                  finalS.push( { id: newFilterStatus[f].id, description: newFilterStatus[f].description, disabled: false } );
                }
              }
            }
            //return finalS;
          } else {
            finalS = newFilterStatus
            //return newFilterStatus;
          }

        } else {

          var returnDepartment = 0;
          var departmentName = [];

          var hasDepartment = false;
          var productCodes = objItem.pCodes.split(',');

          if( this.surveyList[objItem.id] != undefined && this.surveyList[objItem.id] != null ) {
            for( var d in this.departmentList ) {
              if( this.departmentList[d].id == this.surveyList[objItem.id] ) {
                returnDepartment = this.departmentList[d].id;
                theDepartment = this.departmentList[d].id;
                hasDepartment = true;
              }
            }
          }

          if( hasDepartment == false ) {
            var theDepartment = this.fncGetDepartmentId( objItem );
          }

          if( productCodes.length > 0 && hasDepartment == false ) {
            for( var d in this.departmentList ) {
              if( this.departmentList[d].product_codes && this.departmentList[d].product_codes.length > 0 ) {
                for( var c in this.departmentList[d].product_codes ) {
                  for( var p in productCodes ) {
                    if( productCodes[p] == this.departmentList[d].product_codes[c].value ) {
                      returnDepartment = this.departmentList[d].id;
                      hasDepartment = true;
                    }
                  }
                }
              }
            }
          }

          if( objItem.range_id != null && objItem.range_id != undefined && hasDepartment == true && returnDepartment == 0 ) {
            var departmentRanges = this.departmentList;
            var filteredQuotes = [];
            var quoteRanges = objItem.range_id.split(',');
            for( var d in departmentRanges ) {
              for( var qr in quoteRanges ) {
                for( var dr in departmentRanges[d].ranges ) {
                  if( quoteRanges[qr] == departmentRanges[d].ranges[dr] ) {
                    departmentName.push( departmentRanges[d].id );
                  }
                }
              }
            }
            var uniqueDepartment = departmentName.filter((v, i, a) => a.indexOf(v) === i);
            if( uniqueDepartment.length == 0 ) {
              if( objItem.originator_department != '' && objItem.originator_department != null ) {
                for( var d in this.departmentList ) {
                  if( this.departmentList[d].id == objItem.originator_department ) {
                    returnDepartment = this.departmentList[d].id;
                    hasDepartment = true;
                  }
                }
              } else if( objItem.departmentUser != '' && objItem.departmentUser != null ) {
                returnDepartment = objItem.departmentUser;
              } else {
                var productCodes = [];
                var line_item_data = JSON.parse( objItem.product_codes ).split('|||');
                if( line_item_data.length > 0 ) {
                  for( var l in line_item_data ) {
                    var lineObj = JSON.parse( line_item_data[l] );
                    if( lineObj.product_code != null && productCodes.indexOf(lineObj.product_code) == -1 ) {
                      productCodes.push(lineObj.product_code);
                    }
                  }
                }
                if( productCodes.length > 1 ) {
                  returnDepartment = 0;
                } else {
                  for( var d in this.departmentList ) {
                    if( this.departmentList[d].product_codes.length > 0 ) {
                      for( var c in this.departmentList[d].product_codes ) {
                        if( productCodes[0] == this.departmentList[d].product_codes[c].value ) {
                          returnDepartment = this.departmentList[d].id;
                          hasDepartment = true;
                        }
                      }
                    }
                  }
                }
              }
            } else if( uniqueDepartment.length > 1 ) {
              if( objItem.originator_department != '' && objItem.originator_department != null ) {
                returnDepartment = objItem.originator_department;
              } else if( objItem.departmentUser != '' && objItem.departmentUser != null ) {
                returnDepartment = objItem.departmentUser;
                hasDepartment = true;
              } else {
                returnDepartment = 0;
                hasDepartment = true;
              }
            } else {
              returnDepartment = uniqueDepartment[0];
              hasDepartment = true;
            }
          }

          // now that we have the department id we can display the correct statuses
          var returnStatuses = [];
          var loggedRole =  this.objAuthorize.roles[0];

          // return status as per normal
          var canBack = false;
          var canForward = false;
          var isChecked = false;

          for( var s in this.filterStatus ) {
            var statusRoles = this.filterStatus[s].roles != null ? this.filterStatus[s].roles.split(',') : [];
            if( this.filterStatus[s].department != null ) {
              var objDepartments = this.filterStatus[s].department.split(',');
            } else {
              var objDepartments = [];
            }

            if( theDepartment == 'N/A' ) {
              returnDepartment = 0;
            } else {
              returnDepartment = theDepartment;
            }

            returnDepartment = objItem.departmentId;

            // if( returnDepartment == this.filterStatus[s].department && ( statusRoles.indexOf( loggedRole ) != -1 || this.objAuthorize.privileges.indexOf('VIEW_ALL_DEPARTMENT_STATUS') != -1 ) ) {
            if( objDepartments.indexOf(String(returnDepartment)) != -1 && ( statusRoles.indexOf( loggedRole ) != -1 || this.objAuthorize.privileges.indexOf('VIEW_ALL_DEPARTMENT_STATUS') != -1 ) ) {
              returnStatuses.push( this.filterStatus[s] );
            }

            if( returnDepartment == 0 && objDepartments.length == 0) {
              returnStatuses.push( this.filterStatus[s] );
            }

            if( this.filterStatus[s].description == currentStatus ) {
              currentStatusOrder = this.filterStatus[s].order;
            }

            if( this.filterStatus[s].can_back_after_payment == 'Yes' ) {
              canBack = this.filterStatus[s].order;
            }
            if( this.filterStatus[s].is_checked == 'Yes' ) {
              isChecked = this.filterStatus[s].order;
            }
            if( this.filterStatus[s].can_forward_before_payment == 'Yes' ) {
              canForward = this.filterStatus[s].order;
            }

          }

          /* ------------------ */

          var newFilterStatus = [];
          for( var f in returnStatuses ) {
            returnStatuses[f].disabled = false;
            newFilterStatus.push(returnStatuses[f]);
          }

          for( var f in newFilterStatus ) {
            /*if( newFilterStatus[f].description == currentStatus ) {
              currentStatusOrder = f;
            }*/
            /*if( newFilterStatus[f].can_back_after_payment == 'Yes' ) {
              canBack = newFilterStatus[f].order;
            }
            if( newFilterStatus[f].is_checked == 'Yes' ) {
              isChecked = newFilterStatus[f].order;
            }
            if( newFilterStatus[f].can_forward_before_payment == 'Yes' ) {
              canForward = newFilterStatus[f].order;
            }*/
          }


          var finalS = [];

          if( this.objAuthorize.privileges.indexOf('STATUS_CAN_GO_BACK_AFTER_CHECKOUT') == -1 && this.objAuthorize.privileges.indexOf('STATUS_CAN_GO_FORWARD_BEFORE_CHECKOUT') == -1 ) {

            for (var f in newFilterStatus) {

              var statusOrder = newFilterStatus[f].order;

              if( parseInt(currentStatusOrder) == parseInt(isChecked) ) {
                if( parseInt(statusOrder) > parseInt( isChecked ) ) {
                  finalS.push( { id: newFilterStatus[f].id, description: newFilterStatus[f].description, disabled: false, reasons: newFilterStatus[f].reasons } );
                } else {
                  finalS.push( { id: newFilterStatus[f].id, description: newFilterStatus[f].description, disabled: true, reasons: newFilterStatus[f].reasons } );
                }
              } else if( parseInt(currentStatusOrder) <= parseInt(isChecked) && parseInt(statusOrder) <= parseInt(isChecked) ) {
                console.log('Two');

                if( parseInt(statusOrder) == parseInt(isChecked) ){
                  finalS.push( { id: newFilterStatus[f].id, description: newFilterStatus[f].description, disabled: true, reasons: newFilterStatus[f].reasons } );
                } else {
                  finalS.push( { id: newFilterStatus[f].id, description: newFilterStatus[f].description, disabled: false, reasons: newFilterStatus[f].reasons } );
                }
              } else if( parseInt(currentStatusOrder) >= parseInt(isChecked) && parseInt(statusOrder) >= parseInt(isChecked) ) {
                console.log('Three');
                if( parseInt(statusOrder) == parseInt(isChecked) ){
                  finalS.push( { id: newFilterStatus[f].id, description: newFilterStatus[f].description, disabled: true, reasons: newFilterStatus[f].reasons } );
                } else {
                  finalS.push( { id: newFilterStatus[f].id, description: newFilterStatus[f].description, disabled: false, reasons: newFilterStatus[f].reasons } );
                }
              } else {
                console.log('Four');
                finalS.push( { id: newFilterStatus[f].id, description: newFilterStatus[f].description, disabled: true, reasons: newFilterStatus[f].reasons } );
              }
            }
            //return finalS;
          } else if( this.objAuthorize.privileges.indexOf('STATUS_CAN_GO_BACK_AFTER_CHECKOUT') != -1 && this.objAuthorize.privileges.indexOf('STATUS_CAN_GO_FORWARD_BEFORE_CHECKOUT') != -1 ) {
            finalS = newFilterStatus;
            //return newFilterStatus;
          } else if( canBack != false || canForward != false ) {
            if( canBack != false && this.objAuthorize.privileges.indexOf('STATUS_CAN_GO_BACK_AFTER_CHECKOUT') == -1 /*&& currentStatusOrder > isChecked*/ ) {
              for (var f in newFilterStatus) {
                if ( parseInt(f) < parseInt(canBack) && parseInt(currentStatusOrder) >= parseInt(isChecked) ) {
                  finalS.push( { id: newFilterStatus[f].id, description: newFilterStatus[f].description, disabled: true, reasons: newFilterStatus[f].reasons } );
                } else if ( parseInt(f) <= parseInt(isChecked) && parseInt(currentStatusOrder) <= parseInt(isChecked)) {
                  finalS.push( { id: newFilterStatus[f].id, description: newFilterStatus[f].description, disabled: false, reasons: newFilterStatus[f].reasons } );
                } else if ( parseInt(currentStatusOrder) >= parseInt(isChecked) ) {
                  finalS.push( { id: newFilterStatus[f].id, description: newFilterStatus[f].description, disabled: false, reasons: newFilterStatus[f].reasons } );
                } else if( this.objAuthorize.privileges.indexOf('STATUS_CAN_GO_FORWARD_BEFORE_CHECKOUT') != -1 && parseInt(currentStatusOrder) <= parseInt(isChecked)  ) {
                  finalS.push( { id: newFilterStatus[f].id, description: newFilterStatus[f].description, disabled: false, reasons: newFilterStatus[f].reasons } );
                } else {
                  finalS.push( { id: newFilterStatus[f].id, description: newFilterStatus[f].description, disabled: true, reasons: newFilterStatus[f].reasons } );
                }
              }
            }
            if( canForward != false && this.objAuthorize.privileges.indexOf('STATUS_CAN_GO_FORWARD_BEFORE_CHECKOUT') == -1 ) {

              for( var f in newFilterStatus ) {
                if( parseInt(f) >= parseInt(canForward) && parseInt(currentStatusOrder) <= parseInt(isChecked) ) {
                  finalS.push( { id: newFilterStatus[f].id, description: newFilterStatus[f].description, disabled: true, reasons: newFilterStatus[f].reasons } );
                } else {
                  finalS.push( { id: newFilterStatus[f].id, description: newFilterStatus[f].description, disabled: false, reasons: newFilterStatus[f].reasons } );
                }
              }
            }
            //return finalS;
          } else {
            finalS = newFilterStatus
            //return newFilterStatus;
          }


        }

        objItem.staticStatus = document.getElementById(quoteId).innerHTML;

        var modalDetails = { title: 'Quote Status Update (' + objItem.quote_no + ')', component: 'modal-quote-status-update', mstate: true, params: {currentStatus: objItem.staticStatus, quoteId: quoteId, currentStatusStatic: objItem.status, object: objItem, statusList: finalS, quoteTotal: objItem.pricing_total } };
        this.$store.dispatch('fncPopulateStatusList');
        this.$store.commit({
          type: 'setModal',
          details: modalDetails
        });

      },
      fncMakeClickable( dateType ) {
        this.nonClickable = false;
        if( dateType == 'start' ) {
          var sDate = new Date(this.reportDate[0]);
          sDate.setDate(sDate.getDate() + 1);
          var start_date = sDate.toISOString().split('T')[0];
          this.reportDate[0] = start_date;
        } else {
          var eDate = new Date(this.reportDate[1]);
          eDate.setDate(eDate.getDate() + 1);
          var end_date = eDate.toISOString().split('T')[0];
          this.reportDate[1] = end_date;
        }
      },
      fncChangeQuotes( actionType, doReload = false ) {

        if( actionType == 'nonchange' ) {

          this.nonClickable = false;

          this.regenFalse = false;

          var dToday = new Date();
          var dateToday = dToday.toISOString().split('T')[0];
          // localStorage.getItem('reportDates');
          switch(this.quoteFilter) {
            case 1:
              this.reportDate = '';
              var startDate = '1900-01-01';
              break;
            case 2:
              var d = new Date();
              d.setMonth(d.getMonth() - 6);
              var startDate = d.toISOString().split('T')[0];
              break;
            case 3:
              var startDate = new Date(new Date().setDate(dToday.getDate() - 90));
              startDate = startDate.toISOString().split('T')[0];
              break;
            case 4:
              var startDate = new Date(new Date().setDate(dToday.getDate() - 60));
              startDate = startDate.toISOString().split('T')[0];
              break;
            case 5:
              var startDate = new Date(new Date().setDate(dToday.getDate() - 30));
              startDate = startDate.toISOString().split('T')[0];
              break;
            case 6:
              var startDate = new Date(new Date().setDate(dToday.getDate() - 7));
              startDate = startDate.toISOString().split('T')[0];
              break;
          }

          this.reportDate = [];

          if( startDate != '1900-01-01' ) {
            this.reportDate.push( startDate );
            this.reportDate.push( dateToday );
          }

          localStorage.setItem('quoteSetDays', this.quoteFilter);

          this.fncReloadFilters();

        } else if( actionType == true ) {

          var checkStart = new Date(this.reportDate[0]);
          var checkEnd = new Date(this.reportDate[1]);

          if( checkStart > checkEnd ) {
            alert('Start date must be bigger than the end date');
          } else {
            this.$store.commit('fncEmptyDashboard');
            this.$store.commit('fncIsLoaded', false);
            this.statuses = [];

            var newDates = [];
            for( var q in this.reportDate ) {
              if( this.reportDate[q].length == 10 ) {
                newDates.push( this.reportDate[q] );
              } else {
                newDates.push( this.reportDate[q].toISOString().split('T')[0] );
              }
            }

            this.reportDate = newDates;

            if (this.reportDate.length > 0) {
              var start_date = this.reportDate[0];
              if (start_date.length != 10) {
                start_date = this.reportDate[0].substr(0, 10);
              }

              if (start_date != localStorage.getItem("quote_start_date")) {
                start_date = start_date;
              }
            } else {
              start_date = '';
            }

            if (this.reportDate.length > 0) {
              var end_date = this.reportDate[1];
              if (end_date.length != 10) {
                end_date = this.reportDate[1].substr(0, 10);
              }

              if (end_date != localStorage.getItem("quote_end_date")) {
                end_date = end_date;
              } else {
                end_date = localStorage.getItem("quote_end_date");
              }
            } else {
              end_date = '';
            }

          }

          //this.fncSearchNewQuotes();

        } else if( actionType == false ) {
          // this.$store.commit( 'fncIsLoaded', false );

          this.nonClickable = false;

          this.regenFalse = false;

          var dToday = new Date();
          var dateToday = dToday.toISOString().split('T')[0];
          // localStorage.getItem('reportDates');
          switch(this.quoteFilter) {
            case 1:
              this.reportDate = '';
              var startDate = '1900-01-01';
              break;
            case 2:
              var d = new Date();
              d.setMonth(d.getMonth() - 6);
              var startDate = d.toISOString().split('T')[0];
              break;
            case 3:
              var startDate = new Date(new Date().setDate(dToday.getDate() - 90));
              startDate = startDate.toISOString().split('T')[0];
              break;
            case 4:
              var startDate = new Date(new Date().setDate(dToday.getDate() - 60));
              startDate = startDate.toISOString().split('T')[0];
              break;
            case 5:
              var startDate = new Date(new Date().setDate(dToday.getDate() - 30));
              startDate = startDate.toISOString().split('T')[0];
              break;
            case 6:
              var startDate = new Date(new Date().setDate(dToday.getDate() - 7));
              startDate = startDate.toISOString().split('T')[0];
              break;
          }

          this.reportDate = [];

          if( startDate != '1900-01-01' ) {
            this.reportDate.push( startDate );
            this.reportDate.push( dateToday );
          }

          localStorage.setItem('quoteSetDays', this.quoteFilter);

        }

        if( actionType != 'nonchange' ) {
          if( doReload == true ) {
            if (!isDateRangeSelection)
              this.fncSearchNewQuotes();
          } else {
            this.fncReloadFilters();
          }
        }

      },
      fncFilterLabel() {

        var sDate = new Date(this.reportDate[0]);
        var eDate = new Date(this.reportDate[1]);
        var diffDays = parseInt((eDate - sDate) / (1000 * 60 * 60 * 24), 10);

        // alert(diffDays);
        //this.quoteFilter = 99;

        if( ! this.dateChanged  ) {
          if( this.reportDate[0] == undefined ) {
            return 'View All Quotes';
          } else if( diffDays == 30 ) {
            return 'View Last 30 Days';
          } else if( diffDays == 60 ) {
            return 'View Last 60 Days';
          } else if( diffDays == 90 ) {
            return 'View Last 90 Days';
          } else if( diffDays == 7 ) {
            return 'View Last Week';
          } else if( diffDays > 150 ) {
            return 'View Last 6 Months';
          } else {
            return 'Set range';
          }
        }
        return 'Set range';

      },
      fncClearSearchTop() {
        this.search = '';
        console.log('One');
        this.$refs.searchField.lazyValue = '';
        localStorage.setItem('reportSearch','');
        localStorage.removeItem('secondTab')
        console.log('fncClearSearchTop')
        this.secondTab = null
        this.selectedStatus = null

        this.$refs.searchQuoteField.lazyValue = null
        localStorage.setItem('reportSearchQuote',null);

        this.fncSearchNewQuotes();
      },
      fncQuoteReportSearch(){
        localStorage.setItem('reportSearchQuote',JSON.stringify(this.searchQuoteReport));
        this.$router.push({path: '/reports/quote-reports',query: 1});
        this.$router.go();

      },
      fncOnrangeChange()
      {
        //localStorage.setItem('reportIsDateChanged', false)
        //this.isDateChanged = false
        this.fncSearchNewQuotes(true)
      },
      fncSearchNewQuotes( isSingleDate = false, hasTab = false, isClearFilter = false) {
        /** New clear filter**/
        if (isClearFilter === true){
          this.objVendor = ['all'];
          this.objDepartment = ['all'];
          this.objStore = ['all'];
          this.objOriginator = ['all'];
          this.objCustomerUser = ['all'];
          this.objStatus = ['all']
          this.objRegion = ['all'];
          this.objRep = ['all'];
          this.objKam = ['all'];
          this.objQuoteType = ['all'];
          this.objServiceType = ['all'];
          this.objcOriginator = ['all'];
          this.objProjects = ['all'];
          this.objCompany = ['all'];
        }
        this.secondTab = null

        localStorage.setItem('reportSearch',this.$refs.searchField.lazyValue);
        localStorage.setItem('reportSearchQuote',JSON.stringify(this.$refs.searchQuoteField.lazyValue))
        if( isSingleDate ==  true ) {
          localStorage.setItem('quoteSetDays','');
        }/* else {
          localStorage.setItem('quoteSetDays',this.quoteFilter);
        }*/

        this.pagination.page = 1;

        if( this.reportDate.length != 2 ) {
          var start_date = '';
          var end_date = '';
        } else {
          var start_date = this.reportDate[0];
          if( start_date && start_date.length != 10 && start_date.length != 0 ) {
            var new_start_date = new Date(start_date);
            new_start_date.setDate(new_start_date.getDate() + 1);
            start_date = new_start_date.toISOString().split('T')[0]
          }

          localStorage.setItem('quote_start_date', start_date);

          var end_date = this.reportDate[1];
          if( end_date.length != 10 && end_date.length != 0 ) {
            var new_end_date = new Date(end_date);
            new_end_date.setDate(new_end_date.getDate() + 1);
            end_date = new_end_date.toISOString().split('T')[0]
          }

          localStorage.setItem('quote_end_date', end_date);
        }

        if( start_date == '' ) {
          start_date = '1900-01-01';
        }

        if( end_date == '' ) {
          var today = new Date();
          var dd = String(today.getDate()).padStart(2, '0');
          var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
          var yyyy = today.getFullYear();

          end_date = yyyy + '-' + mm + '-' + dd;
        }

        var reportDates = [];
        reportDates.push( start_date );
        reportDates.push( end_date );

        localStorage.setItem('quote_start_date', start_date);
        localStorage.setItem('quote_end_date', end_date);
        localStorage.setItem('reportDates', reportDates.toString());

        /* New */
        if (this.objOriginator != '' && this.objOriginator[0] != 'all' ) {
          localStorage.setItem('reportOriginators', JSON.stringify(this.objOriginator));
        } else {
          localStorage.removeItem('reportOriginators');
        }

        if (this.objStatus != '' && this.objStatus[0] != 'all' ) {
          localStorage.setItem('reportStatus', JSON.stringify(this.objStatus));
          this.secondTab = null
        }
        else {
          localStorage.removeItem('reportStatus');
        }

        if (this.objKam != '' && this.objKam[0] != 'all' ) {
          localStorage.setItem('reportKams', JSON.stringify(this.objKam));
        } else {
          localStorage.removeItem('reportKams');
        }

        if (this.objQuoteType != '' && this.objQuoteType[0] != 'all' ) {
          localStorage.setItem('reportQuoteType', JSON.stringify(this.objQuoteType));
        } else {
          localStorage.removeItem('reportQuoteType');
        }

        if (this.objServiceType != '' && this.objServiceType[0] != 'all' ) {
          localStorage.setItem('reportServiceType', JSON.stringify(this.objServiceType));
        } else {
          localStorage.removeItem('reportServiceType');
        }

        if (this.objcOriginator != '' && this.objcOriginator[0] != 'all' ) {
          localStorage.setItem('reportcOriginator', JSON.stringify(this.objcOriginator));
        } else {
          localStorage.removeItem('reportcOriginator');
        }

        if (this.objQuoteType != '' && this.objQuoteType[0] != 'all' ) {
          localStorage.setItem('reportQuoteType', JSON.stringify(this.objQuoteType));
        } else {
          localStorage.removeItem('reportQuoteType');
        }

        if (this.objServiceType != '' && this.objServiceType[0] != 'all' ) {
          localStorage.setItem('reportServiceType', JSON.stringify(this.objServiceType));
        } else {
          localStorage.removeItem('reportServiceType');
        }

        if (this.objCustomerUser != '' && this.objCustomerUser[0] != 'all') {
          localStorage.setItem('reportUsers', JSON.stringify(this.objCustomerUser));
        } else {
          localStorage.removeItem('reportUsers');
        }

        if (this.objVendor != '' && this.objVendor[0] != 'all') {
          localStorage.setItem('reportVendors', JSON.stringify(this.objVendor));
        } else {
          localStorage.removeItem('reportVendors');
        }

        if (this.objDepartment != '' && this.objDepartment[0] != 'all') {
          localStorage.setItem('reportDepartments', JSON.stringify(this.objDepartment));
        } else {
          localStorage.removeItem('reportDepartments');
        }

        if (this.objStore != '' && this.objStore[0] != 'all') {
          localStorage.setItem('reportStores', JSON.stringify(this.objStore));
        } else {
          localStorage.removeItem('reportStores');
        }

        if (this.objRegion != '' && this.objRegion[0] != 'all') {
          localStorage.setItem('reportRegions', JSON.stringify(this.objRegion));
        } else {
          localStorage.removeItem('reportRegions');
        }

        if (this.objRep != '' && this.objRep[0] != 'all') {
          localStorage.setItem('reportReps', JSON.stringify(this.objRep));
        } else {
          localStorage.removeItem('reportReps');
        }

        if (this.objProjects != '' && this.objProjects[0] != 'all') {
          localStorage.setItem('reportProjects', JSON.stringify(this.objProjects));
        } else {
          localStorage.removeItem('reportProjects');
        }

        if (this.objCompany != '' && this.objCompany[0] != 'all') {
          localStorage.setItem('reportCompany', JSON.stringify(this.objCompany));
        } else {
          localStorage.removeItem('reportCompany');
        }



        if( start_date == '' ) {
          start_date = '1900-01-01';
        }
        if( end_date == '' ) {
          var today = new Date();
          var dd = String(today.getDate()).padStart(2, '0');
          var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
          var yyyy = today.getFullYear();

          end_date = yyyy + '-' + mm + '-' + dd;
        }
        this.$router.push({path: '/reports/quote-reports', query: 1});
        this.$router.go();

        /* End New */
        /*this.$store.dispatch({
          type: 'fncPopulateQuoteList',
          date_from: 'null',
          date_to: 'null',
          date_to: 'null',
          region: 'null',
          status: 'null',
          originator: this.objOriginator,
          status: this.objStatus,
          store: this.objStore,
          customer: this.objCustomerUser,
          vendor: this.objVendor,
          department: this.objDepartment,
          project: 'null',
          company: 'null',
          specifier: 'null',
          refresh: true,
          start_date: start_date,
          end_date: end_date,
          search: this.search
        });*/

        //this.filterDrawer = false;

        /*this.$store.dispatch({
          type: 'fncPopulateQuoteList',
          date_from: 'null',
          date_to: 'null',
          region: 'null',
          status: 'null',
          originator: 'null',
          customer: 'null',
          project: 'null',
          company: 'null',
          specifier: 'null',
          refresh: true,
          start_date: start_date,
          end_date: end_date
        });*/

        //this.nonClickable = true;

      },
      fncCheckSubDisplay( item ) {
        if( this.objAuthorize.manufacturer == '385889803' ) {
          if( item.id == 'total' || item.id == 'vat' ) {
            return false;
          } else {
            return item.checked;
          }
        } else {
          return item.checked;
        }
      },
      fncCheckOrderButton(status) {

        for ( var s in this.statusList ) {
          if (this.statusList[s].description == status) {
            if (this.statusList[s].is_checked == 'Yes' ) {
            //if (this.statusList[s].is_vendor == 'Yes' ) {
              return true;
            }
          }
        }
        return true;
      },
      fncClearSearch() {
        this.search = '';
        this.fncCustomReportSearch();
      },
      fncHasFilters() {
        if (this.filterActive == true ) {
          return 'hasFilters';
        } else {
          return '';
        }
      },
      fncIsLocked(status) {
        for (var s in this.statusList) {
          if (status == this.statusList[s].description) {
            if (this.statusList[s].is_lock == 'Yes' ) {
              return true;
            } else {
              return false;
            }
          }
        }
      },
      fncClearFilters() {

        var dToday = new Date();
        var dateToday = dToday.toISOString().split('T')[0];

        var startDate = new Date(new Date().setDate(dToday.getDate() - 30));
        startDate = startDate.toISOString().split('T')[0];

        var newReportDate = [];
        newReportDate.push( startDate );
        newReportDate.push( dateToday );

        this.hasFilters = false;
        this.objCustomerRegion = '';
        this.objOriginator = ['all'];
        this.objStatus = ['all'];
        this.objCustomerCompany = ['all'];
        this.objCustomerUser = ['all'];
        this.objProject = ['all'];
        this.objSpecifier = ['all'];
        this.objVendor = ['all'];
        this.objDepartment = ['all'];
        this.objStore = ['all'];
        this.startDate = '';
        this.endDate = '';
        this.search = '';
        // this.reportDate = '';
        this.reportDate = newReportDate;
        this.fncCustomReportSearch('');
        var snackDetails = { color: 'success', message: 'Quote Report filters have been cleared', display: true };
        this.$store.commit('setSnack', snackDetails);
        this.filterActive = false;
      },
      fncBlurAll() {
        if (this.$refs.originatorSelect != null) {
          this.originatorBlur = this.$refs.originatorSelect[0].isActive;
        }
        if (this.objCustomerCompany.length > 1 && this.$refs.companySelect != null ) {
          this.companyBlur = this.$refs.companySelect[0].isActive;
        }
        if (this.$refs.customerSelect != null) {
          this.customerBlur = this.$refs.customerSelect[0].isActive;
        }
        if (this.$refs.statusSelect != null) {
          this.statusBlur = this.$refs.statusSelect[0].isActive;
        }
        if (this.$refs.specifierSelect != null) {
          this.specifierBlur = this.$refs.specifierSelect[0].isActive;
        }
        if (this.$refs.projectSelect != null) {
          this.projectBlur = this.$refs.projectSelect[0].isActive;
        }
      },
      fncShowDateFilters() {

        if( this.reportDate[1] == '' && ( this.reportDate[0] != '' && this.reportDate[0] != undefined ) ) {

          var startDate = new Date(this.reportDate[0]);
          startDate.setDate(startDate.getDate() + 1);
          startDate = new Date(startDate + ' GMT +0200').toISOString().slice(0, 10);

          return '<small> ALL after ' + ' ' + startDate + '</small>';
        } else if( this.reportDate[0] == '' && ( this.reportDate[1] != '' && this.reportDate[1] != undefined ) ) {

          var endDate = new Date(this.reportDate[1]);
          endDate.setDate(endDate.getDate() + 1);
          endDate = new Date(endDate + ' GMT +0200').toISOString().slice(0, 10);

          return '<small> ALL up until ' + ' ' + endDate + '</small>';
        } else if( ( this.reportDate[0] == undefined || this.reportDate[1] == undefined  ) ) {
          return '<small>All Dates</small>';
        } else if( ( this.reportDate[0] == '' && this.reportDate[1] == '' ) ) {
          return '<small>All Dates</small>';
        } else {
          var startDate = new Date(this.reportDate[0]);
          startDate.setDate(startDate.getDate() + 1);
          startDate = new Date(startDate + ' GMT +0200').toISOString().slice(0, 10);

          var endDate = new Date(this.reportDate[1]);
          endDate.setDate(endDate.getDate() + 1);
          endDate = new Date(endDate + ' GMT +0200').toISOString().slice(0, 10);

          return '<small>' + startDate + ' ~ ' + endDate + '</small>';
        }

      },
      fncShowOriginatorFilters() {
        var toReturn = '';
        var added = [];
        for (var o in this.objOriginator) {
          if (this.objOriginator[o] != 'all') {
            //var originatorList = this.fncSetFilters('originator');
            var quoteList = this.quoteList;
            for( var ro in quoteList ) {
              if (this.objOriginator[o] == quoteList[ro].originator && added.indexOf(quoteList[ro].originator) == -1) {
                added.push(quoteList[ro].originator);
                var objName = quoteList[ro].orig_name.split(' ');
                if( objName.length == 2 ) {
                  if( objName[0] == objName[1] ) {
                    toReturn += '<small>' +objName[0] + '<br /></small>';
                  } else {
                    toReturn += '<small>' +quoteList[ro].orig_name + '<br /></small>';
                  }
                } else {
                  toReturn += '<small>' +quoteList[ro].orig_name + '<br /></small>';
                }
              }
            }
          }
        }
        return toReturn;
      },
      fncShowVendorFilters() {
        var toReturn = '';
        var added = [];
        for (var v in this.objVendor) {
          if (this.objVendor[v] != 'all') {
            var vendorList = this.vendorList;
            for (var fo in vendorList) {
              if (this.objVendor[v] == vendorList[fo].id && added.indexOf(vendorList[fo].name) == -1) {
                added.push(vendorList[fo].name);
                toReturn += '<small>' + vendorList[fo].name + '<br /></small>';
              }
            }
          }
        }
        return toReturn;
      },
      /*fncShowDepartmentFilters() {
        var toReturn = '';
        var added = [];
        for (var d in this.objDepartment) {
          if (this.objDepartment[d] != 'all') {
            var departmentList = this.fncSetFilters('department');
            for (var fo in departmentList) {
              if (this.objDepartment[d] == departmentList[fo].id && added.indexOf(departmentList[fo].name) == -1) {
                added.push(departmentList[fo].name);
                toReturn += '<small>' + departmentList[fo].name + '<br /></small>';
              }
            }
          }
        }
        return toReturn;
      },*/
      fncShowStoreFilters() {
        var toReturn = '';
        var added = [];
        for (var s in this.objStore) {
          if (this.objStore[s] != 'all') {
            /*var storeList = this.fncSetFilters('store');
            console.log( storeList );*/
            for (var fo in this.branchList) {
              if (this.objStore[s] == this.branchList[fo].code && added.indexOf(this.branchList[fo].code) == -1) {
                added.push(this.branchList[fo].code);
                toReturn += '<small>' + this.branchList[fo].name + '<br /></small>';
              }
            }
          }
        }
        return toReturn;
      },
      fncShowDepartmentFilters() {
        var toReturn = '';
        var added = [];
        // var departmentList = this.fncSetFilters('department');
        for (var d in this.objDepartment) {
          if (this.objDepartment[d] != 'all') {
            for (var fo in this.departmentList) {
              if (this.objDepartment[d] == this.departmentList[fo].id && added.indexOf(this.departmentList[fo].name) == -1) {
                added.push(this.departmentList[fo].name);
                toReturn += '<small>' + this.departmentList[fo].name + '<br /></small>';
              }
            }
          }
        }
        return toReturn;
      },
      fncShowStatusFilters() {
        var toReturn = '';
        var added = [];
        for (var s in this.objStatus) {
          if (this.objStatus[s] != 'all') {
            var statusList = this.statusList;
            for( var sc in statusList ) {
              if (this.objStatus[s] == statusList[sc].description && added.indexOf(statusList[sc].description) == -1) {
                added.push(statusList[sc].description);
                toReturn += '<small>' + statusList[sc].description + '<br /></small>';
              }
            }
            /*for( var so in this.newReportFilters.status ) {
              if( this.objStatus[s] == so ) {
                toReturn += '<small>' + this.newReportFilters.status[so] + '<br /></small>';
              }
            }*/
          }
          /*if (this.objStatus[s] != 'all') {
            for (var fs in this.objQuoteFilters.status) {
              if (this.objQuoteFilters.status[fs] != undefined ) {
                if (this.objStatus[s] == this.objQuoteFilters.status[fs].name && added.indexOf(this.objQuoteFilters.status[fs].name) == -1) {
                  added.push(this.objQuoteFilters.status[fs].name);
                  toReturn += '<small>' + this.objQuoteFilters.status[fs].name + '<br /></small>';
                }
              }
            }
          }*/
        }
        return toReturn;
      },
      fncShowRepFilters() {

        var toDisplay = [];
        for( var i in this.repUsers ){
          if( this.objRep.indexOf(this.repUsers[i].id) != -1 ) {
            toDisplay.push( this.repUsers[i].fullname );
          }
        }
        if( toDisplay.length > 0 ) {
          var toReturn = '';
          for( var d in toDisplay ) {
            toReturn += '<small>'+toDisplay[d]+'</small><br />';
          }
        }
        return toReturn;
      },
      fncShowRegionFilters() {
        var toReturn = '';
        for( var r in this.objRegion ){
          toReturn += '<small>'+this.objRegion[r]+'</small><br />';
        }
        return toReturn;
      },
      fncShowProjectFilters() {
        var toReturn = '';
        var added = [];
        for (var p in this.objProject) {
          if (this.objProject[p] != 'all') {
            for (var fp in this.objQuoteFilters.projects) {
              if (this.objProject[p] == this.objQuoteFilters.projects[fp].name && added.indexOf(this.objQuoteFilters.projects[fp].name) == -1) {
                added.push(this.objQuoteFilters.projects[fp].name);
                toReturn += '<small>' + this.objQuoteFilters.projects[fp].name + '<br /></small>';
              }
            }
          }
        }
        return toReturn;
      },
      fncShowSpecifierFilters() {
        var toReturn = '';
        var added = [];
        for (var s in this.objSpecifier) {
          if (this.objSpecifier[s] != 'all') {
            for (var fs in this.objQuoteFilters.specifier) {
              if (this.objSpecifier[s] == this.objQuoteFilters.specifier[fs].name && added.indexOf(this.objQuoteFilters.specifier[fs].name) == -1) {
                added.push(this.objQuoteFilters.specifier[fs].name);
                toReturn += '<small>' + this.objQuoteFilters.specifier[fs].name + '<br /></small>';
              }
            }
          }
        }
        return toReturn;
      },
      fncShowCustomerUserFilters() {
        var toReturn = '';
        var added = [];
        for (var s in this.objCustomerUser) {
          if (this.objCustomerUser[s] != 'all') {
            //var customerList = this.fncSetFilters('customer');
            var quoteList = this.quoteList;
            for( var sc in quoteList ) {
              if (this.objCustomerUser[s] == quoteList[sc].customer_id && added.indexOf(quoteList[sc].customer_id) == -1) {
                added.push(quoteList[sc].customer_id);
                var objName = quoteList[sc].customer_name.split(' ');
                if( objName.length == 2 ) {
                  if( objName[0] == objName[1] ) {
                    toReturn += '<small>' +objName[0] + '<br /></small>';
                  } else {
                    toReturn += '<small>' +quoteList[sc].customer_name + '<br /></small>';
                  }
                } else {
                  toReturn += '<small>' +quoteList[sc].customer_name + '<br /></small>';
                }
                //toReturn += '<small>' + customerList[sc].name + '<br /></small>';
              }
            }
          }
          /*if (this.objCustomerUser[s] != 'all') {
            for (var fs in this.objQuoteFilters.users) {
              if (this.objCustomerUser[s] == this.objQuoteFilters.users[fs].name && added.indexOf(this.objQuoteFilters.users[fs].name) == -1) {
                added.push(this.objQuoteFilters.users[fs].name);
                toReturn += '<small>' + this.objQuoteFilters.users[fs].name + '<br /></small>';
              }
            }
          }*/
        }
        return toReturn;
      },
      fncShowCustomerCompanyFilters() {
        var toReturn = '';
        var added = [];
        for (var s in this.objCustomerCompany) {
          if (this.objCustomerCompany[s] != 'all') {

            for (var fs in this.objQuoteFilters.company) {
              if (this.objCustomerCompany[s] == this.objQuoteFilters.company[fs].name && added.indexOf(this.objQuoteFilters.company[fs].name) == -1) {
                added.push(this.objQuoteFilters.company[fs].name);
                toReturn += '<small>' + this.objQuoteFilters.company[fs].name + '<br /></small>';
              }
            }
          }
        }
        return toReturn;
      },
      fncToggleFilters() {
        if (this.filterActive == true) {
          this.filterActive = false;
        } else {
          this.filterActive = true;
        }
      },
      fncLinkedQuotes( quote ) {

        this.$store.dispatch({
          type: 'fncPopulateQuoteLinks',
          id: quote.id,
          quote_no: quote.quote_no
        })

        var addedQuoteIds = [];
        var addedQuotes = [];

        /*console.log( this.quoteLinks );

        for( var q in this.quoteSearchList ) {
            if( ( this.quoteLinks.indexOf(quote.id) != -1 ) && addedQuoteIds.indexOf(this.quoteSearchList[q].id) == -1 ) {
              addedQuoteIds.push( this.quoteSearchList[q].id );
              addedQuotes.push( this.quoteSearchList[q] );
            }
        }

        console.log( addedQuotes );

        this.quotesLinked = true;
        this.$store.commit('fncSetQuoteListOutright', addedQuotes);*/

        //this.addedQuotes = this.quoteLinks;

        /*var addedQuoteIds = [];
        addedQuoteIds.push( quote.quote_no );

        var addedQuotes = [];
        addedQuotes.push( quote );

        for( var q in this.quoteSearchList ) {
          if( this.quoteSearchList[q].linked_quotes != null ) {
            var linkedQuotes = this.quoteSearchList[q].linked_quotes.split(',');
            if( ( linkedQuotes.indexOf(quote.quote_no) != -1 || linkedQuotes.indexOf(String(quote.quote_no)) != -1 ) && addedQuoteIds.indexOf(this.quoteSearchList[q].quote_no) == -1 ) {
              addedQuoteIds.push( this.quoteSearchList[q].id );
              addedQuotes.push( this.quoteSearchList[q] );
            }
          }
        }

        this.quotesLinked = true;
        this.$store.commit('fncSetQuoteListOutright', addedQuotes);*/
        //this.quoteSearchList = addedQuotes;

      },
      fncGoSaleOrder(quote) {
        this.$store.dispatch('fncProcessOrder', quote);
      },
      fncCheckStatusStatus(quote) {

        if( this.objAuthorize.manufacturer == '385889803' ) {
          /*var toReturn = false;
          for (var q in this.salesOrderStatusses) {
            if (this.salesOrderStatusses[q].quoteId == quote.id) {
              if (this.salesOrderStatusses[q].statusChangeable == false) {
                toReturn = true;
              }
            }
          }
          // we need to check for the statuses listed against this user
          if( toReturn == false ) {
            for( var s in this.statusList ) {
              if( this.statusList[s].description == quote.status ) {
                if( this.statusList[s].roles != null ) {
                  var statusRoles = this.statusList[s].roles.split(',');
                  if( statusRoles.indexOf(this.objAuthorize.roles[0]) == -1 ) {
                    toReturn = true;
                  }
                }
              }
            }
          }
          return toReturn;*/
          return false;
        } else {
          return false;
        }


      },
      setDates() {
        return window.localStorage.reportDates.split(',');
      },
      fncCheckSpecifier() {
        var isAll = false;
        if (this.objSpecifier.length > 1) {
          for (var s in this.objSpecifier) {
            if (this.objSpecifier[s] == 'all') {
              isAll = true;
            }
          }
        } else if (this.objSpecifier.length == 1 && this.objSpecifier[0] == 'all') {
          isAll = true;
        }

        if (this.objSpecifier.length > 1 && isAll == true && this.objSpecifier[0] == 'all') {
          isAll = false;
        }

        if (this.objSpecifier.length == 0) {
          isAll = true;
        }

        if (isAll == true) {
          this.objSpecifier = ['all'];
          localStorage.removeItem('reportSpecifiers');
        } else {
          var index = this.objSpecifier.indexOf('all');
          if (index > -1) {
            this.objSpecifier.splice(index, 1);
          }
        }
        this.fncCustomReportSearch('specifier');
      },
      fncCheckProject() {
        var isAll = false;
        if (this.objProject.length > 1) {
          for (var p in this.objProject) {
            if (this.objProject[p] == 'all') {
              isAll = true;
            }
          }
        } else if (this.objProject.length == 1 && this.objProject[0] == 'all') {
          isAll = true;
        }

        if (this.objProject.length > 1 && isAll == true && this.objProject[0] == 'all') {
          isAll = false;
        }

        if (this.objProject.length == 0) {
          isAll = true;
        }

        if (isAll == true) {
          this.objProject = ['all'];
          localStorage.removeItem('reportProject');
        } else {
          var index = this.objProject.indexOf('all');
          if (index > -1) {
            this.objProject.splice(index, 1);
          }
        }
        this.fncCustomReportSearch('project');
      },
      fncCheckOriginators() {

        var isAll = false;
        if (this.objOriginator.length > 1) {
          for (var o in this.objOriginator) {
            if (this.objOriginator[o] == 'all') {
              isAll = true;
            }
          }
        } else if (this.objOriginator.length == 1 && this.objOriginator[0] == 'all') {
          isAll = true;
        }

        if (this.objOriginator.length > 1 && isAll == true && this.objOriginator[0] == 'all') {
          isAll = false;
        }

        if (this.objOriginator.length == 0) {
          isAll = true;
        }

        if (isAll == true) {
          this.objOriginator = ['all'];
          localStorage.removeItem('reportOriginators');
        } else {
          var index = this.objOriginator.indexOf('all');
          if (index > -1) {
            this.objOriginator.splice(index, 1);
          }
        }
        //this.fncCustomReportSearch('originators');
      },
      fncCheckVendor() {

        var isAll = false;
        if (this.objVendor.length > 1) {
          for (var v in this.objVendor) {
            if (this.objVendor[v] == 'all') {
              isAll = true;
            }
          }
        } else if (this.objVendor.length == 1 && this.objVendor[0] == 'all') {
          isAll = true;
        }

        if (this.objVendor.length > 1 && isAll == true && this.objVendor[0] == 'all') {
          isAll = false;
        }

        if (this.objVendor.length == 0) {
          isAll = true;
        }

        if (isAll == true) {
          this.objVendor = ['all'];
          localStorage.removeItem('reportVendors');
        } else {
          var index = this.objVendor.indexOf('all');
          if (index > -1) {
            this.objVendor.splice(index, 1);
          }
        }
        //this.fncCustomReportSearch('vendors');
      },
      fncCheckDepartment() {

        var isAll = false;
        if (this.objDepartment.length > 1) {
          for (var d in this.objDepartment) {
            if (this.objDepartment[d] == 'all') {
              isAll = true;
            }
          }
        } else if (this.objDepartment.length == 1 && this.objDepartment[0] == 'all') {
          isAll = true;
        }

        if (this.objDepartment.length > 1 && isAll == true && this.objDepartment[0] == 'all') {
          isAll = false;
        }

        if (this.objDepartment.length == 0) {
          isAll = true;
        }

        if (isAll == true) {
          this.objDepartment = ['all'];
          localStorage.removeItem('reportDepartments');
        } else {
          var index = this.objDepartment.indexOf('all');
          if (index > -1) {
            this.objDepartment.splice(index, 1);
          }
        }
        //this.fncCustomReportSearch('departments');
      },
      fncCheckStoreDrop() {

        var isAll = false;
        if (this.objStore.length > 1) {
          for (var d in this.objStore) {
            if (this.objStore[d] == 'all') {
              isAll = true;
            }
          }
        } else if (this.objStore.length == 1 && this.objStore[0] == 'all') {
          isAll = true;
        }

        if (this.objStore.length > 1 && isAll == true && this.objStore[0] == 'all') {
          isAll = false;
        }

        if (this.objStore.length == 0) {
          isAll = true;
        }

        if (isAll == true) {
          this.objStore = ['all'];
          localStorage.removeItem('reportStores');
        } else {
          var index = this.objStore.indexOf('all');
          if (index > -1) {
            this.objStore.splice(index, 1);
          }
        }
        this.fncCustomReportSearch('stores');
      },
      fncCheckUser() {
        var isAll = false;
        if (this.objCustomerUser.length > 1) {
          for (var c in this.objCustomerUser) {
            if (this.objCustomerUser[c] == 'all') {
              isAll = true;
            }
          }
        } else if (this.objCustomerUser.length == 1 && this.objCustomerUser[0] == 'all') {
          isAll = true;
        }

        if (this.objCustomerUser.length > 1 && isAll == true && this.objCustomerUser[0] == 'all') {
          isAll = false;
        }

        if (this.objCustomerUser.length == 0) {
          isAll = true;
        }

        if (isAll == true) {
          this.objCustomerUser = ['all'];
          localStorage.removeItem('reportUsers');
        } else {
          var index = this.objCustomerUser.indexOf('all');
          if (index > -1) {
            this.objCustomerUser.splice(index, 1);
          }
        }
        this.fncCustomReportSearch('companyuser');
      },
      fncCheckCompany() {
        var isAll = false;
        if (this.objCustomerCompany.length > 1) {
          for (var c in this.objCustomerCompany) {
            if (this.objCustomerCompany[c] == 'all') {
              isAll = true;
            }
          }
        } else if (this.objCustomerCompany.length == 1 && this.objCustomerCompany[0] == 'all') {
          isAll = true;
        }

        if (this.objCustomerCompany.length > 1 && isAll == true && this.objCustomerCompany[0] == 'all') {
          isAll = false;
        }

        if (this.objCustomerCompany.length == 0) {
          isAll = true;
        }

        if (isAll == true) {
          this.objCustomerCompany = ['all'];
          localStorage.removeItem('reportCompanies');
        } else {
          var index = this.objCustomerCompany.indexOf('all');
          if (index > -1) {
            this.objCustomerCompany.splice(index, 1);
          }
        }
        this.fncCustomReportSearch('company');
      },
      fncCheckStatus() {

        var isAll = false;
        if (this.objStatus.length > 1) {
          for (var s in this.objStatus) {
            if (this.objStatus[s] == 'all') {
              isAll = true;
            }
          }
        } else if (this.objStatus.length == 1 && this.objStatus[0] == 'all') {
          isAll = true;
        }

        if (this.objStatus.length > 1 && isAll == true && this.objStatus[0] == 'all') {
          isAll = false;
        }

        if (this.objStatus.length == 0) {
          isAll = true;
        }

        if (isAll == true) {
          this.objStatus = ['all'];
          localStorage.removeItem('reportStatus');
        } else {
          var index = this.objStatus.indexOf('all');
          if (index > -1) {
            this.objStatus.splice(index, 1);
          }
        }

        this.fncCustomReportSearch('status');
      },
      fncUpper( string ) {
        return string.toUpperCase();
      },
      fncCustomReportSearch(type) {

        if( type == 'search' && this.search == '' ) {
          this.fncSearchNewQuotes();
        } else {
          if (this.$refs.dateSelect != null ) {
            this.$refs.dateSelect[0].closePopup();
          }

          if (
            (this.objCustomerRegion.length > 0 && this.objCustomerRegion[0] != 'all') ||
            (this.objOriginator.length > 0 && this.objOriginator[0] != 'all') ||
            (this.objStatus.length > 0 && this.objStatus[0] != 'all') ||
            (this.objCustomerCompany.length > 0 && this.objCustomerCompany[0] != 'all') ||
            (this.objCustomerUser.length > 0 && this.objCustomerUser[0] != 'all') ||
            (this.objProject.length > 0 && this.objProject[0] != 'all') ||
            (this.objSpecifier.length > 0 && this.objSpecifier[0] != 'all') ||
            (this.objDepartment.length > 0 && this.objDepartment[0] != 'all') ||
            (this.objStore.length > 0 && this.objStore[0] != 'all') ||
            (this.objVendor.length > 0 && this.objVendor[0] != 'all')) {
            this.hasFilters = true;
          } else {
            this.hasFilters = false;
            type = '';
          }

          if( this.hasFilters == false && this.reportDate != '' ) {
            this.hasFiltersDateOnly = true;
          }

          if ( type == '' ) {
            var newPush = [];
            newPush.push(type);
            localStorage.setItem('searchOrder', JSON.stringify(newPush));
          } else if (window.localStorage.searchOrder == null || window.localStorage.searchOrder == 'undefined') {
            var newPush = [];
            newPush.push(type);
            localStorage.setItem('searchOrder', JSON.stringify(newPush));
          } else {
            var oldPush = JSON.parse(window.localStorage.searchOrder);

            var checkEmpty = '';
            if (type == 'search') {
              checkEmpty = this.search;
            } else if (type == 'date') {
              checkEmpty = this.reportDate;
            } else if (type == 'specifier') {
              checkEmpty = this.objSpecifier;
            } else if (type == 'project') {
              checkEmpty = this.objProject;
            } else if (type == 'originators') {
              checkEmpty = this.objOriginator;
            } else if (type == 'status') {
              checkEmpty = this.objStatus;
            } else if (type == 'user') {
              checkEmpty = this.objCustomerUser;
            } else if (type == 'company') {
              checkEmpty = this.objCustomerCompany;
            } else if (type == 'vendors') {
              checkEmpty = this.objVendor;
            } else if (type == 'departments') {
              checkEmpty = this.objDepartment;
            } else if (type == 'stores') {
              checkEmpty = this.objStore;
            }

            if (oldPush.indexOf(type) == -1) {
              oldPush.push(type);
              localStorage.setItem('searchOrder', JSON.stringify(oldPush));
            } else if (checkEmpty == '') {
              oldPush = oldPush.filter(function (e) { return e !== type });
              localStorage.setItem('searchOrder', JSON.stringify(oldPush));
            }

          }

          console.log('Three');
          // set the vars here call original object
          localStorage.setItem('reportSearch', this.search);

          if (this.reportDate != '') {
            localStorage.setItem('reportDates', this.reportDate.toString());
          } else {
            localStorage.removeItem('reportDates');
          }

          if (this.objOriginator != '' && this.objOriginator[0] != 'all' ) {
            localStorage.setItem('reportOriginators', JSON.stringify(this.objOriginator));
          } else {
            localStorage.removeItem('reportOriginators');
          }

          if (this.objStatus != '' && this.objStatus[0] != 'all' ) {
            localStorage.setItem('reportStatus', JSON.stringify(this.objStatus));
          } else {
            localStorage.removeItem('reportStatus');
          }

          if (this.objKam != '' && this.objKam[0] != 'all' ) {
            localStorage.setItem('reportKams', JSON.stringify(this.objKam));
          } else {
            localStorage.removeItem('reportKams');
          }

          if (this.objQuoteType != '' && this.objQuoteType[0] != 'all' ) {
            localStorage.setItem('reportQuoteType', JSON.stringify(this.objQuoteType));
          } else {
            localStorage.removeItem('reportQuoteType');
          }

          if (this.objServiceType != '' && this.objServiceType[0] != 'all' ) {
            localStorage.setItem('reportServiceType', JSON.stringify(this.objServiceType));
          } else {
            localStorage.removeItem('reportServiceType');
          }

          if (this.objcOriginator != '' && this.objcOriginator[0] != 'all' ) {
            localStorage.setItem('reportcOriginator', JSON.stringify(this.objcOriginator));
          } else {
            localStorage.removeItem('reportcOriginator');
          }

          if (this.objQuoteType != '' && this.objQuoteType[0] != 'all' ) {
            localStorage.setItem('reportQuoteType', JSON.stringify(this.objQuoteType));
          } else {
            localStorage.removeItem('reportQuoteType');
          }

          if (this.objServiceType != '' && this.objServiceType[0] != 'all' ) {
            localStorage.setItem('reportServiceType', JSON.stringify(this.objServiceType));
          } else {
            localStorage.removeItem('reportServiceType');
          }

          if (this.objProject != '' && this.objProject[0] != 'all') {
            localStorage.setItem('reportProject', JSON.stringify(this.objProject));
          } else {
            localStorage.removeItem('reportProject');
          }

          if (this.objCustomerUser != '' && this.objCustomerUser[0] != 'all') {
            localStorage.setItem('reportUsers', JSON.stringify(this.objCustomerUser));
          } else {
            localStorage.removeItem('reportUsers');
          }

          if (this.objCustomerCompany != '' && this.objCustomerCompany[0] != 'all') {
            localStorage.setItem('reportCompanies', JSON.stringify(this.objCustomerCompany));
          } else {
            localStorage.removeItem('reportCompanies');
          }

          if (this.objSpecifier != '' && this.objSpecifier[0] != 'all') {
            localStorage.setItem('reportSpecifiers', JSON.stringify(this.objSpecifier));
          } else {
            localStorage.removeItem('reportSpecifiers');
          }

          if (this.objVendor != '' && this.objVendor[0] != 'all') {
            localStorage.setItem('reportVendors', JSON.stringify(this.objVendor));
          } else {
            localStorage.removeItem('reportVendors');
          }

          if (this.objDepartment != '' && this.objDepartment[0] != 'all') {
            localStorage.setItem('reportDepartments', JSON.stringify(this.objDepartment));
          } else {
            localStorage.removeItem('reportDepartments');
          }

          if (this.objStore != '' && this.objStore[0] != 'all') {
            localStorage.setItem('reportStores', JSON.stringify(this.objStore));
          } else {
            localStorage.removeItem('reportStores');
          }

          // HERE

          this.$store.commit({
            type: 'setQuoteList',
            quotes: this.quoteList,
            departments: this.departmentList,
            branches: this.branchList,
            loggedUser: this.objAuthorize
          })
        }

      },
      fncGetWidth(columnId) {
        var setWidth = '';
        for (var k in this.objQuoteSettings) {
          if (this.objQuoteSettings[k].id == columnId) {
            setWidth = this.objQuoteSettings[k].width;
          }
          if (setWidth == 'auto') {
            setWidth = '165px';
            if (this.objQuoteSettings[k].label.toLowerCase() == 'preferred follow up method') {
              setWidth = '275px';
            } else if (this.objQuoteSettings[k].label == 'Customer Email' || this.objQuoteSettings[k].label == 'Customer Name' || this.objQuoteSettings[k].label == 'Originator Name') {
              setWidth = '250px';
            } else if (this.objQuoteSettings[k].label == 'Status') {
              setWidth = '500px';
            } else if (this.objQuoteSettings[k].label == 'Quote Date' || this.objQuoteSettings[k].label == 'Process Order') {
              setWidth = '200px';
            } else if (this.objQuoteSettings[k].label == 'Company Name' || this.objQuoteSettings[k].label == 'Quote Type') {
              setWidth = '225px';
            } else if (this.objQuoteSettings[k].label == 'Customer Type') {
              setWidth = '175px';
            } else if (this.objQuoteSettings[k].label == 'Store') {
              setWidth = '175px';
            } else if (this.objQuoteSettings[k].label == 'Installation Description' || this.objQuoteSettings[k].label == 'Cancellation Reason') {
              setWidth = '250px';
            } else if ( this.objQuoteSettings[k].label == 'Commercial KAM' || this.objQuoteSettings[k].label == 'Commercial Originator') {
              setWidth = '250px';
            } else if (this.objQuoteSettings[k].label == 'Purchase Order Number' || this.objQuoteSettings[k].label == 'Calculator') {
              setWidth = '250px';
            } else if( this.objQuoteSettings[k].label == 'Responsible Rep' || isNaN(columnId) == false || this.objQuoteSettings[k].label == 'Customer Recipient' || this.objQuoteSettings[k].label == 'Vendor Recipient' ) {
              setWidth = '350px';
            }
          }
        }
        return setWidth;
      },
      fncGetDepartment( objItem, key ) {

        var returnDepartment = 'N/A';

        var departmentName = [];

        var hasDepartment = false;
        if( objItem.pCodes ) {
          var productCodes = objItem.pCodes.split(',');
        } else {
          var productCodes = [];
        }


        if( this.surveyList[objItem.id] != undefined && this.surveyList[objItem.id] != null ) {
          for( var d in this.departmentList ) {
            if( this.departmentList[d].id == this.surveyList[objItem.id] ) {
              returnDepartment = this.departmentList[d].name;
              hasDepartment = true;
            }
          }
        }

        if( productCodes.length > 0 && hasDepartment == false ) {
          for( var d in this.departmentList ) {
            if( this.departmentList[d].product_codes != null ) {
              if( this.departmentList[d].product_codes.length > 0 ) {
                for( var c in this.departmentList[d].product_codes ) {
                  for( var p in productCodes ) {
                    if( productCodes[p] == this.departmentList[d].product_codes[c].value ) {
                      returnDepartment = this.departmentList[d].name;
                      hasDepartment = true;
                      return returnDepartment;
                    }
                  }
                }
              }
            }
          }
        }

        if( objItem.range_id != null && objItem.range_id != undefined && hasDepartment == false ) {
          var departmentRanges = this.departmentList;
          var filteredQuotes = [];
          var quoteRanges = objItem.range_id.split(',');
          for( var d in departmentRanges ) {
            for( var qr in quoteRanges ) {
              for( var dr in departmentRanges[d].ranges ) {
                if( quoteRanges[qr] == departmentRanges[d].ranges[dr] ) {
                  departmentName.push( departmentRanges[d].name );
                }
              }
            }
          }
          var uniqueDepartment = departmentName.filter((v, i, a) => a.indexOf(v) === i);
          if( uniqueDepartment.length == 0 ) {
            if( objItem.originator_department != '' && objItem.originator_department != null ) {
              /*for( var d in this.departmentList ) {
                if( this.departmentList[d].id == objItem.originator_department ) {
                  returnDepartment = this.departmentList[d].name;
                  hasDepartment = true;
                }
              }*/
            } else {
              if( objItem.departmentUser != '' && objItem.departmentUser != null ) {
                /*for( var d in this.departmentList ) {
                  if( this.departmentList[d].id == objItem.departmentUser ) {
                    returnDepartment = this.departmentList[d].name;
                    hasDepartment = true;
                  }
                }*/
                return returnDepartment;
              } else {
                var productCodes = [];

                if( objItem.product_codes != false && objItem.product_codes != undefined ) {
                  var line_item_data = JSON.parse( objItem.product_codes ).split('|||');
                  if( line_item_data.length > 0 ) {
                    for( var l in line_item_data ) {
                      if( typeof line_item_data[l] == 'string' ) {
                        var lineObj = line_item_data[l];
                      } else {
                        var lineObj = JSON.parse( line_item_data[l]);
                      }
                      //var lineObj = JSON.parse(JSON.parse( line_item_data[l] ));

                      if( lineObj.product_code != null && productCodes.indexOf(lineObj.product_code) == -1 ) {
                        productCodes.push(lineObj.product_code);
                      }
                    }
                  }
                }

                if( productCodes.length > 1 ) {
                  returnDepartment = 'N/A';
                  hasDepartment = true;
                } else {
                  for( var d in this.departmentList ) {
                    if( this.departmentList[d].product_codes && this.departmentList[d].product_codes.length > 0 ) {
                      for( var c in this.departmentList[d].product_codes ) {
                        if( productCodes[0] == this.departmentList[d].product_codes[c].value ) {
                          returnDepartment = this.departmentList[d].name;
                          hasDepartment = true;
                        }
                      }
                    }
                  }
                }
              }
            }
          } else if( uniqueDepartment.length > 1 ) {
            /*if( objItem.departmentUser != '' && objItem.departmentUser != null ) {
              for( var d in this.departmentList ) {
                if( this.departmentList[d].id == objItem.departmentUser ) {
                  returnDepartment = this.departmentList[d].name;
                  hasDepartment = true;
                }
              }
              return returnDepartment;
            } else {
              returnDepartment = 'N/A';
              hasDepartment = true;
            }*/
          } else {
            returnDepartment = uniqueDepartment[0];
            hasDepartment = true;
          }
        }

        /*if( hasDepartment == false ) {
          if( objItem.originator_department != '' && objItem.originator_department != null ) {
            for( var d in this.departmentList ) {
              if( this.departmentList[d].id == objItem.originator_department ) {
                returnDepartment = this.departmentList[d].name;
              }
            }
          } else {
            if( objItem.departmentUser != '' && objItem.departmentUser != null ) {
              for( var d in this.departmentList ) {
                if( this.departmentList[d].id == objItem.departmentUser ) {
                  returnDepartment = this.departmentList[d].name;
                }
              }
              return returnDepartment;
            } else {
              returnDepartment = 'N/A';
            }
          }
        }*/
        return returnDepartment;
      },
      fncGetDepartmentId( objItem, key ) {

        var returnDepartment = 'N/A';

        var departmentName = [];

        // check for product code first
        /*var productCodes = [];
        var line_item_data = JSON.parse( objItem.product_codes ).split('|||');
        if( line_item_data.length > 0 ) {
          for( var l in line_item_data ) {
            var lineObj = JSON.parse( line_item_data[l] );
            if( lineObj.product_code != null && productCodes.indexOf(lineObj.product_code) == -1 ) {
              productCodes.push(lineObj.product_code);
            }
          }
        }*/

        var hasDepartment = false;
        var productCodes = objItem.pCodes.split(',');

        if( productCodes.length > 0 ) {
          for( var d in this.departmentList ) {
            if( this.departmentList[d].product_codes != null ) {
              if( this.departmentList[d].product_codes.length > 0 ) {
                for( var c in this.departmentList[d].product_codes ) {
                  for( var p in productCodes ) {
                    if( productCodes[p] == this.departmentList[d].product_codes[c].value ) {
                      returnDepartment = this.departmentList[d].id;
                      hasDepartment = true;
                      return returnDepartment;
                    }
                  }
                }
              }
            }
          }
        }

        if( objItem.range_id != null && objItem.range_id != undefined && hasDepartment == false ) {
          var departmentRanges = this.departmentList;
          var filteredQuotes = [];
          var quoteRanges = objItem.range_id.split(',');
          for( var d in departmentRanges ) {
            for( var qr in quoteRanges ) {
              for( var dr in departmentRanges[d].ranges ) {
                if( quoteRanges[qr] == departmentRanges[d].ranges[dr] ) {
                  departmentName.push( departmentRanges[d].id );
                }
              }
            }
          }
          var uniqueDepartment = departmentName.filter((v, i, a) => a.indexOf(v) === i);
          if( uniqueDepartment.length == 0 ) {
            if( objItem.originator_department != '' && objItem.originator_department != null ) {
              /*for( var d in this.departmentList ) {
                if( this.departmentList[d].id == objItem.originator_department ) {
                  returnDepartment = this.departmentList[d].name;
                  hasDepartment = true;
                }
              }*/
            } else {
              if( objItem.departmentUser != '' && objItem.departmentUser != null ) {
                /*for( var d in this.departmentList ) {
                  if( this.departmentList[d].id == objItem.departmentUser ) {
                    returnDepartment = this.departmentList[d].name;
                    hasDepartment = true;
                  }
                }*/
                return returnDepartment;
              } else {
                var productCodes = [];

                if( objItem.product_codes != false && objItem.product_codes != undefined ) {
                  var line_item_data = JSON.parse( objItem.product_codes ).split('|||');
                  if( line_item_data.length > 0 ) {
                    for( var l in line_item_data ) {
                      if( typeof line_item_data[l] == 'string' ) {
                        var lineObj = line_item_data[l];
                      } else {
                        var lineObj = JSON.parse( line_item_data[l]);
                      }
                      //var lineObj = JSON.parse(JSON.parse( line_item_data[l] ));

                      if( lineObj.product_code != null && productCodes.indexOf(lineObj.product_code) == -1 ) {
                        productCodes.push(lineObj.product_code);
                      }
                    }
                  }
                }

                if( productCodes.length > 1 ) {
                  returnDepartment = 'N/A';
                  hasDepartment = true;
                } else {
                  for( var d in this.departmentList ) {
                    if( this.departmentList[d].product_codes && this.departmentList[d].product_codes.length > 0 ) {
                      for( var c in this.departmentList[d].product_codes ) {
                        if( productCodes[0] == this.departmentList[d].product_codes[c].value ) {
                          returnDepartment = this.departmentList[d].id;
                          hasDepartment = true;
                        }
                      }
                    }
                  }
                }
              }
            }
          } else if( uniqueDepartment.length > 1 ) {
            /*if( objItem.departmentUser != '' && objItem.departmentUser != null ) {
              for( var d in this.departmentList ) {
                if( this.departmentList[d].id == objItem.departmentUser ) {
                  returnDepartment = this.departmentList[d].name;
                  hasDepartment = true;
                }
              }
              return returnDepartment;
            } else {
              returnDepartment = 'N/A';
              hasDepartment = true;
            }*/
          } else {
            returnDepartment = uniqueDepartment[0];
            hasDepartment = true;
          }
        }

        /*if( hasDepartment == false ) {
          if( objItem.originator_department != '' && objItem.originator_department != null ) {
            for( var d in this.departmentList ) {
              if( this.departmentList[d].id == objItem.originator_department ) {
                returnDepartment = this.departmentList[d].name;
              }
            }
          } else {
            if( objItem.departmentUser != '' && objItem.departmentUser != null ) {
              for( var d in this.departmentList ) {
                if( this.departmentList[d].id == objItem.departmentUser ) {
                  returnDepartment = this.departmentList[d].name;
                }
              }
              return returnDepartment;
            } else {
              returnDepartment = 'N/A';
            }
          }
        }*/
        return returnDepartment;
      },
      fncFormatColumn(objItem, key) {
        switch (key) {
          /*case 'customerRecipient':
            if( objItem.customer_recipient != '' ) {
              return objItem.customer_recipient;
            } else {
              return 'N/A';
            }*/
          case 'poNumbers':

            var poSplit = objItem.po_numbers.split(',');
            if( poSplit.length == 0 ) {
              return 'N/A';
            } else {
              var newPo = [];
              for( var p in poSplit ) {
                if( poSplit[p] != '' && poSplit[p] != '0' ) {
                  newPo.push(poSplit[p]);
                }
              }
              if( newPo.length != 0 ) {
                return newPo.join(', ');
              } else {
                return 'N/A';
              }
            }
          case 'addressType':
            if( objItem.collect_address != '0' ) {
              return 'Collect'
            } else if( objItem.delivery_address != '0' ) {
              return 'Deliver'
            } else {
              return 'N/A';
            }
          case 'appointmentDate':
            if( objItem.process_data != null && objItem.process_data != 'null' ) {
              var processData = JSON.parse( objItem.process_data );
              for( var f in processData.tabs ) {
                for( var fd in processData.tabs[f] ) {
                    for( var td in processData.tabs[f].form ) {
                      if( processData.tabs[f].form[td].label == 'Preferred Date' ) {
                        if( processData.tabs[f].form[td].value != '' ) {
                          return processData.tabs[f].form[td].value;
                        } else {
                          return 'N/A';
                        }
                      }
                    }
                }
              }
            } else {
              return 'N/A';
            }
          case 'appointmentTime':
            if( objItem.process_data != null && objItem.process_data != 'null' ) {
              var processData = JSON.parse( objItem.process_data );
              for( var f in processData.tabs ) {
                for( var fd in processData.tabs[f] ) {
                  for( var td in processData.tabs[f].form ) {
                    if( processData.tabs[f].form[td].label == 'Preferred Time' ) {
                      if( processData.tabs[f].form[td].value != '' ) {
                        return processData.tabs[f].form[td].value;
                      } else {
                        return 'N/A';
                      }
                    }
                  }
                }
              }
            } else {
              return 'N/A';
            }
          case 'quoteRegion':
            /*if( objItem.spec ) {
              var regionSplit = objItem.spec.split("<span class='quoteRegion'>");
              if( regionSplit.length > 1 ) {
                var regionSplitName = regionSplit[1].split('</span>');
                return regionSplitName[0];
              } else {
                return 'N/A';
              }
            } else {
              return 'N/A';
            }*/
            return this.fncCheckStoreLocation(objItem.store_name);
            break;
          case 'customerRejectReason':
            if( objItem.audit_data == '' || objItem.audit_data == null || objItem.audit_data == 'null' ) {
              return 'N/A';
            } else {
              var cancelReasons = ["Cost", "Not Interested Anymore", "Unhappy With The Service", "Was Just Checking Cost"];
              var objReasons = objItem.audit_data.split(',');
              for( var r in objReasons ){
                if( cancelReasons.indexOf( objReasons[r] ) != -1 ) {
                  return objReasons[r];
                }
              }
              //return objItem.audit_data;
              return 'N/A';
            }
          case 'quote_date':

            var options = {
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
              hour: "numeric",
              minute: "numeric",
              hour12: false
            };

            var newDate = new Date( Date.parse(objItem[key] + ' UTC') );
            var dateString = newDate.toLocaleString("en", options);
            var objDate = dateString.split(',');

            var newDate = objDate[0].split('/');

            var strDate = newDate[2] + '-' + newDate[0] + '-' + newDate[1] + ' ' + objDate[1];

            return strDate;
          case 'onsiteTime':
            var statusName = '';
            for( var s in this.statusList ) {
              if( this.statusList[s].fs_on_site == 'Yes' || this.statusList[s].fs_on_site == '1' ) {
                statusName = this.statusList[s].description;
              }
            }
            var toReturn = 'N/A';
            if( this.manufacturerAudits != undefined && this.manufacturerAudits[objItem.id] != null ) {
              if( this.manufacturerAudits[objItem.id][statusName] != null ) {
                toReturn = this.manufacturerAudits[objItem.id][statusName].time;
              }
            }
            return toReturn;
            break;
          case 'jobCompleteDate':
            var statusName = '';
            for( var s in this.statusList ) {
              if( this.statusList[s].fs_job_complete == 'Yes' || this.statusList[s].fs_job_complete == '1' ) {
                statusName = this.statusList[s].description;
              }
            }
            var toReturn = 'N/A';
            if( this.manufacturerAudits != undefined && this.manufacturerAudits[objItem.id] != null ) {
              if( this.manufacturerAudits[objItem.id][statusName] != null ) {
                toReturn = this.manufacturerAudits[objItem.id][statusName].time;
              }
            }
            return toReturn;
            break;
          case 'cancellationReason':
            var statusName = '';
            for( var s in this.statusList ) {
              if( this.statusList[s].fs_job_cancelled == 'Yes' || this.statusList[s].fs_job_cancelled == '1' ) {
                statusName = this.statusList[s].description;
              }
            }
            var toReturn = 'N/A';
            if( this.manufacturerAudits != undefined && this.manufacturerAudits[objItem.id] != null ) {
              if( this.manufacturerAudits[objItem.id][statusName] != null ) {
                toReturn = this.manufacturerAudits[objItem.id][statusName].data;
              }
            }
            return toReturn;
            break;
          case 'status_change_reason':
            return '<span id="reason_'+objItem.id+'">' + objItem.status_change_reason + '</span>';
            break;
          case 'customerRating':
            if( objItem.rating == '0' ) {
              return 'N/A';
            } else {
              return objItem.rating;
            }
            break;
          case 'installationDate':
            var lineData = objItem.product_codes;
            var installationDate = 'N/A';
              if( objItem.product_codes && lineData.indexOf('installation_appointment_date_start') != -1 ) {
                var timeSplit = lineData.split('installation_appointment_date_start');
                var newSplit = timeSplit[1].replace(/"/g, "");
                    newSplit = newSplit.replace(/'/g, "");
                    newSplit = newSplit.replace(/:/g, "");
                    newSplit = newSplit.replace(/\//g,'')
                    newSplit = newSplit.split('\\');
                installationDate = newSplit[2];
                var onjInstallDate = installationDate.split(',');
                installationDate = onjInstallDate[ onjInstallDate.length - 1 ];
              }
              return installationDate;
            break;
          case 'installationDescription':
            var lineData = objItem.product_codes;
            var installationDescription = 'N/A';
            if( objItem.product_codes && lineData.indexOf('installation_product_description_1') != -1 ) {
              var timeSplit = lineData.split('installation_product_description_1');
              var newSplit = timeSplit[1].replace(/"/g, "");
              newSplit = newSplit.replace(/'/g, "");
              newSplit = newSplit.replace(/:/g, "");
              newSplit = newSplit.replace(/\//g,'')
              newSplit = newSplit.split('\\');
              installationDescription = newSplit[2];
            }
            return installationDescription;
            break;
          case 'serviceType':
            if( objItem.service_type == '3' ) {
              return 'Commercial';
            } else if( objItem.service_type == '1' ) {
              return 'Assisted Service';
            } else if( objItem.service_type == '2' ) {
                return 'Self Service';
            } else {
              return 'Unknown';
            }
            break;
          case 'soNumber':
            if( objItem.sales_order_number != null && objItem.sales_order_number != undefined ) {
              return objItem.sales_order_number
            } else {
              return 'N/A';
            }
            break;
          case 'department':
            //return this.fncGetDepartment( objItem, key );
            return objItem.departmentName;
            break;
          case 'quote_no':
            return '<span class="quoteSettings"><strong style="margin-top: 0px !important;">' + objItem[key] + '</strong></span>&nbsp;&nbsp;';
            break;
          case 'sub_total':
            return '<strong>' + this.fncFixedRand(objItem.pricing_subtotal, objItem.override_currency_sym) + '</strong>';
            break;
          case 'vat':
            return '<strong>' + this.fncFixedRand(objItem.pricing_vat, objItem.override_currency_sym) + '</strong>';
            break;
          case 'total':
            return '<strong>' + this.fncFixedRand(objItem.pricing_total, objItem.override_currency_sym) + '</strong>';
            break;
          case 'discount_value':
            return this.fncFixedRand(objItem.discount_val, objItem.override_currency_sym);
            break;
          case 'pre_discount_total':
            return this.fncFixedRand(objItem.discount_val, objItem.override_currency_sym);
            break;
          case 'customer_region':
            return this.fncCheckNull(objItem.customer_region);
            break;
          case 'originator_region':
            return this.fncCheckNull(objItem.originator_region);
            break;
          case 'status':
            //  return '<strong class="cursor">&nbsp;' + objItem.status + '</strong>';
            break;
          case 'process_order':
            //return 'Meh';
            //  return '<strong class="cursor">&nbsp;' + objItem.status + '</strong>';
            break;
          case 'orig_name':
            if( objItem.orig_name != '' && objItem.orig_name!= null ) {
              var origName = objItem.orig_name.split(' ');
              if( origName.length == 2 ) {
                if( origName[0] == origName[1] ) {
                  return '<strong class="cursor">' + origName[0] + '</strong>';
                } else {
                  return '<strong class="cursor">' + objItem.orig_name + '</strong>';
                }
              } else {
                return '<strong class="cursor">' + objItem.orig_name + '</strong>';
              }
            } else {
              return '<strong class="cursor">N/A</strong>';
            }
            break;
          case 'store_name':
            return this.fncCheckStore(objItem.store_name);
            break;
          case 'responsible_representative':

            if( this.objAuthorize.manufacturer != '385889803' ) {
              var resRep = objItem.responsible_representative;
              if ( resRep == 'N/A' ) {
                resRep = 'None';
              }

              if (resRep.length >  24 ) {
                return '<strong class="cursor">' + resRep.substr(0,24) + '...</strong>';
              } else {
                return '<strong class="cursor">' + resRep + '</strong>';
              }
            } else {
              return '';
            }
            //return '<strong class="cursor">'+objItem.responsible_representative+'</strong>';
            //return '<strong class="cursor">&nbsp;Click to View Reps</strong>';
            break;
          case 'customer_name':
            if (objItem.customer_name == null ) {
              return 'N/A';
            } else {

              var toSplit = 'N/A';
              var userSplit = objItem.customer_name.split(' - ');
              if (userSplit.length == 1) {
                toSplit = userSplit[0];
                //return '<strong class="cursor">' + userSplit[0] + '</strong>';
              } else if (userSplit.length == 2) {
                toSplit = userSplit[1];
                //return '<strong class="cursor">' + userSplit[1] + '</strong>';
              } else if (userSplit.length == 3) {
                toSplit = userSplit[2];
                //return '<strong class="cursor">' + userSplit[2] + '</strong>';
              }

              var cusName = toSplit.split(' ');
              if( cusName.length == 2 ) {
                if( cusName[0] == cusName[1] ) {
                  return '<strong class="cursor">' + cusName[0] + '</strong>';
                } else {
                  return '<strong class="cursor">' + toSplit + '</strong>';
                }
              } else {
                return '<strong class="cursor">' + toSplit + '</strong>';
              }

            }
            break;
          case 'company_name':
            if( objItem.company_name != 'None' ) {
              return objItem.company_name;
            } else if (objItem.customer_name != null ) {
              var userSplit = objItem.customer_name.split(' - ');
              if (userSplit.length > 1) {
                return userSplit[0];
              } else {
                return 'None';
              }
            } else {
              return 'None';
            }
            break;
          case 'survey_type':
            // this.surveyListQuotes[]
            if( this.surveyListQuotes[objItem.id] == '1' ) {
              return 'Contact Customer';
            } else if( this.surveyListQuotes[objItem.id] == '2' ) {
              return 'Request Quote';
            } else if( this.surveyListQuotes[objItem.id] == '3' ) {
              return 'Callout Request';
            } else if( this.surveyListQuotes[objItem.id] == '4' ) {
              return 'Callout Conversion';
            } else if( this.surveyListQuotes[objItem.id] == '5' ) {
              return 'Request Calculator';
            } else {
              return 'N/A';
            }
            break;
          case 'customerTelephone':
              if( objItem.customer_telephone != '' ) {
                return objItem.customer_telephone;
              } else {
                return 'N/A';
              }
            break;
          case 'customerEmail':
            if( objItem.customer_email != '' ) {
              return objItem.customer_email;
            } else {
              return 'N/A';
            }
            break;
          case 'quoteType':

            if( objItem.product_codes.includes('installation_lookup_service_ref') ) {
              return 'Lookup Service';
            } else if( this.surveyList[objItem.id] != undefined ) {
              return 'Service Form';
            }
            return 'Calculator';
            break;
          case 'calculator':
            if( this.surveyList[objItem.id] != undefined ) {
              return 'Service Form';
            } else if( objItem.item_range != '' ) {
              return objItem.item_range;
            } else {
              return 'N/A';
            }
            break;
          case 'kamRegion':

            var specData = objItem.spec;
            var kamRegion = 'N/A';

            if( objItem.spec && specData.indexOf("<span class='quoteRegion'>") != -1 ) {

              var regionSplit = specData.split("<span class='quoteRegion'>");
              if( regionSplit.length > 1 ) {
                var regionName = regionSplit[1].split('</span>');
                if( regionName.length > 1 ) {
                  kamRegion = regionName[0];
                }
              }
            }
            return kamRegion;
            break;
          case 'orig_type':
            if( objItem[key] == 'Manufacturer User' && this.objAuthorize.manufacturer == '385889803' ) {
              return 'Builders User';
            } else {
              return objItem[key];
            }
            break;
           case 'linkedQuotes':
             return objItem['linked_quotes'];
             break;
          default:
            return objItem[key];
            break;
        }
      },
      fncCheckStore( storeCode ) {
        for( var b in this.branchList ) {
          if( this.branchList[b].code == storeCode ) {
            return this.branchList[b].name;
          }
        }
        return storeCode;
      },
      fncCheckStoreLocation( storeCode ) {
        for( var b in this.branchList ) {
          if( this.branchList[b].code == storeCode ) {
            return this.branchList[b].locationName;
          }
        }
        return storeCode;
      },
      fncFixedRand(val, currencySymbol) {
        if( val == '0' ) {
          return '<span class="floatRight">PENDING</span>';
        } else {
          if (currencySymbol == '' || currencySymbol == null) {
            currencySymbol = 'R';
          }
          return '<span class="floatRight">' + currencySymbol + parseFloat(val).toFixed(2).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") + '</span>';
        }
      },
      fncCheckNull(val) {
        if (val === null) {
          return 'N/A';
        } else {
          return '<span class="cursor">' + val + '</span>';
        }
      },
      fncShowColumn(col) {
      },
      fncEditStatus(objItem, key) {
        if (key === 'originator_region' ) {
          this.$store.dispatch('fncGetUserInfo', objItem.customer);
          var modalDetails = { title: 'Originator Region (' + objItem.orig_name + ')', component: 'modal-user-info', mstate: true, params: { type: 'orig_region' } };
          this.$store.commit({
            type: 'setModal',
            details: modalDetails
          });
        } else if (key === 'customer_region') {
          var cName = '';
          var customer = objItem.customer_name.split('-');
          if (customer.length == 1) {
            cName = customer[0];
          } else {
            cName = customer[1];
          }
          this.$store.dispatch('fncGetUserInfo', objItem.customer);
          var modalDetails = { title: 'Customer Region (' + cName + ')', component: 'modal-user-info', mstate: true, params: { type: 'customer_region' } };
          this.$store.commit({
            type: 'setModal',
            details: modalDetails
          });
        } else if (key === 'status') {
          this.$store.dispatch('fncGetQuoteHistory', objItem.id);
          var modalDetails = { title: 'Status History (' + objItem.quote_no + ')', component: 'modal-quote-history', mstate: true, params: {} };
          this.$store.commit({
            type: 'setModal',
            details: modalDetails
          });
        } else if (key === 'orig_name') {
          this.$store.dispatch('fncGetUserInfo', objItem.originator);
          var modalDetails = { title: 'User Information - ' + objItem.orig_name, component: 'modal-user-info', mstate: true, params: { type: 'orig' } };
          this.$store.commit({
            type: 'setModal',
            details: modalDetails
          });
        } else if (key === 'customer_name') {
          var cName = '';
          var customer = objItem.customer_name.split('-');
          if ( customer.length == 1 ) {
            cName = customer[0];
          } else {
            cName = customer[1];
          }
          this.$store.dispatch('fncGetUserInfo', objItem.customer_id);
          var modalDetails = { title: 'User Information - ' + cName, component: 'modal-user-info', mstate: true, params: { type: 'customer' } };
          this.$store.commit({
            type: 'setModal',
            details: modalDetails
          });
        } else if (key === 'responsible_representative') {
          var modalDetails = { title: 'Link / Unlink Users ( ' + objItem.quote_no+' )', component: 'modal-quote-link-users', mstate: true, params: { quoteId: objItem } };
          this.$store.commit({
            type: 'setModal',
            details: modalDetails
          });
          this.$store.dispatch('fncAvailableReps', objItem.customer_id);
        } else if (key === 'linkedQuotes') {

          alert('Test');
          /*var modalDetails = { title: 'Link / Unlink Users ( ' + objItem.quote_no+' )', component: 'modal-quote-link-users', mstate: true, params: { quoteId: objItem } };
          this.$store.commit({
            type: 'setModal',
            details: modalDetails
          });
          this.$store.dispatch('fncAvailableReps', objItem.customer_id);*/
        }
      },
      fncEditStatusPopup(status, quoteId) {

        var popupStatuses = this.fncGetStatusDropdown(status, quoteId);

        /*var mainThis = this;

        setTimeout(function() {

          status.staticStatus = document.getElementById(quoteId).innerHTML;

            var modalDetails = { title: 'Quote Status Update (' + status.quote_no + ')', component: 'modal-quote-status-update', mstate: true, params: {currentStatus: status.staticStatus, quoteId: quoteId, currentStatusStatic: status.status, object: status, statusList: popupStatuses, quoteTotal: status.pricing_total } };
          mainThis.$store.dispatch('fncPopulateStatusList');
          mainThis.$store.commit({
              type: 'setModal',
              details: modalDetails
            });
        }, 500);*/
      },
      fncDistibuteQuote( objItem, customerEmail ) {
        var modalDetails = { title: 'Distribute Quote', component: 'modal-distribute-quote', mstate: true, params: {quoteId: objItem, customerEmail: customerEmail} };
        this.$store.commit({
          type: 'setModal',
          details: modalDetails
        });
      },
      fncQuoteSettings(quoteId, quoteNo,item) {

        this.$store.dispatch({
          type: 'fncQuoteSettings',
          quoteId: quoteId,
          quoteNo: quoteNo,
          data:item,
        })
        //this.$store.dispatch('fncQuoteSettings', quoteId);
      },
      fncForex(quoteId, quoteNo, currencyType) {
        //this.$store.dispatch('fncGetOriginalForex', currencyType );
        var modalDetails = { title: 'Change Currency - '+quoteNo, component: 'modal-quote-forex', mstate: true, params: { quoteId: quoteId, currencyType: currencyType } };
        this.$store.commit({
          type: 'setModal',
          details: modalDetails
        });
      },
      fncEditQuote( quoteItem ) {

        this.$store.commit('fncSetEditLoading', true);
        this.$store.dispatch('fncSetupQuoteEdit', quoteItem);
        /*var modalDetails = { title: 'Update Details - ' + quoteItem.quote_no, component: 'modal-edit-quote-details', mstate: true, params: { details: quoteItem } };
        this.$store.commit({
          type: 'setModal',
          details: modalDetails
        });*/
      },
      fncViewQuote(quoteItem) {
        this.$store.dispatch({
          type: 'fncSetQuoteDetails',
          quoteId: quoteItem.id,
          quote: quoteItem
        });
        /*var modalDetails = { title: 'Quote Details - ' + quoteItem.quote_no, component: 'modal-quote-details', mstate: true, params: {} };
        this.$store.commit({
          type: 'setModal',
          details: modalDetails
        });*/
        //this.$store.dispatch('fncViewAppQuote', quoteItem);
      },
      fncOpenQuote(quoteItem) {
        this.$store.dispatch('fncViewAppQuote', quoteItem);
      },
      fncGenerateReport() {
        this.$store.commit('fncEmptyQuoteList');
        if (this.objRegion != undefined && this.objRegion[0] == 'null') { this.objRegion.shift() }
        if (this.objStatus != undefined && this.objStatus[0] == 'null') { this.objStatus.shift() }
        if (this.objOriginator != undefined && this.objOriginator[0] == 'null') { this.objOriginator.shift() }
        if (this.objCustomerUser != undefined && this.objCustomerUser[0] == 'null') { this.objCustomerUser.shift() }
        if (this.objProject != undefined && this.objProject[0] == 'null') { this.objProject.shift() }
        if (this.objCustomerCompany != undefined && this.objCustomerCompany[0] == 'null') { this.objCustomerCompany.shift() }
        if (this.objSpecifier != undefined && this.objSpecifier[0] == 'null') { this.objSpecifier.shift() }
        this.$store.dispatch({
          type: 'fncPopulateQuoteList',
          reload: true,
          date_from: this.startDate == '' || this.startDate == undefined ? 'null' : this.startDate,
          date_to: this.endDate == '' || this.endDate == undefined ? 'null' : this.endDate,
          region: this.objCustomerRegion == '' || this.objCustomerRegion[0] == 'null' ? 'null' : this.objCustomerRegion,
          status: this.objStatus == '' || this.objStatus[0] == 'null' ? 'null' || this.objStatus[0] == 'null' : this.objStatus,
          originator: this.objOriginator == '' || this.objOriginator[0] == 'null' || this.objOriginator[0] == 'null' ? 'null' : this.objOriginator,
          customer: this.objCustomerUser == '' || this.objCustomerUser[0] == 'null' || this.objCustomerUser[0] == 'null' ? 'null' : this.objCustomerUser,
          project: this.objProject == '' || this.objProject[0] == 'null' || this.objProject[0] == 'null' ? 'null' : this.objProject,
          company: this.objCustomerCompany == '' || this.objCustomerCompany[0] == 'null' || this.objCustomerCompany[0] == 'null' ? 'null' : this.objCustomerCompany,
          specifier: this.objSpecifier == '' || this.objSpecifier[0] == 'null' || this.objSpecifier[0] == 'null' ? 'null' : this.objSpecifier,
          filter: true
        })
      },
      fncGenerateReportSelectedTab(tab) {
        var quote_age = '';
        var current_quote_age = localStorage.getItem("quote_start_date");
        if( current_quote_age && current_quote_age != '' ) {
          quote_age = current_quote_age;
        }

        if( quote_age == undefined || quote_age == '' ) {
          quote_age = new Date(new Date().setDate(dToday.getDate() - 30));
          quote_age = quote_age.toISOString().split('T')[0];
        }

        var quote_age_end = '';
        var current_quote_age_end = localStorage.getItem("quote_end_date");
        if( current_quote_age_end && current_quote_age_end != '' ) {
          quote_age_end = current_quote_age_end;
        }

        var page_start = 0;
        var page_end = 10000000;
        this.$router.push({path: '/reports/quote-reports', query: {p: 1}});

        this.$store.commit('fncEmptyQuoteList');
        if (this.objRegion != undefined && this.objRegion[0] == 'null') { this.objRegion.shift() }
        if (this.objStatus != undefined && this.objStatus[0] == 'null') { this.objStatus.shift() }
        if (this.objOriginator != undefined && this.objOriginator[0] == 'null') { this.objOriginator.shift() }
        if (this.objCustomerUser != undefined && this.objCustomerUser[0] == 'null') { this.objCustomerUser.shift() }
        if (this.objProject != undefined && this.objProject[0] == 'null') { this.objProject.shift() }
        if (this.objCustomerCompany != undefined && this.objCustomerCompany[0] == 'null') { this.objCustomerCompany.shift() }
        if (this.objSpecifier != undefined && this.objSpecifier[0] == 'null') { this.objSpecifier.shift() }

        this.$store.dispatch({
          type: 'fncPopulateQuoteList',
          date_from: this.startDate == '' || this.startDate == undefined ? 'null' : this.startDate,
          date_to: this.endDate == '' || this.endDate == undefined ? 'null' : this.endDate,
          // region: this.objCustomerRegion == '' || this.objCustomerRegion[0] == 'null' ? 'null' : this.objCustomerRegion,
          status: this.objStatus == '' || this.objStatus[0] == 'null' ? 'null' || this.objStatus[0] == 'null' : this.objStatus,
          originator: this.objOriginator == '' || this.objOriginator[0] == 'null' || this.objOriginator[0] == 'null' ? 'null' : this.objOriginator,
          department: this.objDepartment == '' || this.objDepartment[0] == 'null' || this.objDepartment[0] == 'null' ? 'null' : this.objDepartment,
          vendor: this.objVendor == '' || this.objVendor[0] == 'null' || this.objVendor[0] == 'null' ? 'null' : this.objVendor,
          customer: this.objCustomerUser == '' || this.objCustomerUser[0] == 'null' || this.objCustomerUser[0] == 'null' ? 'null' : this.objCustomerUser,
          project: this.objProject == '' || this.objProject[0] == 'null' || this.objProject[0] == 'null' ? 'null' : this.objProject,
          projects: this.objProjects == '' || this.objProjects[0] == 'null' || this.objProjects[0] == 'null' ? 'null' : this.objProjects,
          // company: this.objCustomerCompany == '' || this.objCustomerCompany[0] == 'null' || this.objCustomerCompany[0] == 'null' ? 'null' : this.objCustomerCompany,
          company: this.objCompany == '' || this.objCompany[0] == 'null' || this.objCompany[0] == 'null' ? 'null' : this.objCompany,
          specifier: this.objSpecifier == '' || this.objSpecifier[0] == 'null' || this.objSpecifier[0] == 'null' ? 'null' : this.objSpecifier,
          store: this.objStore == '' || this.objStore[0] == 'null' || this.objStore[0] == 'null' ? 'null' : this.objStore,
          quoteRegion: this.objRegion == '' || this.objRegion[0] == 'null' || this.objRegion[0] == 'null' ? 'null' : this.objRegion,
          quoteRep: this.objRep == '' || this.objRep[0] == 'null' || this.objRep[0] == 'null' ? 'null' : this.objRep,
          commercial_kam: this.objKam == '' || this.objKam[0] == 'null' || this.objKam[0] == 'null' ? 'null' : this.objKam,
          quote_type: this.objQuoteType == '' || this.objQuoteType[0] == 'null' || this.objQuoteType[0] == 'null' ? 'null' : this.objQuoteType,
          service_type: this.objServiceType == '' || this.objServiceType[0] == 'null' || this.objServiceType[0] == 'null' ? 'null' : this.objServiceType,
          commercial_originator: this.objcOriginator == '' || this.objcOriginator[0] == 'null' || this.objcOriginator[0] == 'null' ? 'null' : this.objcOriginator,
          payloadRefresh: true,
          start_date: quote_age,
          end_date: quote_age_end,
          search: this.search,
          page_start: page_start,
          page_end: page_end,
          selectedTab: tab,
        })
      },
      isValidDate(dateString) {
        const date = new Date(dateString);
        return !isNaN(date.getTime());
      }
    },
    computed: {
      ...mapGetters([
        'objAuthorize',
        'quoteList',
        'quoteSearchList',
        'quoteSearchListSet',
        'spinePriceList',
        'objQuoteSettings',
        'objQuoteFilters',
        'statusList',
        'salesOrderStatusses',
        'quoteReportLoaded',
        'quotesLoaded',
        'departmentList',
        'branchList',
        'newReportFilters',
        'filterNeedsReload',
        'totalQuoteRecords',
        'vendorList',
        'manufacturerAudits',
        'repUsers',
        'surveyList',
        'surveyListQuotes',
        'quoteLinks',
        'editLoading',
        'commercialKams',
        'commercialOriginators',
        'vendorUsers',
        'initialFiltersLoaded',
        'tabs',
        'excelLoading',
        'topTabsCount',
        'totalPending',
        'selectedSearchTab',
        'tabWithQuotes',
        'surveyCalculators',
        'surveyListProcess'
      ]),
      dates(){
        let d = {};
        for (var s in this.quoteList) {
          d[this.quoteList[s].id] = this.quoteList[s].installationDate
        }
        return d;
      },
      convertedItems() {
        // Use a computed property to convert date strings to the 'YYYY-MM-DD' format
        let t = {}
        let d = {};
        for (var s in this.quoteList) {
          if (this.isValidDateFormat(this.quoteList[s].delivery_date_api)){
            const [day, month, year] = this.quoteList[s].delivery_date_api.split('/');
            const convertedDate = `${year}-${month}-${day}`;
            d[this.quoteList[s].id] = convertedDate
          }
          else if (this.quoteList[s].delivery_date_api === 'N/A'){
            d[this.quoteList[s].id] = 'N/A'
          }
          else{
            d[this.quoteList[s].id] = this.quoteList[s].delivery_date_api
          }
        }
        return d;
      },
      checGoButton()
      {
        let label = this.fncFilterLabel()
        if (label === 'Set range'){
          return false;
        }

        return true;
      }
    },
    beforeCreate() {

      /*this.$store.commit('fncSetQuoteNo', '');

      // this.$store.dispatch('fncPopulateCommercialKams', this.objAuthorize.manufacturer);
      // this.$store.dispatch('fncPopulateCommercialOriginator', this.objAuthorize.manufacturer);

      this.$store.dispatch('fncPopulateRoles');

      this.$store.dispatch('fncPopulateSurveys');

      // this.$store.dispatch('fncPopulateQuoteLinks')

      this.$store.dispatch('fncPopulateManufacturerAudits');
      this.$store.dispatch('fncPopulateVendors');*/

    },
    beforeMount() {

      if( this.objAuthorize.privileges != null && this.objAuthorize.privileges.indexOf('VIEW_QUOTES') == -1 ) {
        this.$router.push({path: '/reports/quote-reports-lite', query: {p: 1}});
      }


      this.$store.dispatch('fncGetSurveyCalculators');

      if( this.filterNeedsReload != true & this.initialFiltersLoaded == false ) {
        this.$store.commit('setInitialFiltersLoaded', true);
        this.$store.commit('fncFilterNeedsReload', true);
      }

      this.$store.dispatch('fncPopulateStatusList');

      var thePage = 1;
      if( this.$router.history.current.query.p != undefined && this.$router.history.current.query.p != 'undefined' ) {
        thePage = this.$router.history.current.query.p;
      }

      var perPage = 10;
      var page_start = ( thePage * perPage ) - ( perPage );
      var page_end = perPage;

      var quoteSetDays = localStorage.getItem("quoteSetDays");

        if( quoteSetDays != '' ) {

          var dToday = new Date();
          var quote_age_end = dToday.toISOString().split('T')[0];

          switch(quoteSetDays) {
            case '1':
              this.reportDate = '';
              var quote_age = '1900-01-01';
              break;
            case '2':
              var d = new Date();
              d.setMonth(d.getMonth() - 6);
              var quote_age = d.toISOString().split('T')[0];
              break;
            case '3':
              var quote_age = new Date(new Date().setDate(dToday.getDate() - 90));
              quote_age = quote_age.toISOString().split('T')[0];
              break;
            case '4':
              var quote_age = new Date(new Date().setDate(dToday.getDate() - 60));
              quote_age = quote_age.toISOString().split('T')[0];
              break;
            case '5':
              var quote_age = new Date(new Date().setDate(dToday.getDate() - 30));
              quote_age = quote_age.toISOString().split('T')[0];
              break;
            case '6':
              var quote_age = new Date(new Date().setDate(dToday.getDate() - 7));
              quote_age = quote_age.toISOString().split('T')[0];
              break;
          }

          if( quote_age == undefined || quote_age == '' ) {
            var quote_age = new Date(new Date().setDate(dToday.getDate() - 30));
            quote_age = quote_age.toISOString().split('T')[0];
          }

          this.reportDate = [];

          this.reportDate.push( quote_age );
          this.reportDate.push( quote_age_end );

        } else {
          var quote_age = '';
          var current_quote_age = localStorage.getItem("quote_start_date");
          if( current_quote_age && current_quote_age != '' ) {
            quote_age = current_quote_age;
          }

          if( quote_age == undefined || quote_age == '' ) {
            quote_age = new Date(new Date().setDate(dToday.getDate() - 30));
            quote_age = quote_age.toISOString().split('T')[0];
          }

          var quote_age_end = '';
          var current_quote_age_end = localStorage.getItem("quote_end_date");
          if( current_quote_age_end && current_quote_age_end != '' ) {
            quote_age_end = current_quote_age_end;
          }
        }

        // if(!this.secondTab || this.secondTab === ' ')
        //   localStorage.removeItem('secondTab')

      if( this.$router.history.current.query.quoteNo != undefined && this.$router.history.current.query.quoteNo != 'undefined' ) {

        this.searchQuoteReport = this.$router.history.current.query.quoteNo;

        this.$store.dispatch({
          type: 'fncPopulateQuoteList',
          date_from: this.startDate == '' || this.startDate == undefined ? 'null' : this.startDate,
          date_to: this.endDate == '' || this.endDate == undefined ? 'null' : this.endDate,
          // region: this.objCustomerRegion == '' || this.objCustomerRegion[0] == 'null' ? 'null' : this.objCustomerRegion,
          status: this.objStatus == '' || this.objStatus[0] == 'null' ? 'null' || this.objStatus[0] == 'null' : this.objStatus,
          originator: this.objOriginator == '' || this.objOriginator[0] == 'null' || this.objOriginator[0] == 'null' ? 'null' : this.objOriginator,
          department: this.objDepartment == '' || this.objDepartment[0] == 'null' || this.objDepartment[0] == 'null' ? 'null' : this.objDepartment,
          vendor: this.objVendor == '' || this.objVendor[0] == 'null' || this.objVendor[0] == 'null' ? 'null' : this.objVendor,
          customer: this.objCustomerUser == '' || this.objCustomerUser[0] == 'null' || this.objCustomerUser[0] == 'null' ? 'null' : this.objCustomerUser,
          project: this.objProject == '' || this.objProject[0] == 'null' || this.objProject[0] == 'null' ? 'null' : this.objProject,
          company: this.objCompany == '' || this.objCompany[0] == 'null' || this.objCompany[0] == 'null' ? 'null' : this.objCompany,
          projects: this.objProjects == '' || this.objProjects[0] == 'null' || this.objProjects[0] == 'null' ? 'null' : this.objProjects,
          // company: this.objCustomerCompany == '' || this.objCustomerCompany[0] == 'null' || this.objCustomerCompany[0] == 'null' ? 'null' : this.objCustomerCompany,
          specifier: this.objSpecifier == '' || this.objSpecifier[0] == 'null' || this.objSpecifier[0] == 'null' ? 'null' : this.objSpecifier,
          store: this.objStore == '' || this.objStore[0] == 'null' || this.objStore[0] == 'null' ? 'null' : this.objStore,
          quoteRegion: this.objRegion == '' || this.objRegion[0] == 'null' || this.objRegion[0] == 'null' ? 'null' : this.objRegion,
          quoteRep: this.objRep == '' || this.objRep[0] == 'null' || this.objRep[0] == 'null' ? 'null' : this.objRep,
          commercial_kam: this.objKam == '' || this.objKam[0] == 'null' || this.objKam[0] == 'null' ? 'null' : this.objKam,
          quote_type: this.objQuoteType == '' || this.objQuoteType[0] == 'null' || this.objQuoteType[0] == 'null' ? 'null' : this.objQuoteType,
          service_type: this.objServiceType == '' || this.objServiceType[0] == 'null' || this.objServiceType[0] == 'null' ? 'null' : this.objServiceType,
          commercial_originator: this.objcOriginator == '' || this.objcOriginator[0] == 'null' || this.objcOriginator[0] == 'null' ? 'null' : this.objcOriginator,
          payloadRefresh: true,
          start_date: quote_age,
          end_date: quote_age_end,
          search: '',
          page_start: page_start,
          page_end: page_end,
          linked: this.$router.history.current.query.linked != undefined ? this.$router.history.current.query.linked : '',
          quote_report_search: this.searchQuoteReport,
          selectedTab: this.selectedStatus,
        })

      } else {
        this.$store.dispatch({
          type: 'fncPopulateQuoteList',
          date_from: this.startDate == '' || this.startDate == undefined ? 'null' : this.startDate,
          date_to: this.endDate == '' || this.endDate == undefined ? 'null' : this.endDate,
          // region: this.objCustomerRegion == '' || this.objCustomerRegion[0] == 'null' ? 'null' : this.objCustomerRegion,
          status: this.objStatus == '' || this.objStatus[0] == 'null' ? 'null' || this.objStatus[0] == 'null' : this.objStatus,
          originator: this.objOriginator == '' || this.objOriginator[0] == 'null' || this.objOriginator[0] == 'null' ? 'null' : this.objOriginator,
          department: this.objDepartment == '' || this.objDepartment[0] == 'null' || this.objDepartment[0] == 'null' ? 'null' : this.objDepartment,
          vendor: this.objVendor == '' || this.objVendor[0] == 'null' || this.objVendor[0] == 'null' ? 'null' : this.objVendor,
          customer: this.objCustomerUser == '' || this.objCustomerUser[0] == 'null' || this.objCustomerUser[0] == 'null' ? 'null' : this.objCustomerUser,
          project: this.objProject == '' || this.objProject[0] == 'null' || this.objProject[0] == 'null' ? 'null' : this.objProject,
          projects: this.objProjects == '' || this.objProjects[0] == 'null' || this.objProjects[0] == 'null' ? 'null' : this.objProjects,
          // company: this.objCustomerCompany == '' || this.objCustomerCompany[0] == 'null' || this.objCustomerCompany[0] == 'null' ? 'null' : this.objCustomerCompany,
          company: this.objCompany == '' || this.objCompany[0] == 'null' || this.objCompany[0] == 'null' ? 'null' : this.objCompany,
          specifier: this.objSpecifier == '' || this.objSpecifier[0] == 'null' || this.objSpecifier[0] == 'null' ? 'null' : this.objSpecifier,
          store: this.objStore == '' || this.objStore[0] == 'null' || this.objStore[0] == 'null' ? 'null' : this.objStore,
          quoteRegion: this.objRegion == '' || this.objRegion[0] == 'null' || this.objRegion[0] == 'null' ? 'null' : this.objRegion,
          quoteRep: this.objRep == '' || this.objRep[0] == 'null' || this.objRep[0] == 'null' ? 'null' : this.objRep,
          commercial_kam: this.objKam == '' || this.objKam[0] == 'null' || this.objKam[0] == 'null' ? 'null' : this.objKam,
          quote_type: this.objQuoteType == '' || this.objQuoteType[0] == 'null' || this.objQuoteType[0] == 'null' ? 'null' : this.objQuoteType,
          service_type: this.objServiceType == '' || this.objServiceType[0] == 'null' || this.objServiceType[0] == 'null' ? 'null' : this.objServiceType,
          commercial_originator: this.objcOriginator == '' || this.objcOriginator[0] == 'null' || this.objcOriginator[0] == 'null' ? 'null' : this.objcOriginator,
          payloadRefresh: true,
          start_date: quote_age,
          end_date: quote_age_end,
          //search: this.search,
          search: '',
          page_start: page_start,
          page_end: page_end,
          linked: this.$router.history.current.query.linked != undefined ? this.$router.history.current.query.linked : '',
          quote_report_search: this.searchQuoteReport,
          selectedTab: this.selectedStatus
        })
      }

        this.headers = [];

        this.tableWidth = 100;
        this.headers.push({ text: 'Quote Details', value: 'view', width: '100px' });
        //this.headers.push({ text: 'Distribute', value: 'distribute', width: '100px' });
        if (this.objAuthorize.vendorActive == 1 && this.objAuthorize.type != '6' ) {
          this.headers.push({ text: 'Vendor', value: 'vendor', width: '350px' });
          this.tableWidth = 450;
        }
        for (var k in this.objQuoteSettings) {
          var width = '165px';
          if (this.objQuoteSettings[k].checked === true) {
            if (this.objQuoteSettings[k].label == 'Preferred follow up method' ) {
              width = '275px';
            } else if (this.objQuoteSettings[k].label == 'Customer Name' || this.objQuoteSettings[k].label == 'Originator Name') {
              width = '250px';
            } else if (this.objQuoteSettings[k].label == 'Status') {
              width = '500px';
            } else if (this.objQuoteSettings[k].label == 'Quote Date' || this.objQuoteSettings[k].label == 'Responsible Rep'  || this.objQuoteSettings[k].label == 'Process Order') {
              width = '200px';
            } else if (this.objQuoteSettings[k].label == 'Company Name' || this.objQuoteSettings[k].label == 'Quote Type') {
              width = '225px';
            } else if (this.objQuoteSettings[k].label == 'Customer Type') {
              width = '175px';
            } else if (this.objQuoteSettings[k].label == 'Store') {
              width = '175px';
            } else if (this.objQuoteSettings[k].label == 'Installation Description' || this.objQuoteSettings[k].label == 'Cancellation Reason') {
              width = '250px';
            } else if ( this.objQuoteSettings[k].label == 'Commercial KAM' || this.objQuoteSettings[k].label == 'Commercial Originator') {
              width = '250px';
            } else if (this.objQuoteSettings[k].label == 'Purchase Order Number' || this.objQuoteSettings[k].label == 'Calculator') {
              width = '250px';
            } else if( this.objQuoteSettings[k].label == 'Responsible Rep' || isNaN(this.objQuoteSettings[k].id) == false || this.objQuoteSettings[k].label == 'Customer Recipient' || this.objQuoteSettings[k].label == 'Vendor Recipient' ) {
              width = '350px';
            }

            var headerWidth = this.objQuoteSettings[k].width == 'auto' ? width : this.objQuoteSettings[k].width;
            var searchId = this.objQuoteSettings[k].id;
            var searchLabel = this.objQuoteSettings[k].label;
            if (searchId == 'total') {
              searchId = 'total_gross';
            }
            if ( searchLabel == 'Project Region' ) {
              searchLabel = 'Project Address';
            }
            if (searchLabel == 'Sub-Total' && this.objAuthorize.vendorActive == 1) {
              searchLabel = 'Total';
            }

            if( this.objAuthorize.manufacturer == '385889803' ) {
              if( this.objQuoteSettings[k].id != 'total' && this.objQuoteSettings[k].id != 'vat' ) {
                var objHeader = { text: searchLabel, value: searchId, width: headerWidth };
                this.headers.push(objHeader);
                this.tableWidth += parseInt(headerWidth);
              }
            } else {
              var objHeader = { text: searchLabel, value: searchId, width: headerWidth };
              this.headers.push(objHeader);
              this.tableWidth += parseInt(headerWidth);
            }

          }
        }

      this.topTab = localStorage.getItem('topTab')
    },
    mounted() {

      /*if( this.search != '' ) {
        console.log('Element');
        console.log( document.getElementById("quoteSearch") );
        document.getElementById("quoteSearch").value = this.search;
      }*/
      // if (this.tabs['is_new_lead']){
      //
      // }


      const myObject = JSON.parse(localStorage.getItem('reportSearchQuote'));

      if (myObject) {
        this.EnableSearch = true
      } else {
        this.EnableSearch = false
      }

      if( this.$router.history.current.query.linked != undefined ) {
        this.quotesLinked = true;
      }

      this.$store.commit('fncSetEditLoading', false);

      if( this.objAuthorize.privileges.indexOf('CAN_UPDATE_ORIGINATOR') != -1 ) {
        this.canEditOriginator = true;
      }

      this.totalPages = Math.ceil( this.totalQuoteRecords / 10 );

      if( this.$router.history.current.query.p != undefined && this.$router.history.current.query.p != 'undefined' ) {
        this.getPage = this.$router.history.current.query.p;
      } else {
        this.$router.push({path: '/reports/quote-reports', query: {p: 1}});
      }

      this.page = parseInt(this.getPage);

      this.dateFilterShow = false;
      this.vendorFilterShow = false;
      this.departmentFilterShow = false;
      this.storeFilterShow = false;
      this.originatorFilterShow = false;
      this.customerFilterShow = false;
      this.statusFilterShow = false;
      this.regionFilterShow = false;
      this.repFilterShow = false;

      this.reportDate = [];

      var start_date = localStorage.getItem("quote_start_date");
      var end_date = localStorage.getItem("quote_end_date");

      if( start_date == '1900-01-01' ) {
        this.reportDate[0] = '';
        this.reportDate[1] = end_date;
        this.quoteFilter = 1;
      } else {
        this.reportDate[0] = start_date;
        this.reportDate[1] = end_date;
      }

      if (
        (this.objCustomerRegion && this.objCustomerRegion.length > 0 && this.objCustomerRegion[0] != 'all') ||
        (this.objOriginator.length > 0 && this.objOriginator[0] != 'all') ||
        (this.objStatus.length > 0 && this.objStatus[0] != 'all') ||
        (this.objCustomerCompany.length > 0 && this.objCustomerCompany[0] != 'all') ||
        (this.objCustomerUser.length > 0 && this.objCustomerUser[0] != 'all') ||
        (this.objProject.length > 0 && this.objProject[0] != 'all') ||
        (this.objSpecifier.length > 0 && this.objSpecifier[0] != 'all') ||
        (this.objDepartment.length > 0 && this.objDepartment[0] != 'all') ||
        (this.objStore.length > 0 && this.objStore[0] != 'all') ||
        (this.objVendor.length > 0 && this.objVendor[0] != 'all')) {
        this.hasFilters = true;
        this.filterActive = true;
      }

      if( this.hasFilters == false && this.reportDate != '' ) {
        this.hasFiltersDateOnly = true;
      }

      var hasFiltered = false;
      var objDepartments = this.objAuthorize.department != null ? this.objAuthorize.department.split(',') : [];
      var newDepartments = [];
      for( var o in objDepartments ) {
        newDepartments.push( parseInt( objDepartments[o] ) );
      }
      if( newDepartments.length > 0 ) {
        for( var s in this.statusList ) {
          if( newDepartments.indexOf(this.statusList[s].department) != -1  ) {
            hasFiltered = true;
            this.filterStatus.push( this.statusList[s] );
          }
        }
      }

      if( hasFiltered == false ) {
        this.filterStatus = this.statusList;
      } else if( this.objAuthorize.privileges.indexOf('VIEW_ALL_DEPARTMENT_STATUS') != -1) {
        // do nothing
      } else if( this.filterStatus.length > 0 ) {

        var role = this.objAuthorize.roles[0];

        this.filterStatus = [];

        for( var s in this.statusList ) {
          if( this.statusList[s].roles != null ) {
            var statusRoles = this.statusList[s].roles.split(',');
            if( statusRoles.indexOf(role) != -1 ) {
              this.filterStatus.push( this.statusList[s]  );
            }
          }
        }

        if( this.filterStatus.length == 0 ) {
          this.filterStatus = this.statusList;
        }
      } else {
        this.filterStatus = [];
      }

      this.filterStatus = this.statusList;

      var quoteSetDays = localStorage.getItem("quoteSetDays");

      if( quoteSetDays != '' ) {

        var dToday = new Date();
        var quote_age_end = dToday.toISOString().split('T')[0];

        switch(quoteSetDays) {
          case '1':
            this.reportDate = '';
            var quote_age = '1900-01-01';
            break;
          case '2':
            var d = new Date();
            d.setMonth(d.getMonth() - 6);
            var quote_age = d.toISOString().split('T')[0];
            break;
          case '3':
            var quote_age = new Date(new Date().setDate(dToday.getDate() - 90));
            quote_age = quote_age.toISOString().split('T')[0];
            break;
          case '4':
            var quote_age = new Date(new Date().setDate(dToday.getDate() - 60));
            quote_age = quote_age.toISOString().split('T')[0];
            break;
          case '5':
            var quote_age = new Date(new Date().setDate(dToday.getDate() - 30));
            quote_age = quote_age.toISOString().split('T')[0];
            break;
          case '6':
            var quote_age = new Date(new Date().setDate(dToday.getDate() - 7));
            quote_age = quote_age.toISOString().split('T')[0];
            break;
        }

        this.reportDate = [];

        if( quote_age != '1900-01-01' ) {
          this.reportDate.push( quote_age );
          this.reportDate.push( quote_age_end );
        }

      }

      for( var s in this.statusList ) {
        if( this.statusList[s].is_checked == 'Yes' ) {
          this.checkoutStatus = this.statusList[s].order;
        }
      }

      var mainThis = this;
      setTimeout(function(){
        // vendorUserList
        for( var v in mainThis.vendorUsers ) {
          if( mainThis.vendorUsers[s].vendorName != 'undefined' && mainThis.vendorUsers[s].vendorName && mainThis.vendorUsers[s].vendorName != null ) {
            if( mainThis.vendorUserList[mainThis.vendorUsers[s].vendorName] == null ) {
              mainThis.vendorUserList[mainThis.vendorUsers[s].vendorName] = [];
            }
          }
        }
      }, 2000)

     // this.$store.dispatch('fncPopulateSalesOrders', false);

    },
    watch: {
      isStatusSortOn(){
        if (this.isStatusSortOn) {
          let i = document.getElementById("icon_date");
          if (i != null)
            i.remove()
        }
      },
      isDateSortOn(){
        if (this.isDateSortOn) {
          let i = document.getElementById("icon_status");
          if (i != null)
            i.remove()
        }
      },
      tabWithQuotes(){
        if (this.tabWithQuotes){
          let key
          switch (this.tabWithQuotes) {
            case 'is_initial_engagement_quote' :
              key = '0'
              break
            case 'is_negotiating_customer_approval' :
              key = '1'
              break
            case 'is_manufacturer_fulfilment' :
              key = '2'
              break
            case 'is_cancelled_expired_rejected' :
              key = '3'
              break
          }
          this.topTab = key
        }
      },
      selectedSearchTab(){
        if (this.selectedSearchTab){
          let key
          let index
          for( let k in this.tabs) {
            for( let t in this.tabs[k]) {
              if (this.tabs[k][t].description === this.selectedSearchTab){
                index = k
                break
              }
            }
          }
          switch (index) {
            case 'is_initial_engagement_quote' :
              key = '0'
              break
            case 'is_negotiating_customer_approval' :
              key = '1'
              break
            case 'is_manufacturer_fulfilment' :
              key = '2'
              break
            case 'is_cancelled_expired_rejected' :
              key = '3'
              break
          }
          // find child
          let count = 0
          let foundKey = null
          let keyFound = false
          for( let t in this.tabs[index]) {
            if (this.tabs[index][t].description === this.selectedSearchTab){
              foundKey = count
              keyFound = true
              break
            }
            count++
          }
          if (keyFound){
            console.log('foundKey :'+ foundKey)
            this.secondTab = ""+foundKey+""
          }

          this.topTab = key
        }
      },
      quotesLoaded() {

        this.$store.commit('fncSetQuoteReportLoaded', true);

        if( this.quotesLoaded == true ) {
          this.fncShowFilterSlide( false );
        }

        if( this.departmentList.length == 0 ) {
          this.$store.dispatch('fncPopulateDepartments');
        }

        if( this.branchList.length == 0 ) {
          this.$store.dispatch('fncPopulateBranches');
        }

        this.$store.commit('fncSetQuoteNo', '');
        this.$store.dispatch('fncGetManualInstallations', this.objAuthorize.manufacturer);

        // this.$store.dispatch('fncPopulateCommercialKams', this.objAuthorize.manufacturer);
        // this.$store.dispatch('fncPopulateCommercialOriginator', this.objAuthorize.manufacturer);

        this.$store.dispatch('fncPopulateRoles');

        this.$store.dispatch('fncPopulateSurveys');

        // this.$store.dispatch('fncPopulateQuoteLinks')

        this.$store.dispatch('fncPopulateManufacturerAudits');
        this.$store.dispatch('fncPopulateVendors');

        if( this.repUsers.length == 0 ) {
          this.$store.dispatch({
            type: 'fncPopulateUsers',
            context: 0,
            parent: -1,
            notification: 0
          });
        }

        if( this.vendorUsers.length == 0 ) {
          this.$store.dispatch({
            type: 'fncPopulateUsers',
            context: 6,
            parent: -1,
            notification: 0
          });
        }
        this.$store.dispatch('fncPopulateSalesOrdersStatusList', false);
      },
      vendorUsers() {
        for( var v in this.vendorUsers ) {
          if( this.vendorUserList[this.vendorUsers[v].vendorName] == null ) {
            this.vendorUserList[this.vendorUsers[v].vendorName] = [];
          }
          this.vendorUserList[this.vendorUsers[v].vendorName].push(this.vendorUsers[v].fullname);
        }
      },
      filterStatus() {
        for( var f in this.filterStatus ) {
          this.filterStatusSet.push( this.filterStatus[f] );
        }
      },
      filterStatusSet() {
        // console.log( 'changing' );
      },
      getDashBoardStatuses(){
        if (Object.keys(this.getDashBoardStatuses).length > 0 ){
          localStorage.setItem('getDashBoardStatuses', JSON.stringify(this.getDashBoardStatuses))
        }
      },
      reportDate() {
        if( this.reportDate[0] == '' || this.reportDate[0] == undefined ) {

          var start_date = localStorage.getItem("quote_start_date");

          if( start_date != '1900-01-01' ) {
            var dToday = new Date();
            var quote_age = new Date(new Date().setDate(dToday.getDate() - 30));
            quote_age = quote_age.toISOString().split('T')[0];
            this.reportDate[0] = quote_age;
          }
        }
      },
      totalQuoteRecords() {
        this.totalPages = Math.ceil( this.totalQuoteRecords / 10 );
      },
      page() {

        if( this.$router.history.current.query.p == undefined || this.$router.history.current.query.p == 'undefined' ) {
          this.$router.push({path: '/reports/quote-reports', query: {p: 1}});
        }

        if( this.page != this.$router.history.current.query.p ) {
          this.$router.push({path: '/reports/quote-reports', query: {p: this.page}});
          this.$router.go();
        }

      },
      spinePriceList() {
        this.$store.dispatch('fncPopulateQuoteList');

      },
      quoteList() {
        if (this.quoteList == '') {
        } else {
          // this.headerLoaded = true;
          this.headers = [];
          this.tableWidth = 100;
          this.headers.push({ text: 'Quote Details', value: 'view', width: '100px' });
          //this.headers.push({ text: 'Distribute', value: 'distribute', width: '100px' });
          if (this.objAuthorize.vendorActive == 1 && this.objAuthorize.type != '6') {
            this.headers.push({ text: 'Vendor', value: 'vendor', width: '350px' });
            this.tableWidth = 450;
          }
          for (var k in this.objQuoteSettings) {
            var width = '165px';
            if (this.objQuoteSettings[k].checked === true) {
              if (this.objQuoteSettings[k].label == 'Preferred follow up method') {
                width = '275px';
              } else if (this.objQuoteSettings[k].label == 'Customer Email' || this.objQuoteSettings[k].label == 'Customer Name' || this.objQuoteSettings[k].label == 'Originator Name') {
                width = '250px';
              } else if (this.objQuoteSettings[k].label == 'Status') {
                width = '500px';
              } else if (this.objQuoteSettings[k].label == 'Quote Date' || this.objQuoteSettings[k].label == 'Process Order') {
                width = '200px';
              } else if (this.objQuoteSettings[k].label == 'Company Name' || this.objQuoteSettings[k].label == 'Quote Type') {
                width = '225px';
              } else if (this.objQuoteSettings[k].label == 'Customer Type') {
                width = '175px';
              } else if (this.objQuoteSettings[k].label == 'Store') {
                width = '175px';
              } else if (this.objQuoteSettings[k].label == 'Commercial KAM' || this.objQuoteSettings[k].label == 'Commercial Originator') {
                width = '250px';
              } else if (this.objQuoteSettings[k].label == 'Installation Description' || this.objQuoteSettings[k].label == 'Cancellation Reason') {
                width = '250px';
              } else if (this.objQuoteSettings[k].label == 'Purchase Order Number' || this.objQuoteSettings[k].label == 'Calculator') {
                width = '250px';
              } else if( this.objQuoteSettings[k].label == 'Responsible Rep' || isNaN(this.objQuoteSettings[k].id) == false || this.objQuoteSettings[k].label == 'Customer Recipient' || this.objQuoteSettings[k].label == 'Vendor Recipient' ) {
                width = '350px';
              }

              var headerWidth = this.objQuoteSettings[k].width == 'auto' ? width : this.objQuoteSettings[k].width;
              var searchId = this.objQuoteSettings[k].id;
              var searchLabel = this.objQuoteSettings[k].label;
              if (searchId == 'total') {
                searchId = 'total_gross';
              }
              if (searchLabel == 'Project Region') {
                searchLabel = 'Project Address';
              }
              if (searchLabel == 'Sub-Total' && this.objAuthorize.vendorActive == 1) {
                searchLabel = 'Total';
              }

              if( this.objAuthorize.manufacturer == '385889803' ) {
                if( this.objQuoteSettings[k].id != 'total' && this.objQuoteSettings[k].id != 'vat' ) {
                  var objHeader = { text: searchLabel, value: searchId, width: headerWidth };
                  this.headers.push(objHeader);
                  this.tableWidth += parseInt(headerWidth);
                }
              } else {
                var objHeader = { text: searchLabel, value: searchId, width: headerWidth };
                this.headers.push(objHeader);
                this.tableWidth += parseInt(headerWidth);
              }

            }
          }
        }

        var allowedStatus = [];
        var hasFiltered = false;
        var loggedInrole = this.objAuthorize.roles[0];

        var objDepartments = this.objAuthorize.department != null ? this.objAuthorize.department.split(',') : [];
        var newDepartments = [];
        for( var o in objDepartments ) {
          newDepartments.push( parseInt( objDepartments[o] ) );
        }
        if( newDepartments.length > 0 ) {
          for( var s in this.statusList ) {
            if( newDepartments.indexOf(this.statusList[s].department) != -1  ) {
              hasFiltered = true;
              this.filterStatus.push( this.statusList[s] );
            }
          }
        }

        if( hasFiltered == false ) {
          this.filterStatus = this.statusList;
        } else if( this.objAuthorize.privileges.indexOf('VIEW_ALL_DEPARTMENT_STATUS') != -1) {
          // do nothing
        } else if( this.filterStatus.length > 0 ) {

          var role = this.objAuthorize.roles[0];

          this.filterStatus = [];

          for( var s in this.statusList ) {
            if( this.statusList[s].roles != null ) {
              var statusRoles = this.statusList[s].roles.split(',');
              if( statusRoles.indexOf(role) != -1 ) {
                this.filterStatus.push( this.statusList[s]  );
              }
            }
          }

          if( this.filterStatus.length == 0 ) {
            this.filterStatus = this.statusList;
          }
        } else {
          this.filterStatus = [];
        }

        this.filterStatus = this.statusList;

      },
      quoteSearchList() {
        // this.$store.commit('fncFilterNeedsReload', true);
      },
      newReportFilters() {

      },
      quoteLinks() {

        var addedQuoteIds = [];
        var addedQuotes = [];

        for( var q in this.quoteSearchList ) {
            if( ( this.quoteLinks.indexOf(parseInt(this.quoteSearchList[q].id)) != -1 ) && addedQuoteIds.indexOf(parseInt(this.quoteSearchList[q].id)) == -1 ) {
              addedQuoteIds.push( this.quoteSearchList[q].id );
              addedQuotes.push( this.quoteSearchList[q] );
            }
        }

        this.quotesLinked = true;
        this.$store.commit('fncSetQuoteListOutright', addedQuotes);

      },
      topTab(){
        this.previousTab = localStorage.getItem('topTab');
        localStorage.setItem('topTab', this.topTab);
      },
      secondTab(){
        localStorage.setItem('secondTab', this.secondTab);
      },
      tabs(){
        localStorage.setItem('tabs', JSON.stringify(this.tabs))
      },
      statusList() {
        for( var s in this.statusList ) {
          if( this.statusList[s].is_checked == 'Yes' ) {
            this.checkoutStatus = this.statusList[s].order;
          }
        }
      }
},
    destroyed() {
      console.log("destroyed");

    },

    updated() {
      let elementsArray = document.querySelectorAll('.tabs__container.tabs__container--overflow');
      if (elementsArray.length !== 0){
        elementsArray[0].classList.remove('tabs__container--overflow')
      }
    },
    updated() {
      const tableHeader = document.querySelector('[data-ref="quote_date"]');
      if (tableHeader != null){

        tableHeader.addEventListener('click', this.sortBy);
        tableHeader.style.cursor = 'pointer'

        let span = tableHeader.querySelector("span")
        let div = span.querySelector("div")

        if (this.isDateSortOn){
          let i  = document.getElementById("icon_date");
          if (i != null)
            i.remove()

          const icon = document.createElement('i');
          icon.setAttribute("id", "icon_date");
          icon.innerHTML = (this.sortOrders.quote_date == -1) ?  "Newest quote date" : "Oldest Quote date";
          icon.style.color = 'white !important'
          div.appendChild(icon)
        }

        if (document.getElementById("icon_date_sorting") == null){
          const t = document.createElement('i');
          t.setAttribute("id", "icon_date_sorting");
          t.innerHTML = "<i class=\"material-icons sortIcon\">sort</i>";
          // icon.style.color = 'white !important'
          div.appendChild(t)
        }

      }
      const status = document.querySelector('[data-ref="status"]');
      if (status != null){
        status.addEventListener('click', this.sortByStatus);
        status.style.cursor = 'pointer'
        let span = status.querySelector("span")
        let div = span.querySelector("div")
        let span2 = div.querySelector("span")


        //<v-icon small>arrow_upward</v-icon>
        if (this.isStatusSortOn){
          let i  = document.getElementById("icon_status")
          if (i != null)
            i.remove()


          const icon = document.createElement('i');
          icon.setAttribute("id", "icon_status");
          icon.innerHTML = (this.sortStatus == -1) ?  "Latest status change" : "Oldest status change";
          icon.style.color = 'white !important'
          div.appendChild(icon)
        }

        if (document.getElementById("icon_status_sorting") == null){
          const t = document.createElement('i');
          t.setAttribute("id", "icon_status_sorting");
          t.innerHTML = "<i class=\"material-icons sortIcon\">sort</i>";
          // icon.style.color = 'white !important'
          div.appendChild(t)
        }

      }
    },
    created() {
    var vm = this;

    window.addEventListener('keyup', function (event) {
      if( window.location.href.indexOf('login') != -1 ) {
        if (event.keyCode === 13 && vm.$refs.searchField.isFocused == true) {


        }
      }
    })

},
components: {
DatePicker
}
}
</script>

<style scoped>
  @import '../../shared/assets/css/shared.css';

  /*tbody {*/
  /*  overflow-y: scroll !important;*/
  /*  ::-webkit-scrollbar: width: 5px !important;*/
  /*}*/
  ul.pagination {
    /* float: right; */
    /* margin-bottom: 5px; */
    float: inherit !important;
    margin-top: 5px !important;
  }
  #quoteReportTable{
    margin-top: unset !important;
  }
  div.tabs__items {
    width: 80% !important;
  }
  .ninePixel{
    margin-top: -9px !important;
  }
  .fivePixel{
    margin-top: -5px !important;
  }
</style>
